import { HenryBMRData } from './shared.interfaces';
import iconMail from '../assets/icons/mailIcon.svg';
import iconPhone from '../assets/icons/phoneIcon.svg';
import iconHospital from '../assets/icons/hospitalIcon.svg';
import iconNutriionalReq from '../assets/icons/nutritionReqTileIcon.svg';
import iconMalnutritionReq from '../assets/icons/malnutriScreenTileIcon.svg';
import iconMuscleScreen from '../assets/icons/muscleScreenTileIcon.svg';
import iconProductComp from '../assets/icons/compareFluidIcon.svg';
import iconProductSample from '../assets/icons/productSampleTileIcon.svg';
import iconNutriionalReqHover from '../assets/icons/nutritionReqTileIconHover.svg';
import iconMalnutritionReqHover from '../assets/icons/malnutriScreenTileIconHover.svg';
import iconMuscleScreenHover from '../assets/icons/muscleScreenTileIconHover.svg';
import iconProductCompHover from '../assets/icons/compareFluidIcon_Light.svg';
import iconProductSampleHover from '../assets/icons/productSampleTileIconHover.svg';
import iconHome from '../assets/icons/homeIcon.svg';
import iconContact from '../assets/icons/contactIcon_Blue.svg';

export const months = [
  { label: 'January', value: 1 },
  { label: 'February', value: 2 },
  { label: 'March', value: 3 },
  { label: 'April', value: 4 },
  { label: 'May', value: 5 },
  { label: 'June', value: 6 },
  { label: 'July', value: 7 },
  { label: 'August', value: 8 },
  { label: 'September', value: 9 },
  { label: 'October', value: 10 },
  { label: 'November', value: 11 },
  { label: 'December', value: 12 }
];

export const diseaseState = [
  { label: 'Burns 10% of BSA', value: 1, range: '1 - 12' },
  { label: 'Single fracture (1st week)', value: 2, range: '1 - 12' },
  { label: 'Post - operative (1st 4 days)', value: 3, range: '1 - 12' },
  {
    label: 'Inflammatory bowel disease ',
    value: 4,
    range: '1 - 12'
  },
  { label: 'Mild infection', value: 5, range: '1 - 12' },
  {
    label: 'Infection (persistent fever 1°C)',
    value: 6,
    range: '12'
  },
  {
    label: 'Burns 10-25% of BSA (1st month)',
    value: 7,
    range: '9 - 28'
  },
  {
    label: 'Multiple long bone fractures (1st week) ',
    value: 8,
    range: '9 - 28'
  },
  {
    label: 'Infection (persistent fever 2°C)',
    value: 9,
    range: '25'
  },
  {
    label: 'Severe sepsis/multiple trauma (patient on respirator)',
    value: 10,
    range: '20 - 48'
  },
  {
    label: 'Burn 25-90% BSA (1st month) ',
    value: 11,
    range: '22 - 66'
  },
  {
    label: 'Partial starvation (weight loss >10% body weight) ',
    value: 12,
    range: '-18 - 0'
  },
  {
    label: 'Other',
    value: 13,
    range: '0 - 100'
  }
];

export const henryBmrData: { male: HenryBMRData[]; female: HenryBMRData[] } = {
  male: [
    { range: '18-30', calculation: { slope: 16.0, intercept: 545 } },
    { range: '30-60', calculation: { slope: 14.2, intercept: 593 } },
    { range: '60-70', calculation: { slope: 13.0, intercept: 567 } },
    { range: '70+', calculation: { slope: 13.7, intercept: 481 } }
  ],
  female: [
    { range: '18-30', calculation: { slope: 13.1, intercept: 558 } },
    { range: '30-60', calculation: { slope: 9.74, intercept: 694 } },
    { range: '60-70', calculation: { slope: 10.2, intercept: 572 } },
    { range: '70+', calculation: { slope: 10.0, intercept: 577 } }
  ]
};

// PENG diseases
const cancerPancreas = 'Cancer - Pancreas';
const polymorbidAcutelyIllHospitalised =
  'Polymorbid - Acutely ill hospitalised';
const polymorbidMixedInAndOutpatients = 'Polymorbid - Mixed in and outpatients';
const respiratoryCopdOutpatients = 'Respiratory - COPD outpatients';

export const peng2018DiseaseData = {
  // 1) BMI < 18.5 and age < 65
  underWeightBelow65: [
    {
      label: 'Gastro-intestinal - Crohns Disease',
      calcValues: [28],
      id: 'crohnsDisease'
    },
    { label: 'Cancer - Oesophagus', calcValues: [29], id: 'cancerOesophagus' },
    { label: cancerPancreas, calcValues: [25], id: 'cancerPancreas' },
    {
      label: 'Cancer - Various cancers (weight losing or cachectic)',
      calcValues: [24],
      id: 'cancerVarious'
    },
    {
      label: 'Neurological - Multiple sclerosis',
      calcValues: [28],
      id: 'neurologicalMS'
    },
    {
      label: polymorbidAcutelyIllHospitalised,
      calcValues: [30],
      id: 'polymorbidAcutelyIllHospitalised'
    },
    {
      label: polymorbidMixedInAndOutpatients,
      calcValues: [29],
      id: 'polymorbidMixedInAndOutpatients'
    },
    {
      label: respiratoryCopdOutpatients,
      calcValues: [31],
      id: 'respiratoryCopdOutpatients'
    },
    { label: 'Other', calcValues: [], id: 'otherUnder65' }
  ],

  // 2) BMI < 18.5 and age > 65
  underWeightAbove65: [
    {
      label: 'Respiratory - COPD rehabilitation',
      calcValues: [27],
      id: 'respiratoryCopdRehab'
    },
    { label: 'Other', calcValues: [], id: 'otherOver65' }
  ],

  // -------------------------------------
  // 3) 18.5 <= BMI <= 30 and age < 65
  // -------------------------------------
  normalBelow65: [
    {
      id: 'chronicHeartFailure',
      label: 'Chronic Heart Failure',
      calcValues: [25]
    },
    {
      id: 'giCrohnsDisease',
      label: 'Gastro-intestinal - Crohns Disease',
      calcValues: [25]
    },
    {
      id: 'giUlcerativeColitis',
      label: 'Gastro-intestinal - Ulcerative Colitis',
      calcValues: [26]
    },
    {
      id: 'hivOutpatients',
      label: 'Human Immunodeficiecy Virus (HIV) Outpatients',
      calcValues: [27]
    },
    {
      id: 'cancerAcuteLeukamia',
      label: 'Cancer - Acute leukamia',
      calcValues: [26]
    },
    {
      id: 'cancerBoneMarrowTransplant',
      label: 'Cancer - Bone marrow transplant',
      calcValues: [24]
    },
    {
      id: 'cancerGastroIntestinal',
      label: 'Cancer - Gastro-intestinal',
      calcValues: [20]
    },
    {
      id: 'cancerHeadAndNeck',
      label: 'Cancer - Head and neck',
      calcValues: [22]
    },
    {
      id: 'cancerLiver',
      label: 'Cancer - Liver',
      calcValues: [23]
    },
    {
      id: 'cancerLung',
      label: 'Cancer - Lung',
      calcValues: [23]
    },
    {
      id: 'cancerNonHodgkinsLymphoma',
      label: "Cancer - Non-Hodgkin's lymphoma",
      calcValues: [20]
    },
    {
      id: 'cancerOesophagus',
      label: 'Cancer - Oesophagus',
      calcValues: [26]
    },
    {
      id: 'cancerPancreas', // variable in your code
      label: cancerPancreas,
      calcValues: [24]
    },
    {
      id: 'cancerVariousStableNonCachetic',
      label: 'Cancer - Various cancers (weight stable non cachetic)',
      calcValues: [23]
    },
    {
      id: 'liverAcuteHepatitis',
      label: 'Liver - Acute hepatitis',
      calcValues: [27]
    },
    {
      id: 'liverAlcoholicLiverCirrhosis',
      label: 'Liver - Alcoholic liver cirrhosis',
      calcValues: [28]
    },
    {
      id: 'liverChronicAlcoholDependency',
      label: 'Liver - Chronic alcohol dependency',
      calcValues: [27]
    },
    {
      id: 'liverChronicHepatitis',
      label: 'Liver - Chronic hepatitis',
      calcValues: [21]
    },
    {
      id: 'liverCirrhosis',
      label: 'Liver - Cirrhosis',
      calcValues: [22]
    },
    {
      id: 'liverTransplantationPreOp',
      label: 'Liver - transplantation (pre-op)',
      calcValues: [23]
    },
    {
      id: 'neurologicalAlsMnd',
      label:
        'Neurological - Amyotrophic lateral sclerosis (ALS) (Motor neurone disease)',
      calcValues: [22]
    },
    {
      id: 'neurologicalMuscularDystrophy',
      label: 'Neurological - Muscular dystrophy',
      calcValues: [24]
    },
    {
      id: 'neurologicalHeadInjuryAcute',
      label: 'Neurological - Head injury (acute spontaneously breathing)',
      calcValues: [29]
    },
    {
      id: 'neurologicalHeadInjuryRehab',
      label: 'Neurological - Head injury (rehabilitation)',
      calcValues: [24]
    },
    {
      id: 'neurologicalHaemorrhagicStroke',
      label: 'Neurological - Haemorrhagic stroke',
      calcValues: [24]
    },
    {
      id: 'neurologicalIschaemicStrokeRehab',
      label: 'Neurological - Ischaemic stroke (rehabilitation)',
      calcValues: [19]
    },
    {
      id: 'neurologicalPostPolioSyndrome',
      label: 'Neurological - Post polio syndrome',
      calcValues: [20]
    },
    {
      id: 'neurologicalSpinalCordInjuryAcute',
      label: 'Neurological - Spinal cord injury (acute)',
      calcValues: [23]
    },
    {
      id: 'neurologicalSpinalCordInjuryChronic',
      label: 'Neurological - Spinal cord injury (chronic)',
      calcValues: [25]
    },
    {
      id: 'pancreatitisAcute',
      label: 'Pancreatitis - Acute',
      calcValues: [26]
    },
    {
      id: 'pancreatitisChronic',
      label: 'Pancreatitis - Chronic',
      calcValues: [25]
    },
    {
      id: 'pancreatitisSeptic',
      label: 'Pancreatitis - Septic',
      calcValues: [26]
    },
    {
      id: 'polymorbidAcutelyIllHospitalised', // variable in your code
      label: polymorbidAcutelyIllHospitalised,
      calcValues: [25]
    },
    {
      id: 'polymorbidMixedInAndOutpatients', // variable in your code
      label: polymorbidMixedInAndOutpatients,
      calcValues: [25]
    },
    {
      id: 'polymorbidOutpatient',
      label: 'Polymorbid - Outpatient',
      calcValues: [23]
    },
    {
      id: 'renalAcuteKidneyInjury',
      label: 'Renal - Acute Kidney Injury',
      calcValues: [28]
    },
    {
      id: 'renalPreDialysis',
      label: 'Renal - Pre-dialysis',
      calcValues: [23]
    },
    {
      id: 'renalPeritonealDialysis',
      label: 'Renal - Peritoneal dialysis',
      calcValues: [23]
    },
    {
      id: 'renalHaemodialysis',
      label: 'Renal - Haemodialysis',
      calcValues: [24]
    },
    {
      id: 'respiratoryCopdRehabilitation',
      label: 'Respiratory - COPD rehabilitation',
      calcValues: [25]
    },
    {
      id: 'respiratoryCopdOutpatients', // variable in your code
      label: respiratoryCopdOutpatients,
      calcValues: [24]
    },
    {
      id: 'respiratoryInterstitialLungDisease',
      label: 'Respiratory - Interstital lung disease',
      calcValues: [27]
    },
    {
      id: 'surgeryGastrointestinal',
      label: 'Surgery - Gastro - intestinal',
      calcValues: [24]
    },
    {
      id: 'otherCysticFibrosis',
      label: 'Other - Cystic fibrosis',
      calcValues: [29]
    },
    {
      id: 'otherGraftVersusHostDisease',
      label: 'Other - Graft-versus-host-disease',
      calcValues: [22]
    },
    {
      id: 'otherInfections',
      label: 'Other - Infections',
      calcValues: [25]
    },
    {
      id: 'otherPheochromocytoma',
      label: 'Other - Pheochromocytoma',
      calcValues: [22]
    },
    {
      id: 'otherSepsis',
      label: 'Other - Sepsis',
      calcValues: [30]
    },
    {
      id: 'otherSickleCellAndThalassaemia',
      label: 'Other - Sickle cell disease and thalassaemia',
      calcValues: [27.5]
    },
    {
      id: 'otherNormalBelow65',
      label: 'Other',
      calcValues: []
    }
  ],

  // -------------------------------------
  // 4) 18.5 <= BMI <= 30 and age > 65
  // -------------------------------------
  normalAbove65: [
    {
      id: 'cancerGastroIntestinalAbove65',
      label: 'Cancer - Gastro-intestinal',
      calcValues: [21]
    },
    {
      id: 'cancerLiverAbove65',
      label: 'Cancer - Liver',
      calcValues: [22]
    },
    {
      id: 'cancerLungAbove65',
      label: 'Cancer - Lung',
      calcValues: [23]
    },
    {
      id: 'cancerPancreasAbove65', // variable in your code
      label: cancerPancreas,
      calcValues: [24]
    },
    {
      id: 'cancerVariousCachecticAbove65',
      label: 'Cancer - Various cancers (weight losing or cachectic)',
      calcValues: [23]
    },
    {
      id: 'cancerVariousStableNonCacheticAbove65',
      label: 'Cancer - Various cancers (weight stable non cachetic)',
      calcValues: [25]
    },
    {
      id: 'neurologicalAlsMndAbove65',
      label:
        'Neurological - Amyotrophic lateral sclerosis (ALS) (Motor neurone disease)',
      calcValues: [24]
    },
    {
      id: 'neurologicalDementia',
      label: 'Neurological - Dementia',
      calcValues: [20]
    },
    {
      id: 'neurologicalIschaemicStrokeAcute',
      label: 'Neurological - Ischaemic stroke (acute)',
      calcValues: [21]
    },
    {
      id: 'neurologicalIschaemicStrokeRehab65',
      label: 'Neurological - Ischaemic stroke (rehabilitation)',
      calcValues: [19]
    },
    {
      id: 'polymorbidAcutelyIllHospitalisedAbove65', // variable in your code
      label: polymorbidAcutelyIllHospitalised,
      calcValues: [20]
    },
    {
      id: 'polymorbidNursingHomeFacility',
      label: 'Polymorbid - Nursing home or long term care facility',
      calcValues: [21]
    },
    {
      id: 'polymorbidRehabilitation',
      label: 'Polymorbid - Rehabilitation',
      calcValues: [19]
    },
    {
      id: 'respiratoryCopdOutpatientsAbove65', // variable in your code
      label: respiratoryCopdOutpatients,
      calcValues: [25]
    },
    {
      id: 'surgeryFixationFracturedNeckOfFemur',
      label: 'Surgery - Fixation of fractured neck of femur',
      calcValues: [23]
    },
    {
      id: 'surgeryGeneral',
      label: 'Surgery - General',
      calcValues: [26]
    },
    {
      id: 'otherParkinsonsDisease',
      label: 'Other - Parkinsons Disease',
      calcValues: [24]
    },
    {
      id: 'otherPressureUlcers',
      label: 'Other - Pressure ulcers',
      calcValues: [24]
    },
    {
      id: 'otherSepsisAbove65',
      label: 'Other - Sepsis',
      calcValues: [26]
    },
    {
      id: 'otherNormalAbove65',
      label: 'Other',
      calcValues: []
    }
  ],

  // -------------------------------------
  // 5) BMI > 30 and age < 65
  // -------------------------------------
  overWeightBelow65: [
    {
      id: 'liverNonAlcoholicFattyLiverDisease',
      label: 'Liver - Non alchoholic fatty liver disease',
      calcValues: [18]
    },
    {
      id: 'polymorbidMixedInAndOutpatientsBelow65', // variable in your code
      label: polymorbidMixedInAndOutpatients,
      calcValues: [18.5]
    },
    {
      id: 'respiratoryCopdOutpatientsBelow65', // variable in your code
      label: respiratoryCopdOutpatients,
      calcValues: [24]
    },
    {
      id: 'surgeryGastricRestrictionPreSurgery',
      label: 'Surgery - Gastric restriction surgery - pre surgery',
      calcValues: [16]
    },
    {
      id: 'otherOverweightBelow65',
      label: 'Other',
      calcValues: []
    }
  ],

  // -------------------------------------
  // 6) BMI > 30 and age > 65
  // -------------------------------------
  overWeightAbove65: [
    {
      id: 'chronicHeartFailure',
      label: 'Chronic Heart Failure',
      calcValues: [18]
    },
    {
      id: 'otherOverweightAbove65',
      label: 'Other',
      calcValues: []
    }
  ]
};

// PENG Disease Lookup Table
export const peng2018DiseaseMap = {
  underweight_below65: peng2018DiseaseData.underWeightBelow65,
  underweight_above65: peng2018DiseaseData.underWeightAbove65,
  normal_below65: peng2018DiseaseData.normalBelow65,
  normal_above65: peng2018DiseaseData.normalAbove65,
  overweight_below65: peng2018DiseaseData.overWeightBelow65,
  overweight_above65: peng2018DiseaseData.overWeightAbove65
};

// PENG PAL Options
export const pengPalOptions = [
  {
    id: 'noActivity',
    label: 'No activity level',
    subLabel: '',
    min: 0,
    max: 0
  },
  {
    id: 'bedImmobile',
    label: 'In bed and immobile',
    subLabel: '(Acute illness or injury post-surgery)',
    min: 1.0,
    max: 1.1
  },
  {
    id: 'bedSittingOut',
    label: 'In bed and/or sitting out',
    subLabel: '(Hospital ward, care home or at home)',
    min: 1.1,
    max: 1.2
  },
  {
    id: 'limitedMobility',
    label: 'Limited mobility',
    subLabel: '(Hospital ward at home with full time care)',
    min: 1.2,
    max: 1.25
  },
  {
    id: 'sedentary',
    label: 'Sedentary',
    subLabel: '(Care home or home)',
    min: 1.25,
    max: 2.0
  }
];

export const pdfSummaryTileData = [
  {
    tileText: 'Products vs Requirements',
    toLink: '/rni'
  },
  {
    tileText: 'Compare Products',
    toLink: '/compare'
  }
];
export const contactTileData = [
  {
    imgSrc: iconMail,
    altVal: 'iconMail',
    tileText: 'Email Medical Team',
    tileSubText: 'abbott_nutrition_irl@abbott.com',
    toLink: 'mailto:abbott_nutrition_irl@abbott.com'
  },
  {
    imgSrc: iconPhone,
    altVal: 'iconPhone',
    tileText: 'Freephone Dietetic Helpline',
    tileSubText: '1800 411 411',
    toLink: 'tel:1800 411 411'
  },
  {
    imgSrc: iconHospital,
    altVal: 'iconHospital',
    tileText: 'Freephone Hospital2Home',
    tileSubText: '1800 22 11 66',
    toLink: 'tel:1800 22 11 66'
  }
];
export const tileData = [
  {
    imgSrc: iconNutriionalReq,
    imgSrcOnHover: iconNutriionalReqHover,
    altVal: 'iconNutriionalReqirements',
    tileText: 'NUTRITIONAL REQUIREMENTS',
    toLink: '/patientInformation',
    dynamicRoute: false,
    dynamicRouteLink: ''
  },
  {
    imgSrc: iconMuscleScreen,
    imgSrcOnHover: iconMuscleScreenHover,
    altVal: 'iconMuscleScreening',
    tileText: 'MUSCLE ASSESSMENT',
    toLink: '/patientInformation',
    dynamicRoute: true,
    dynamicRouteLink: '/muscle-screening'
  },
  {
    imgSrc: iconMalnutritionReq,
    imgSrcOnHover: iconMalnutritionReqHover,
    altVal: 'iconMalnutritionScreening',
    tileText: 'MALNUTRITION ASSESSMENT',
    toLink: '/patientInformation',
    dynamicRoute: true,
    dynamicRouteLink: '/malnutrition-screening'
  },
  {
    imgSrc: iconProductComp,
    imgSrcOnHover: iconProductCompHover,
    altVal: 'iconProductCompendium',
    tileText: 'PRODUCT COMPENDIUM',
    toLink: '',
    dynamicRoute: false,
    dynamicRouteLink: ''
  },
  {
    imgSrc: iconProductSample,
    imgSrcOnHover: iconProductSampleHover,
    altVal: 'iconProductSample',
    tileText: 'DIRECT TO PATIENT SAMPLE',
    toLink: '',
    dynamicRoute: false,
    dynamicRouteLink: ''
  }
];

export const controlPadData = [
  { imgSrc: iconHome, altVal: 'iconHome', toLink: '/', showIcon: true },
  {
    imgSrc: iconContact,
    altVal: 'iconContact',
    toLink: '/contact',
    showIcon: false
  }
];

export const henryOxfordSelection = {
  activityFactor: {
    immobile: {
      min: 10,
      max: 10
    },
    mobileSitting: {
      min: 15,
      max: 20
    },
    mobileWard: {
      min: 25,
      max: 25
    }
  },
  pal: {
    select: {
      male: {
        light: {
          nonActive: 1.4,
          active: 1.5,
          veryActive: 1.6
        },
        moderate: {
          nonActive: 1.6,
          active: 1.7,
          veryActive: 1.8
        },
        heavy: {
          nonActive: 1.7,
          active: 1.8,
          veryActive: 1.9
        }
      },
      female: {
        light: {
          nonActive: 1.4,
          active: 1.5,
          veryActive: 1.6
        },
        moderate: {
          nonActive: 1.5,
          active: 1.6,
          veryActive: 1.7
        },
        heavy: {
          nonActive: 1.5,
          active: 1.6,
          veryActive: 1.7
        }
      }
    },
    input: {
      value: 0
    }
  }
};

export const estimatinRequirementsTileData = [
  {
    tileText: 'PENG 2018',
    toLink: '/peng2018'
  },
  {
    tileText: 'Henry Oxford',
    toLink: '/estimating-requirements/henryOxford'
  },
  {
    tileText: 'Harris Benedict',
    toLink: '/estimating-requirements/harrisBenedict',
    disabled: false,
    subInfo1: 'To access Harris Benedict',
    subInfo2: 'please enter height.'
  },
  {
    tileText: 'Simple Caloric Equation',
    toLink: '/estimating-requirements/simpleCaloricEquation'
  },
  {
    tileText: 'PENN State',
    toLink: '/estimating-requirements/pennState'
  },
  {
    tileText: 'Modified PENN State',
    toLink: '/estimating-requirements/modifiedPennState'
  },
  {
    tileText: 'Faisy',
    toLink: '/estimating-requirements/faisyEquation'
  },
  {
    tileText: 'Mifflin-St. Jeor',
    toLink: '/estimating-requirements/mifflinStJeor',
    disabled: false,
    subInfo1: 'To access Mifflin-St. Jeor',
    subInfo2: 'please enter height.'
  }
];

export const malnutriScreenTileData = [
  {
    tileText: 'MUST',
    toLink: '/malnutrition-screening/must',
    disabled: false,
    subInfo1: 'To access MUST',
    subInfo2: 'please enter usual weight.'
  },
  {
    tileText: 'GLIM',
    toLink: '/malnutrition-screening/glim'
  },
  {
    tileText: 'MST',
    toLink: '/malnutrition-screening/mst'
  }
];

export const muscleScreenTileData = [
  {
    tileText: 'SARC-F',
    toLink: '/muscle-screening/sarc-f',
    disabled: false
  },
  {
    tileText: 'Handgrip Strength',
    toLink: '/muscle-screening/handgrip-strength'
  },
  {
    tileText: 'Calf Circumference',
    toLink: '/muscle-screening/calf-circumference'
  }
];
export const glimConstants = {
  calfCalc: {
    healthy: [
      [0, 18.49, 4],
      [18.5, 24.99, 0],
      [25, 29.99, -3],
      [30, 39.99, -7],
      [40, 10000, -12]
    ],
    nothealthy: [
      [0, 18.49, 0],
      [18.5, 24.99, 0],
      [25, 29.99, -3],
      [30, 39.99, -7],
      [40, 10000, -12]
    ],
    oedema: -2,
    malesMin: 34,
    femalesMin: 33
  }
};

const sarcfSectionCommonOptions = [
  { label: 'No difficulty', value: 'notAtAll' },
  { label: 'Some difficulty', value: 'aLittle' },
  { label: 'A lot or unable to do so', value: 'veryUnable' }
];

const sarcfSectionTwoOptions = [
  { label: 'No difficulty', value: 'notAtAll' },
  { label: 'Some difficulty', value: 'aLittle' },
  {
    label:
      'A lot of difficulty, use aids, or unable to do without personal help',
    value: 'veryUnable'
  }
];

const sarcfSectionThreeOptions = [
  { label: 'No difficulty', value: 'notAtAll' },
  { label: 'Some difficulty', value: 'aLittle' },
  {
    label: 'A lot of difficulty, use aids, or unable to do without help',
    value: 'veryUnable'
  }
];

export const sarcfConstants = {
  sectionOne: {
    id: 'power',
    title: 'Strength',
    question:
      'How much difficulty do you have lifting or carrying 10 lbs (4.5 kg)?',
    options: sarcfSectionCommonOptions
  },
  sectionTwo: {
    id: 'walking',
    title: 'Assistance Walking',
    question:
      'How much difficulty do you have walking across a room and do you use aids or need help to do this?',
    options: sarcfSectionTwoOptions
  },
  sectionThree: {
    id: 'chair',
    title: 'Rise from a chair',
    question:
      'How much difficulty do you have transferring from a chair or bed and do you use aids or need help to do this?',
    options: sarcfSectionThreeOptions
  },
  sectionFour: {
    id: 'stairs',
    title: 'Climb Stairs',
    question: 'How much difficulty do you have climbing a flight of 10 steps?',
    options: sarcfSectionCommonOptions
  },
  sectionFive: {
    id: 'fall',
    title: 'Falls',
    question: 'How many times have you fallen in the past year?',
    options: [
      { label: 'No falls', value: 'notAtAll' },
      { label: '1-3 times', value: 'oneToThreeTimes' },
      { label: '4 or more falls', value: 'fourOrMoreFalls' }
    ]
  }
};

export const efsaConstants = {
  age_groups: [
    {
      minAge: 6,
      maxAge: 11,
      ar: 1.12,
      pri: 1.31
    },
    {
      minAge: 12,
      maxAge: 17,
      ar: 0.95,
      pri: 1.14
    },
    {
      minAge: 18,
      maxAge: 23,
      ar: 0.85,
      pri: 1.03
    },
    {
      minAge: 24,
      maxAge: 35,
      ar: 0.79,
      pri: 0.97
    },
    {
      minAge: 36,
      maxAge: 47,
      ar: 0.73,
      pri: 0.9
    },
    {
      minAge: 48,
      maxAge: 59,
      ar: 0.69,
      pri: 0.86
    },
    {
      minAge: 60,
      maxAge: 71,
      ar: 0.69,
      pri: 0.85
    },
    {
      minAge: 72,
      maxAge: 83,
      ar: 0.72,
      pri: 0.89
    },
    {
      minAge: 84,
      maxAge: 95,
      ar: 0.74,
      pri: 0.91
    },
    {
      minAge: 96,
      maxAge: 107,
      ar: 0.75,
      pri: 0.92
    },
    {
      minAge: 108,
      maxAge: 119,
      ar: 0.75,
      pri: 0.92
    },
    {
      minAge: 120,
      maxAge: 131,
      ar: 0.75,
      pri: 0.91
    }
  ],
  adult_age_groups: [
    {
      minAge: 132,
      maxAge: 143,
      arMale: 0.75,
      priMale: 0.91,
      arFemale: 0.73,
      priFemale: 0.9
    },
    {
      minAge: 144,
      maxAge: 155,
      arMale: 0.74,
      priMale: 0.9,
      arFemale: 0.72,
      priFemale: 0.89
    },
    {
      minAge: 156,
      maxAge: 167,
      arMale: 0.73,
      priMale: 0.9,
      arFemale: 0.71,
      priFemale: 0.88
    },
    {
      minAge: 168,
      maxAge: 179,
      arMale: 0.72,
      priMale: 0.89,
      arFemale: 0.7,
      priFemale: 0.87
    },
    {
      minAge: 180,
      maxAge: 191,
      arMale: 0.72,
      priMale: 0.88,
      arFemale: 0.69,
      priFemale: 0.85
    },
    {
      minAge: 192,
      maxAge: 203,
      arMale: 0.71,
      priMale: 0.87,
      arFemale: 0.68,
      priFemale: 0.84
    },
    {
      minAge: 204,
      maxAge: 215,
      arMale: 0.7,
      priMale: 0.86,
      arFemale: 0.67,
      priFemale: 0.83
    }
  ]
};

export const comaConstants = {
  age_groups: [
    {
      minAge: 0,
      maxAge: 3,
      ear: 0,
      rni: 12.5
    },
    {
      minAge: 4,
      maxAge: 6,
      ear: 10.6,
      rni: 12.7
    },
    {
      minAge: 7,
      maxAge: 9,
      ear: 11,
      rni: 13.7
    },
    {
      minAge: 10,
      maxAge: 11,
      ear: 11.2,
      rni: 14.9
    },
    {
      minAge: 12,
      maxAge: 47,
      ear: 11.7,
      rni: 14.5
    },
    {
      minAge: 48,
      maxAge: 83,
      ear: 14.8,
      rni: 19.7
    },
    {
      minAge: 84,
      maxAge: 131,
      ear: 22.8,
      rni: 28.3
    }
  ],
  adult_age_groups: [
    {
      minAge: 132,
      maxAge: 179,
      earMale: 33.8,
      rniMale: 42.1,
      earFemale: 33.1,
      rniFemale: 41.2
    },
    {
      minAge: 180,
      maxAge: 215,
      earMale: 46.1,
      rniMale: 55.2,
      earFemale: 37.1,
      rniFemale: 45.0
    }
  ]
};

export const energyConstants = {
  infant: {
    male: [
      {
        ageInMonths: 7,
        energy: 636,
        energyForAge: 77
      },
      {
        ageInMonths: 8,
        energy: 661,
        energyForAge: 77
      },
      {
        ageInMonths: 9,
        energy: 688,
        energyForAge: 77
      },
      {
        ageInMonths: 10,
        energy: 725,
        energyForAge: 79
      },
      {
        ageInMonths: 11,
        energy: 742,
        energyForAge: 79
      }
    ],
    female: [
      {
        ageInMonths: 7,
        energy: 573,
        energyForAge: 75
      },
      {
        ageInMonths: 8,
        energy: 599,
        energyForAge: 76
      },
      {
        ageInMonths: 9,
        energy: 625,
        energyForAge: 76
      },
      {
        ageInMonths: 10,
        energy: 656,
        energyForAge: 77
      },
      {
        ageInMonths: 11,
        energy: 673,
        energyForAge: 77
      }
    ]
  },
  toddler: {
    male: [
      {
        minAgeInMonths: 12,
        maxAgeInMonths: 23,
        ree: 550,
        pal_1_4: 777,
        pal_1_6: 0,
        pal_1_8: 0,
        pal_2_0: 0
      },
      {
        minAgeInMonths: 24,
        maxAgeInMonths: 35,
        ree: 727,
        pal_1_4: 1028,
        pal_1_6: 0,
        pal_1_8: 0,
        pal_2_0: 0
      },
      {
        minAgeInMonths: 36,
        maxAgeInMonths: 47,
        ree: 830,
        pal_1_4: 1174,
        pal_1_6: 0,
        pal_1_8: 0,
        pal_2_0: 0
      }
    ],
    female: [
      {
        minAgeInMonths: 12,
        maxAgeInMonths: 23,
        ree: 503,
        pal_1_4: 712,
        pal_1_6: 0,
        pal_1_8: 0,
        pal_2_0: 0
      },
      {
        minAgeInMonths: 24,
        maxAgeInMonths: 35,
        ree: 669,
        pal_1_4: 946,
        pal_1_6: 0,
        pal_1_8: 0,
        pal_2_0: 0
      },
      {
        minAgeInMonths: 36,
        maxAgeInMonths: 47,
        ree: 775,
        pal_1_4: 1096,
        pal_1_6: 0,
        pal_1_8: 0,
        pal_2_0: 0
      }
    ]
  },
  kid: {
    male: [
      {
        minAgeInMonths: 48,
        maxAgeInMonths: 59,
        ree: 888,
        pal_1_4: 1256,
        pal_1_6: 1436,
        pal_1_8: 1615,
        pal_2_0: 0
      },
      {
        minAgeInMonths: 60,
        maxAgeInMonths: 71,
        ree: 942,
        pal_1_4: 1332,
        pal_1_6: 1522,
        pal_1_8: 1712,
        pal_2_0: 0
      },
      {
        minAgeInMonths: 72,
        maxAgeInMonths: 83,
        ree: 996,
        pal_1_4: 1409,
        pal_1_6: 1610,
        pal_1_8: 1811,
        pal_2_0: 0
      },
      {
        minAgeInMonths: 84,
        maxAgeInMonths: 95,
        ree: 1059,
        pal_1_4: 1497,
        pal_1_6: 1711,
        pal_1_8: 1925,
        pal_2_0: 0
      },
      {
        minAgeInMonths: 96,
        maxAgeInMonths: 107,
        ree: 1126,
        pal_1_4: 1592,
        pal_1_6: 1819,
        pal_1_8: 2046,
        pal_2_0: 0
      },
      {
        minAgeInMonths: 108,
        maxAgeInMonths: 119,
        ree: 1191,
        pal_1_4: 1684,
        pal_1_6: 1925,
        pal_1_8: 2165,
        pal_2_0: 0
      }
    ],
    female: [
      {
        minAgeInMonths: 48,
        maxAgeInMonths: 59,
        ree: 826,
        pal_1_4: 1168,
        pal_1_6: 1335,
        pal_1_8: 1502,
        pal_2_0: 0
      },
      {
        minAgeInMonths: 60,
        maxAgeInMonths: 71,
        ree: 877,
        pal_1_4: 1239,
        pal_1_6: 1417,
        pal_1_8: 1594,
        pal_2_0: 0
      },
      {
        minAgeInMonths: 72,
        maxAgeInMonths: 83,
        ree: 928,
        pal_1_4: 1312,
        pal_1_6: 1500,
        pal_1_8: 1687,
        pal_2_0: 0
      },
      {
        minAgeInMonths: 84,
        maxAgeInMonths: 95,
        ree: 984,
        pal_1_4: 1392,
        pal_1_6: 1591,
        pal_1_8: 1790,
        pal_2_0: 0
      },
      {
        minAgeInMonths: 96,
        maxAgeInMonths: 107,
        ree: 1045,
        pal_1_4: 1477,
        pal_1_6: 1688,
        pal_1_8: 1899,
        pal_2_0: 0
      },
      {
        minAgeInMonths: 108,
        maxAgeInMonths: 119,
        ree: 1107,
        pal_1_4: 1566,
        pal_1_6: 1790,
        pal_1_8: 2013,
        pal_2_0: 0
      }
    ]
  },
  teen: {
    male: [
      {
        minAgeInMonths: 120,
        maxAgeInMonths: 131,
        ree: 1196,
        pal_1_4: 0,
        pal_1_6: 1933,
        pal_1_8: 2174,
        pal_2_0: 2416
      },
      {
        minAgeInMonths: 132,
        maxAgeInMonths: 143,
        ree: 1264,
        pal_1_4: 0,
        pal_1_6: 2043,
        pal_1_8: 2298,
        pal_2_0: 2554
      },
      {
        minAgeInMonths: 144,
        maxAgeInMonths: 155,
        ree: 1345,
        pal_1_4: 0,
        pal_1_6: 2174,
        pal_1_8: 2445,
        pal_2_0: 2717
      },
      {
        minAgeInMonths: 156,
        maxAgeInMonths: 167,
        ree: 1444,
        pal_1_4: 0,
        pal_1_6: 2333,
        pal_1_8: 2625,
        pal_2_0: 2916
      },
      {
        minAgeInMonths: 168,
        maxAgeInMonths: 179,
        ree: 1555,
        pal_1_4: 0,
        pal_1_6: 2513,
        pal_1_8: 2828,
        pal_2_0: 3142
      },
      {
        minAgeInMonths: 180,
        maxAgeInMonths: 191,
        ree: 1670,
        pal_1_4: 0,
        pal_1_6: 2699,
        pal_1_8: 3036,
        pal_2_0: 3374
      },
      {
        minAgeInMonths: 192,
        maxAgeInMonths: 203,
        ree: 1761,
        pal_1_4: 0,
        pal_1_6: 1845,
        pal_1_8: 3201,
        pal_2_0: 3556
      },
      {
        minAgeInMonths: 204,
        maxAgeInMonths: 215,
        ree: 1819,
        pal_1_4: 0,
        pal_1_6: 2940,
        pal_1_8: 3307,
        pal_2_0: 3675
      }
    ],
    female: [
      {
        minAgeInMonths: 120,
        maxAgeInMonths: 131,
        ree: 1125,
        pal_1_4: 0,
        pal_1_6: 1818,
        pal_1_8: 2046,
        pal_2_0: 2273
      },
      {
        minAgeInMonths: 132,
        maxAgeInMonths: 143,
        ree: 1181,
        pal_1_4: 0,
        pal_1_6: 1908,
        pal_1_8: 2146,
        pal_2_0: 2385
      },
      {
        minAgeInMonths: 144,
        maxAgeInMonths: 155,
        ree: 1240,
        pal_1_4: 0,
        pal_1_6: 2004,
        pal_1_8: 2255,
        pal_2_0: 2505
      },
      {
        minAgeInMonths: 156,
        maxAgeInMonths: 167,
        ree: 1299,
        pal_1_4: 0,
        pal_1_6: 2099,
        pal_1_8: 2361,
        pal_2_0: 2624
      },
      {
        minAgeInMonths: 168,
        maxAgeInMonths: 179,
        ree: 1346,
        pal_1_4: 0,
        pal_1_6: 2175,
        pal_1_8: 2447,
        pal_2_0: 2719
      },
      {
        minAgeInMonths: 180,
        maxAgeInMonths: 191,
        ree: 1379,
        pal_1_4: 0,
        pal_1_6: 2228,
        pal_1_8: 2507,
        pal_2_0: 2786
      },
      {
        minAgeInMonths: 192,
        maxAgeInMonths: 203,
        ree: 1398,
        pal_1_4: 0,
        pal_1_6: 2259,
        pal_1_8: 2542,
        pal_2_0: 2824
      },
      {
        minAgeInMonths: 204,
        maxAgeInMonths: 215,
        ree: 1409,
        pal_1_4: 0,
        pal_1_6: 2277,
        pal_1_8: 2562,
        pal_2_0: 2846
      }
    ]
  }
};

export const rniScreenTileData = [
  {
    tileText: 'Product Comparison',
    toLink: '/compare',
    disabled: false
  }
];

export const compareScreenTileData = [
  {
    tileText: 'Products vs Requirements',
    toLink: '/rni',
    disabled: false
  }
];

// The values below refer to Compare and RNI pages

export const compareProductsRniValues: any = {
  adults: {
    rniFemale19To50: {
      fibre: '25-30',
      vitaminAre: 600,
      vitaminD: '10-15',
      vitaminE: 3,
      vitaminC: 40,
      thiaminVitaminB1: 0.8,
      riboflavinVitaminB2: 1.1,
      niacin: 13,
      vitaminB6: 1.2,
      folate: 200,
      folacin: 'N/A',
      vitaminB12: 1.5,
      biotin: 10,
      panthothenicAcid: 3,
      vitaminK: '1mcg/kg/day',
      sodium: 1600,
      calcium: 700,
      phosphate: 550,
      iron: 14.8,
      magnesium: 270,
      zinc: 7,
      iodine: 140,
      potassium: 3500,
      chloride: 2500,
      copper: 1.2,
      manganese: 1.4,
      selenium: 60,
      fluoride: 'N/A',
      chromium: 25,
      molybdenum: 50,
      choline: 'N/A',
      water: 'N/A',
      osmolality: 'N/A',
      osmolarity: 'N/A',
      renalSoluteLoad: 'N/A'
    },
    rniFemale50Plus: {
      fibre: '25-30',
      vitaminAre: 600,
      vitaminD: '10-15',
      vitaminE: 3,
      vitaminC: 40,
      thiaminVitaminB1: 0.8,
      riboflavinVitaminB2: 1.1,
      niacin: 12,
      vitaminB6: 1.2,
      folate: 200,
      folacin: 'N/A',
      vitaminB12: 1.5,
      biotin: 10,
      panthothenicAcid: 3,
      vitaminK: '1mcg/kg/day',
      sodium: 1600,
      calcium: 700,
      phosphate: 550,
      iron: 8.7,
      magnesium: 270,
      zinc: 7,
      iodine: 140,
      potassium: 3500,
      chloride: 2500,
      copper: 1.2,
      manganese: 1.4,
      selenium: 60,
      fluoride: 'N/A',
      chromium: 25,
      molybdenum: 50,
      choline: 'N/A',
      water: 'N/A',
      osmolality: 'N/A',
      osmolarity: 'N/A',
      renalSoluteLoad: 'N/A'
    },
    rniMale19To50: {
      fibre: '25-30',
      vitaminAre: 700,
      vitaminD: '10-15',
      vitaminE: 4,
      vitaminC: 40,
      thiaminVitaminB1: 1.0,
      riboflavinVitaminB2: 1.3,
      niacin: 17,
      vitaminB6: 1.4,
      folate: 200,
      folacin: 'N/A',
      vitaminB12: 1.5,
      biotin: 10,
      panthothenicAcid: 3,
      vitaminK: '1mcg/kg/day',
      sodium: 1600,
      calcium: 700,
      phosphate: 550,
      iron: 8.7,
      magnesium: 300,
      zinc: 9.5,
      iodine: 140,
      potassium: 3500,
      chloride: 2500,
      copper: 1.2,
      manganese: 1.4,
      selenium: 75,
      fluoride: 'N/A',
      chromium: 25,
      molybdenum: 50,
      choline: 'N/A',
      water: 'N/A',
      osmolality: 'N/A',
      osmolarity: 'N/A',
      renalSoluteLoad: 'N/A'
    },
    rniMale50Plus: {
      fibre: '25-30',
      vitaminAre: 700,
      vitaminD: '10-15',
      vitaminE: 4,
      vitaminC: 40,
      thiaminVitaminB1: 0.9,
      riboflavinVitaminB2: 1.3,
      niacin: 16,
      vitaminB6: 1.4,
      folate: 200,
      folacin: 'N/A',
      vitaminB12: 1.5,
      biotin: 10,
      panthothenicAcid: 3,
      vitaminK: '1mcg/kg/day',
      sodium: 1600,
      calcium: 700,
      phosphate: 550,
      iron: 8.7,
      magnesium: 300,
      zinc: 9.5,
      iodine: 140,
      potassium: 3500,
      chloride: 2500,
      copper: 1.2,
      manganese: 1.4,
      selenium: 75,
      fluoride: 'N/A',
      chromium: 25,
      molybdenum: 50,
      choline: 'N/A',
      water: 'N/A',
      osmolality: 'N/A',
      osmolarity: 'N/A',
      renalSoluteLoad: 'N/A'
    }
  },
  paed: {
    fibre: {
      rniMale7to11m: 'N/A',
      rniMale1To3: '10',
      rniMale4To5: '14',
      rniMale7To10: '16',
      rniMale11To14: '19',
      rniMale15to17: '21',
      rniFemale7to11m: 'N/A',
      rniFemale1To3: '10',
      rniFemale4To5: '14',
      rniFemale7To10: '16',
      rniFemale11To14: '19',
      rniFemale15to17: '21'
    },
    vitaminAre: {
      rniMale7to11m: 250,
      rniMale1To3: 250,
      rniMale4To5: 300,
      rniMale7To10: 400,
      rniMale11To14: 600,
      rniMale15to17: 750,
      rniFemale7to11m: 250,
      rniFemale1To3: 250,
      rniFemale4To5: 300,
      rniFemale7To10: 400,
      rniFemale11To14: 600,
      rniFemale15to17: 650
    },
    vitaminD: {
      rniMale7to11m: 10,
      rniMale1To3: 15,
      rniMale4To5: 15,
      rniMale7To10: 15,
      rniMale11To14: 15,
      rniMale15to17: 15,
      rniFemale7to11m: 10,
      rniFemale1To3: 15,
      rniFemale4To5: 15,
      rniFemale7To10: 15,
      rniFemale11To14: 15,
      rniFemale15to17: 15
    },
    vitaminE: {
      rniMale7to11m: 5,
      rniMale1To3: 6,
      rniMale4To5: 9,
      rniMale7To10: 9,
      rniMale11To14: 13,
      rniMale15to17: 13,
      rniFemale7to11m: 5,
      rniFemale1To3: 6,
      rniFemale4To5: 9,
      rniFemale7To10: 9,
      rniFemale11To14: 11,
      rniFemale15to17: 11
    },
    vitaminC: {
      rniMale7to11m: 20,
      rniMale1To3: 20,
      rniMale4To5: 30,
      rniMale7To10: 45,
      rniMale11To14: 70,
      rniMale15to17: 100,
      rniFemale7to11m: 20,
      rniFemale1To3: 20,
      rniFemale4To5: 30,
      rniFemale7To10: 45,
      rniFemale11To14: 70,
      rniFemale15to17: 90
    },
    thiaminVitaminB1: {
      rniMale7to11m: 0.1,
      rniMale1To3: 0.1,
      rniMale4To5: 0.1,
      rniMale7To10: 0.1,
      rniMale11To14: 0.1,
      rniMale15to17: 0.1,
      rniFemale7to11m: 0.1,
      rniFemale1To3: 0.1,
      rniFemale4To5: 0.1,
      rniFemale7To10: 0.1,
      rniFemale11To14: 0.1,
      rniFemale15to17: 0.1
    },
    riboflavinVitaminB2: {
      rniMale7to11m: 0.4,
      rniMale1To3: 0.6,
      rniMale4To5: 0.7,
      rniMale7To10: 1,
      rniMale11To14: 1.4,
      rniMale15to17: 1.6,
      rniFemale7to11m: 0.4,
      rniFemale1To3: 0.6,
      rniFemale4To5: 0.7,
      rniFemale7To10: 1,
      rniFemale11To14: 1.4,
      rniFemale15to17: 1.6
    },
    niacin: {
      rniMale7to11m: 1.6,
      rniMale1To3: 1.6,
      rniMale4To5: 1.6,
      rniMale7To10: 1.6,
      rniMale11To14: 1.6,
      rniMale15to17: 1.6,
      rniFemale7to11m: 1.6,
      rniFemale1To3: 1.6,
      rniFemale4To5: 1.6,
      rniFemale7To10: 1.6,
      rniFemale11To14: 1.6,
      rniFemale15to17: 1.6
    },
    vitaminB6: {
      rniMale7to11m: 0.3,
      rniMale1To3: 0.6,
      rniMale4To5: 0.7,
      rniMale7To10: 1,
      rniMale11To14: 1.4,
      rniMale15to17: 1.7,
      rniFemale7to11m: 0.3,
      rniFemale1To3: 0.6,
      rniFemale4To5: 0.7,
      rniFemale7To10: 1,
      rniFemale11To14: 1.4,
      rniFemale15to17: 1.6
    },
    folate: {
      rniMale7to11m: 80,
      rniMale1To3: 120,
      rniMale4To5: 140,
      rniMale7To10: 200,
      rniMale11To14: 270,
      rniMale15to17: 330,
      rniFemale7to11m: 80,
      rniFemale1To3: 120,
      rniFemale4To5: 140,
      rniFemale7To10: 200,
      rniFemale11To14: 270,
      rniFemale15to17: 330
    },
    folacin: 'N/A',
    vitaminB12: {
      rniMale7to11m: 1.5,
      rniMale1To3: 1.5,
      rniMale4To5: 1.5,
      rniMale7To10: 2.5,
      rniMale11To14: 3.5,
      rniMale15to17: 4,
      rniFemale7to11m: 1.5,
      rniFemale1To3: 1.5,
      rniFemale4To5: 1.5,
      rniFemale7To10: 2.5,
      rniFemale11To14: 3.5,
      rniFemale15to17: 4
    },
    biotin: {
      rniMale7to11m: 6,
      rniMale1To3: 20,
      rniMale4To5: 25,
      rniMale7To10: 25,
      rniMale11To14: 35,
      rniMale15to17: 35,
      rniFemale7to11m: 6,
      rniFemale1To3: 20,
      rniFemale4To5: 25,
      rniFemale7To10: 25,
      rniFemale11To14: 35,
      rniFemale15to17: 35
    },
    panthothenicAcid: {
      rniMale7to11m: 3,
      rniMale1To3: 4,
      rniMale4To5: 4,
      rniMale7To10: 4,
      rniMale11To14: 5,
      rniMale15to17: 5,
      rniFemale7to11m: 3,
      rniFemale1To3: 4,
      rniFemale4To5: 4,
      rniFemale7To10: 4,
      rniFemale11To14: 5,
      rniFemale15to17: 5
    },
    vitaminK: {
      rniMale7to11m: 10,
      rniMale1To3: 12,
      rniMale4To5: 20,
      rniMale7To10: 30,
      rniMale11To14: 45,
      rniMale15to17: 65,
      rniFemale7to11m: 10,
      rniFemale1To3: 12,
      rniFemale4To5: 20,
      rniFemale7To10: 30,
      rniFemale11To14: 45,
      rniFemale15to17: 65
    },
    sodium: {
      rniMale7to11m: 200,
      rniMale1To3: 1100,
      rniMale4To5: 1300,
      rniMale7To10: 1700,
      rniMale11To14: 2000,
      rniMale15to17: 2000,
      rniFemale7to11m: 200,
      rniFemale1To3: 1100,
      rniFemale4To5: 1300,
      rniFemale7To10: 1700,
      rniFemale11To14: 2000,
      rniFemale15to17: 2000
    },
    calcium: {
      rniMale7to11m: 280,
      rniMale1To3: 450,
      rniMale4To5: 800,
      rniMale7To10: 800,
      rniMale11To14: 1150,
      rniMale15to17: 1150,
      rniFemale7to11m: 280,
      rniFemale1To3: 450,
      rniFemale4To5: 800,
      rniFemale7To10: 800,
      rniFemale11To14: 1150,
      rniFemale15to17: 1150
    },
    phosphate: {
      rniMale7to11m: 160,
      rniMale1To3: 250,
      rniMale4To5: 440,
      rniMale7To10: 440,
      rniMale11To14: 640,
      rniMale15to17: 640,
      rniFemale7to11m: 160,
      rniFemale1To3: 250,
      rniFemale4To5: 440,
      rniFemale7To10: 440,
      rniFemale11To14: 640,
      rniFemale15to17: 640
    },
    iron: {
      rniMale7to11m: 11,
      rniMale1To3: 7,
      rniMale4To5: 7,
      rniMale7To10: 11,
      rniMale11To14: 11,
      rniMale15to17: 11,
      rniFemale7to11m: 11,
      rniFemale1To3: 7,
      rniFemale4To5: 7,
      rniFemale7To10: 11,
      rniFemale11To14: 13,
      rniFemale15to17: 13
    },
    magnesium: {
      rniMale7to11m: 80,
      rniMale1To2: 170,
      rniMale3To9: 230,
      rniMale10To17: 300,
      rniFemale7to11m: 80,
      rniFemale1To2: 170,
      rniFemale3To9: 230,
      rniFemale10To17: 250
    },
    zinc: {
      rniMale7to11m: 2.9,
      rniMale1To3: 4.3,
      rniMale4To5: 5.5,
      rniMale7To10: 7.4,
      rniMale11To14: 10.7,
      rniMale15to17: 14.2,
      rniFemale7to11m: 2.9,
      rniFemale1To3: 4.3,
      rniFemale4To5: 5.5,
      rniFemale7To10: 7.4,
      rniFemale11To14: 10.7,
      rniFemale15to17: 11.9
    },
    iodine: {
      rniMale7to11m: 70,
      rniMale1To3: 90,
      rniMale4To5: 90,
      rniMale7To10: 90,
      rniMale11To14: 120,
      rniMale15to17: 130,
      rniFemale7to11m: 70,
      rniFemale1To3: 90,
      rniFemale4To5: 90,
      rniFemale7To10: 90,
      rniFemale11To14: 120,
      rniFemale15to17: 130
    },
    potassium: {
      rniMale7to11m: 750,
      rniMale1To3: 800,
      rniMale4To5: 1100,
      rniMale7To10: 1800,
      rniMale11To14: 2700,
      rniMale15to17: 3500,
      rniFemale7to11m: 750,
      rniFemale1To3: 800,
      rniFemale4To5: 1100,
      rniFemale7To10: 1800,
      rniFemale11To14: 2700,
      rniFemale15to17: 3500
    },
    chloride: {
      rniMale7to11m: 300,
      rniMale1To3: 1700,
      rniMale4To5: 2000,
      rniMale7To10: 2600,
      rniMale11To14: 3100,
      rniMale15to17: 3100,
      rniFemale7to11m: 300,
      rniFemale1To3: 1700,
      rniFemale4To5: 2000,
      rniFemale7To10: 2600,
      rniFemale11To14: 3100,
      rniFemale15to17: 3100
    },
    copper: {
      rniMale7to11m: 0.4,
      rniMale1To2: 0.7,
      rniMale3To9: 1,
      rniMale10To17: 1.3,
      rniFemale7to11m: 0.4,
      rniFemale1To2: 0.7,
      rniFemale3To9: 1,
      rniFemale10To17: 1.1
    },
    manganese: {
      rniMale7to11m: '0.02-0.5',
      rniMale1To3: 0.5,
      rniMale4To5: 1,
      rniMale7To10: 1.5,
      rniMale11To14: 2,
      rniMale15to17: 3,
      rniFemale7to11m: '0.02-0.5',
      rniFemale1To3: 0.5,
      rniFemale4To5: 1,
      rniFemale7To10: 1.5,
      rniFemale11To14: 2,
      rniFemale15to17: 3
    },
    selenium: {
      rniMale7to11m: 15,
      rniMale1To3: 15,
      rniMale4To5: 20,
      rniMale7To10: 35,
      rniMale11To14: 55,
      rniMale15to17: 70,
      rniFemale7to11m: 15,
      rniFemale1To3: 15,
      rniFemale4To5: 20,
      rniFemale7To10: 35,
      rniFemale11To14: 55,
      rniFemale15to17: 70
    },
    chromium: 'N/A',
    molybdenum: {
      rniMale7to11m: 10,
      rniMale1To3: 15,
      rniMale4To5: 20,
      rniMale7To10: 30,
      rniMale11To14: 45,
      rniMale15to17: 65,
      rniFemale7to11m: 10,
      rniFemale1To3: 15,
      rniFemale4To5: 20,
      rniFemale7To10: 30,
      rniFemale11To14: 45,
      rniFemale15to17: 65
    },
    choline: {
      rniMale7to11m: 160,
      rniMale1To3: 140,
      rniMale4To5: 170,
      rniMale7To10: 250,
      rniMale11To14: 340,
      rniMale15to17: 400,
      rniFemale7to11m: 160,
      rniFemale1To3: 140,
      rniFemale4To5: 170,
      rniFemale7To10: 250,
      rniFemale11To14: 340,
      rniFemale15to17: 400
    },
    fluoride: {
      rniMale7to11m: 0.4,
      rniMale1To3: 0.6,
      rniMale4To5: 1,
      rniMale7To10: 1.5,
      rniMale11To14: 2.2,
      rniMale15to17: 3.2,
      rniFemale7to11m: 0.4,
      rniFemale1To3: 0.6,
      rniFemale4To5: 0.9,
      rniFemale7To10: 1.4,
      rniFemale11To14: 2.3,
      rniFemale15to17: 2.8
    },
    water: 'N/A',
    osmolality: 'N/A',
    osmolarity: 'N/A',
    renalSoluteLoad: 'N/A'
  }
};

//  product values

export const compareProductAccordionSections: any = [
  {
    title: 'SIP FEEDS',
    products: [
      {
        id: 1,
        name: 'Ensure® Plus Advance',
        volume: '220 mL',
        volumeOffset: 220,
        typeofcategory: 'Bottle',
        macroNutrients: {
          energy: {
            kj: {
              value: 1388,
              unit: 'kJ'
            },
            kcal: {
              value: 330,
              unit: 'kcal'
            }
          },
          protein: {
            value: 20,
            unit: 'g'
          },
          carbohydrate: {
            value: 37,
            unit: 'g',
            ofWhichSugars: {
              value: 15.0,
              unit: 'g'
            }
          },
          fat: {
            value: 11,
            unit: 'g',
            ofWhichSaturates: {
              value: 0.99,
              unit: 'g'
            }
          },
          cahmb: {
            value: 1.5,
            unit: 'g'
          },
          salt: {
            value: 0.84,
            unit: 'g'
          },
          fibre: {
            value: 1.7,
            unit: 'g',
            ofWhichFos: {
              value: 1.7,
              unit: 'g'
            }
          }
        },
        vitamins: {
          vitaminAre: {
            unit: 'mcg',
            value: 264,
            ofWhichBCaroteneRE: {
              unit: 'mcg',
              value: 132
            }
          },
          vitaminD: {
            unit: 'mcg',
            value: 13
          },
          vitaminE: {
            unit: 'mg',
            value: 5.5
          },
          vitaminC: {
            unit: 'mg',
            value: 35
          },
          thiaminVitaminB1: {
            unit: 'mg',
            value: 0.57
          },
          riboflavinVitaminB2: {
            unit: 'mg',
            value: 0.7
          },
          niacin: {
            unit: 'mg',
            value: 6.6
          },
          vitaminB6: {
            unit: 'mg',
            value: 0.66
          },
          folate: {
            unit: 'mcg',
            value: 128
          },
          folacin: {
            unit: 'mcg',
            value: 77
          },
          vitaminB12: {
            title: 'Vitamin B12',
            unit: 'mcg',
            value: 1.4
          },
          biotin: {
            unit: 'mcg',
            value: 13
          },
          panthothenicAcid: {
            title: 'Pantothenic acid',
            unit: 'mg',
            value: 2.4
          },
          vitaminK: {
            title: 'Vitamin K',
            unit: 'mcg',
            value: 33
          }
        },
        minerals: {
          sodium: {
            unit: 'mg',
            value: 330
          },
          calcium: {
            unit: 'mg',
            value: 499
          },
          phosphate: {
            unit: 'mg',
            value: 260
          },
          iron: {
            unit: 'mg',
            value: 4.6
          },
          magnesium: {
            unit: 'mg',
            value: 55
          },
          zinc: {
            unit: 'mg',
            value: 3.9
          },
          iodine: {
            unit: 'mcg',
            value: 48
          },
          potassium: {
            unit: 'mg',
            value: 594
          },
          chloride: {
            unit: 'mg',
            value: 139
          },
          copper: {
            unit: 'mg',
            value: 0.54
          },
          manganese: {
            unit: 'mg',
            value: 0.99
          },
          selenium: {
            unit: 'mcg',
            value: 20
          },
          chromium: {
            unit: 'mcg',
            value: 19
          },
          molybdenum: {
            unit: 'mcg',
            value: 33
          },
          choline: {
            unit: 'mg',
            value: 154
          },
          taurine: {
            unit: 'mg',
            value: 'N/A'
          },
          lCarnitine: {
            unit: 'mg',
            value: 40
          },
          osmolality: {
            unit: 'mOsm/kg H<sub>2</sub>O',
            value: 730
          },
          osmolarity: {
            unit: 'mOsm/litre',
            value: 557
          },
          water: {
            unit: 'g/100ml',
            value: 76.5
          },
          renalSoluteLoad: {
            unit: 'mOsm/litre',
            value: 671
          }
        }
      },
      {
        id: 2,
        name: 'Glucerna® Advance 1.6kcal',
        volume: '220 mL',
        volumeOffset: 220,
        typeofcategory: 'Bottle',
        macroNutrients: {
          energy: {
            kj: {
              value: 1484,
              unit: 'kJ'
            },
            kcal: {
              value: 355,
              unit: 'kcal'
            }
          },
          protein: {
            value: 18.3,
            unit: 'g'
          },
          carbohydrate: {
            value: 28.05,
            unit: 'g',
            ofWhichSugars: {
              value: 14.74,
              unit: 'g'
            }
          },
          fat: {
            value: 18.22,
            unit: 'g',
            ofWhichSaturates: {
              value: 1.5,
              unit: 'g'
            }
          },
          cahmb: {
            value: 0.77,
            unit: 'g'
          },
          salt: {
            value: 0.77,
            unit: 'g'
          },
          fibre: {
            value: 4.2,
            unit: 'g',
            ofWhichFos: {
              value: 2.2,
              unit: 'g'
            }
          }
        },
        vitamins: {
          vitaminAre: {
            unit: 'mcg',
            value: 317,
            ofWhichBCaroteneRE: {
              unit: 'mcg',
              value: 0
            }
          },
          vitaminD: {
            unit: 'mcg',
            value: 7.0
          },
          vitaminE: {
            unit: 'mg',
            value: 6.6
          },
          vitaminC: {
            unit: 'mg',
            value: 29
          },
          thiaminVitaminB1: {
            unit: 'mg',
            value: 0.57
          },
          riboflavinVitaminB2: {
            unit: 'mg',
            value: 0.75
          },
          niacin: {
            unit: 'mg',
            value: 6.6
          },
          vitaminB6: {
            unit: 'mg',
            value: 0.86
          },
          folate: {
            unit: 'mcg',
            value: 147
          },
          folacin: {
            unit: 'mcg',
            value: 88
          },
          vitaminB12: {
            title: 'Vitamin B12',
            unit: 'mcg',
            value: 1.1
          },
          biotin: {
            unit: 'mcg',
            value: 16
          },
          panthothenicAcid: {
            title: 'Pantothenic acid',
            unit: 'mg',
            value: 2.6
          },
          vitaminK: {
            title: 'Vitamin K',
            unit: 'mcg',
            value: 26
          }
        },
        minerals: {
          sodium: {
            unit: 'mg',
            value: 308
          },
          calcium: {
            unit: 'mg',
            value: 271
          },
          phosphate: {
            unit: 'mg',
            value: 194
          },
          iron: {
            unit: 'mg',
            value: 2.6
          },
          magnesium: {
            unit: 'mg',
            value: 57
          },
          zinc: {
            unit: 'mg',
            value: 3.7
          },
          iodine: {
            unit: 'mcg',
            value: 33
          },
          potassium: {
            unit: 'mg',
            value: 363
          },
          chloride: {
            unit: 'mg',
            value: 271
          },
          copper: {
            unit: 'mg',
            value: 0.23
          },
          manganese: {
            unit: 'mg',
            value: 0.97
          },
          selenium: {
            unit: 'mcg',
            value: 21
          },
          chromium: {
            unit: 'mcg',
            value: 19
          },
          molybdenum: {
            unit: 'mcg',
            value: 35
          },
          choline: {
            unit: 'mg',
            value: 132
          },
          taurine: {
            unit: 'mg',
            value: 33
          },
          lCarnitine: {
            unit: 'mg',
            value: 26
          },
          osmolality: {
            unit: 'mOsm/kg H2O',
            value: 945
          },
          osmolarity: {
            unit: 'mOsm/litre',
            value: 704
          },
          water: {
            unit: 'g/100ml',
            value: 74.7
          },
          renalSoluteLoad: {
            unit: 'mOsm/litre',
            value: 612
          }
        }
      },
      {
        id: 3,
        name: 'Ensure® Compact',
        volume: '125 mL',
        volumeOffset: 125,
        typeofcategory: 'Bottle',
        macroNutrients: {
          energy: {
            kj: {
              value: 1261,
              unit: 'kJ'
            },
            kcal: {
              value: 300,
              unit: 'kcal'
            }
          },
          protein: {
            value: 12.8,
            unit: 'g'
          },
          carbohydrate: {
            value: 36,
            unit: 'g',
            ofWhichSugars: {
              value: 7.8,
              unit: 'g'
            }
          },
          fat: {
            value: 11.7,
            unit: 'g',
            ofWhichSaturates: {
              value: 1,
              unit: 'g'
            }
          },
          fibre: {
            value: 0,
            unit: 'g',
            ofWhichFos: {
              value: 0,
              unit: 'g'
            }
          },
          cahmb: {
            value: 'N/A',
            unit: 'g'
          },
          salt: {
            value: 0.45,
            unit: 'g'
          }
        },
        vitamins: {
          vitaminAre: {
            unit: 'mcg',
            value: 194,
            ofWhichBCaroteneRE: {
              unit: 'mcg',
              value: 0
            }
          },
          vitaminD: {
            unit: 'mcg',
            value: 3.8
          },
          vitaminE: {
            unit: 'mg',
            value: 5.9
          },
          vitaminC: {
            unit: 'mg',
            value: 26
          },
          thiaminVitaminB1: {
            unit: 'mg',
            value: 0.44
          },
          riboflavinVitaminB2: {
            unit: 'mg',
            value: 0.59
          },
          niacin: {
            unit: 'mg',
            value: 5.5
          },
          vitaminB6: {
            unit: 'mg',
            value: 0.59
          },
          folate: {
            unit: 'mcg',
            value: 102
          },
          folacin: {
            unit: 'mcg',
            value: 60
          },
          vitaminB12: {
            unit: 'mcg',
            value: 1.2
          },
          biotin: {
            unit: 'mcg',
            value: 9.4
          },
          panthothenicAcid: {
            title: 'Pantothenic acid',
            unit: 'mg',
            value: 1.9
          },
          vitaminK: {
            title: 'Vitamin K',
            unit: 'mcg',
            value: 26
          }
        },
        minerals: {
          sodium: {
            unit: 'mg',
            value: 181
          },
          calcium: {
            unit: 'mg',
            value: 213
          },
          phosphate: {
            unit: 'mg',
            value: 213
          },
          iron: {
            unit: 'mg',
            value: 4.3
          },
          magnesium: {
            unit: 'mg',
            value: 25
          },
          zinc: {
            unit: 'mg',
            value: 3.6
          },
          iodine: {
            unit: 'mcg',
            value: 48
          },
          potassium: {
            unit: 'mg',
            value: 269
          },
          chloride: {
            unit: 'mg',
            value: 181
          },
          copper: {
            unit: 'mg',
            value: 0.4
          },
          manganese: {
            unit: 'mg',
            value: 0.75
          },
          selenium: {
            unit: 'mcg',
            value: 15
          },
          chromium: {
            unit: 'mcg',
            value: 13
          },
          molybdenum: {
            unit: 'mcg',
            value: 25
          },
          choline: {
            unit: 'mg',
            value: 121
          },
          taurine: {
            unit: 'mg',
            value: 'N/A'
          },
          lCarnitine: {
            unit: 'mg',
            value: 'N/A'
          },
          osmolality: {
            unit: 'mOsm/kg H2O',
            value: 1052
          },
          osmolarity: {
            unit: 'mOsm/litre',
            value: 676
          },
          water: {
            unit: 'g/100ml',
            value: 64.3
          },
          renalSoluteLoad: {
            unit: 'mOsm/litre',
            value: 740
          }
        }
      },
      {
        id: 4,
        name: 'Ensure® Plus HP',
        volume: '200 mL',
        volumeOffset: 200,
        typeofcategory: 'Bottle',
        macroNutrients: {
          energy: {
            kj: {
              value: 1053,
              unit: 'kJ'
            },
            kcal: {
              value: 250,
              unit: 'kcal'
            }
          },
          protein: {
            value: 15.8,
            unit: 'g'
          },
          carbohydrate: {
            value: 31.8,
            unit: 'g',
            ofWhichSugars: {
              value: 19,
              unit: 'g'
            }
          },
          fat: {
            value: 6.6,
            unit: 'g',
            ofWhichSaturates: {
              value: 0.66,
              unit: 'g'
            }
          },
          cahmb: {
            value: 'N/A',
            unit: 'g'
          },
          salt: {
            value: 0.64,
            unit: 'g'
          },
          fibre: {
            value: 0,
            unit: 'g',
            ofWhichFos: {
              value: 0,
              unit: 'g'
            }
          }
        },
        vitamins: {
          vitaminAre: {
            unit: 'mcg',
            value: 210,
            ofWhichBCaroteneRE: {
              unit: 'mcg',
              value: 0
            }
          },
          vitaminD: {
            unit: 'mcg',
            value: 2.2
          },
          vitaminE: {
            unit: 'mg',
            value: 4.0
          },
          vitaminC: {
            unit: 'mg',
            value: 26
          },
          thiaminVitaminB1: {
            unit: 'mg',
            value: 0.42
          },
          riboflavinVitaminB2: {
            unit: 'mg',
            value: 0.48
          },
          niacin: {
            unit: 'mg',
            value: 5.0
          },
          vitaminB6: {
            unit: 'mg',
            value: 0.6
          },
          folate: {
            unit: 'mcg',
            value: 108.8
          },
          folacin: {
            unit: 'mcg',
            value: 64
          },
          vitaminB12: {
            title: 'Vitamin B12',
            unit: 'mcg',
            value: 0.8
          },
          biotin: {
            unit: 'mcg',
            value: 10.0
          },
          panthothenicAcid: {
            title: 'Pantothenic acid',
            unit: 'mg',
            value: 1.8
          },
          vitaminK: {
            title: 'Vitamin K',
            unit: 'mcg',
            value: 19
          }
        },
        minerals: {
          sodium: {
            unit: 'mg',
            value: 256
          },
          calcium: {
            unit: 'mg',
            value: 250
          },
          phosphate: {
            unit: 'mg',
            value: 176
          },
          iron: {
            unit: 'mg',
            value: 2.4
          },
          magnesium: {
            unit: 'mg',
            value: 50
          },
          zinc: {
            unit: 'mg',
            value: 2.2
          },
          iodine: {
            unit: 'mcg',
            value: 32
          },
          potassium: {
            unit: 'mg',
            value: 440
          },
          chloride: {
            unit: 'mg',
            value: 230
          },
          copper: {
            unit: 'mg',
            value: 0.26
          },
          manganese: {
            unit: 'mg',
            value: 0.56
          },
          selenium: {
            unit: 'mcg',
            value: 10
          },
          chromium: {
            unit: 'mcg',
            value: 10.0
          },
          molybdenum: {
            unit: 'mcg',
            value: 22
          },
          choline: {
            unit: 'mg',
            value: 84
          },
          taurine: {
            unit: 'mg',
            value: 'N/A'
          },
          lCarnitine: {
            unit: 'mg',
            value: 'N/A'
          },
          osmolality: {
            unit: 'mOsm/kg H2O',
            value: 650
          },
          osmolarity: {
            unit: 'mOsm/litre',
            value: 522
          },
          water: {
            unit: 'g/100ml',
            value: 80.7
          },
          renalSoluteLoad: {
            unit: 'mOsm/litre',
            value: 595
          }
        }
      },
      {
        id: 5,
        name: 'Ensure® TwoCal®',
        volume: '200 mL',
        volumeOffset: 200,
        typeofcategory: 'Bottle',
        macroNutrients: {
          energy: {
            kj: {
              value: 1675,
              unit: 'kJ'
            },
            kcal: {
              value: 399,
              unit: 'kcal'
            }
          },
          protein: {
            value: 16.8,
            unit: 'g'
          },
          carbohydrate: {
            value: 42.0,
            unit: 'g',
            ofWhichSugars: {
              value: 10,
              unit: 'g'
            }
          },
          fat: {
            value: 17.8,
            unit: 'g',
            ofWhichSaturates: {
              value: 2.0,
              unit: 'g'
            }
          },
          cahmb: {
            value: 'N/A',
            unit: 'g'
          },
          salt: {
            value: 0.4,
            unit: 'g'
          },
          fibre: {
            value: 2.0,
            unit: 'g',
            ofWhichFos: {
              value: 2.0,
              unit: 'g'
            }
          }
        },
        vitamins: {
          vitaminAre: {
            unit: 'mcg',
            value: 316,
            ofWhichBCaroteneRE: {
              unit: 'mcg',
              value: 0
            }
          },
          vitaminD: {
            unit: 'mcg',
            value: 3.4
          },
          vitaminE: {
            unit: 'mg',
            value: 6.8
          },
          vitaminC: {
            unit: 'mg',
            value: 40
          },
          thiaminVitaminB1: {
            unit: 'mg',
            value: 0.6
          },
          riboflavinVitaminB2: {
            unit: 'mg',
            value: 0.58
          },
          niacin: {
            unit: 'mg',
            value: 6.8
          },
          vitaminB6: {
            unit: 'mg',
            value: 0.68
          },
          folate: {
            unit: 'mcg',
            value: 163.2
          },
          folacin: {
            unit: 'mcg',
            value: 96
          },
          vitaminB12: {
            title: 'Vitamin B12',
            unit: 'mcg',
            value: 1.3
          },
          biotin: {
            unit: 'mcg',
            value: 16
          },
          panthothenicAcid: {
            title: 'Pantothenic acid',
            unit: 'mg',
            value: 3.2
          },
          vitaminK: {
            title: 'Vitamin K',
            unit: 'mcg',
            value: 17
          }
        },
        minerals: {
          sodium: {
            unit: 'mg',
            value: 160
          },
          calcium: {
            unit: 'mg',
            value: 300
          },
          phosphate: {
            unit: 'mg',
            value: 240
          },
          iron: {
            unit: 'mg',
            value: 4.2
          },
          magnesium: {
            unit: 'mg',
            value: 80
          },
          zinc: {
            unit: 'mg',
            value: 4.8
          },
          iodine: {
            unit: 'mcg',
            value: 32
          },
          potassium: {
            unit: 'mg',
            value: 350
          },
          chloride: {
            unit: 'mg',
            value: 230
          },
          copper: {
            unit: 'mg',
            value: 0.48
          },
          manganese: {
            unit: 'mg',
            value: 1.1
          },
          selenium: {
            unit: 'mcg',
            value: 18
          },
          chromium: {
            unit: 'mcg',
            value: 20
          },
          molybdenum: {
            unit: 'mcg',
            value: 32
          },
          choline: {
            unit: 'mg',
            value: 126
          },
          taurine: {
            unit: 'mg',
            value: 32
          },
          lCarnitine: {
            unit: 'mg',
            value: 32
          },
          osmolality: {
            unit: 'mOsm/kg H2O',
            value: 750
          },
          osmolarity: {
            unit: 'mOsm/litre',
            value: 527
          },
          water: {
            unit: 'g/100ml',
            value: 70.3
          },
          renalSoluteLoad: {
            unit: 'mOsm/litre',
            value: 591
          }
        }
      },
      {
        id: 6,
        name: 'Ensure® Plus',
        volume: '200 mL',
        volumeOffset: 200,
        typeofcategory: 'Bottle',
        macroNutrients: {
          energy: {
            kj: {
              value: 1263,
              unit: 'kJ'
            },
            kcal: {
              value: 300,
              unit: 'kcal'
            }
          },
          protein: {
            value: 12.5,
            unit: 'g'
          },
          carbohydrate: {
            value: 40.4,
            unit: 'g',
            ofWhichSugars: {
              value: 13,
              unit: 'g'
            }
          },
          fat: {
            value: 9.84,
            unit: 'g',
            ofWhichSaturates: {
              value: 0.9,
              unit: 'g'
            }
          },
          fibre: {
            value: 0,
            unit: 'g',
            ofWhichFos: {
              value: 0,
              unit: 'g'
            }
          },
          cahmb: {
            value: 'N/A',
            unit: 'g'
          },
          salt: {
            value: 0.46,
            unit: 'g'
          }
        },
        vitamins: {
          vitaminAre: {
            unit: 'mcg',
            value: 233,
            ofWhichBCaroteneRE: {
              unit: 'mcg',
              value: 58
            }
          },
          vitaminD: {
            unit: 'mcg',
            value: 4
          },
          vitaminE: {
            unit: 'mg',
            value: 4.3
          },
          vitaminC: {
            unit: 'mg',
            value: 24
          },
          thiaminVitaminB1: {
            unit: 'mg',
            value: 0.4
          },
          riboflavinVitaminB2: {
            unit: 'mg',
            value: 0.54
          },
          niacin: {
            unit: 'mg',
            value: 5.2
          },
          vitaminB6: {
            unit: 'mg',
            value: 0.54
          },
          folate: {
            unit: 'mcg',
            value: 136
          },
          folacin: {
            unit: 'mcg',
            value: 80
          },
          vitaminB12: {
            unit: 'mcg',
            value: 1.1
          },
          biotin: {
            unit: 'mcg',
            value: 12
          },
          panthothenicAcid: {
            title: 'Pantothenic acid',
            unit: 'mg',
            value: 2.2
          },
          vitaminK: {
            title: 'Vitamin K',
            unit: 'mcg',
            value: 24
          }
        },
        minerals: {
          sodium: {
            unit: 'mg',
            value: 184
          },
          calcium: {
            unit: 'mg',
            value: 240
          },
          phosphate: {
            unit: 'mg',
            value: 200
          },
          iron: {
            unit: 'mg',
            value: 4.2
          },
          magnesium: {
            unit: 'mg',
            value: 60
          },
          zinc: {
            unit: 'mg',
            value: 3.6
          },
          iodine: {
            unit: 'mcg',
            value: 44
          },
          potassium: {
            unit: 'mg',
            value: 320
          },
          chloride: {
            unit: 'mg',
            value: 220
          },
          copper: {
            unit: 'mg',
            value: 0.36
          },
          manganese: {
            unit: 'mg',
            value: 1.0
          },
          selenium: {
            unit: 'mcg',
            value: 17
          },
          chromium: {
            unit: 'mcg',
            value: 15
          },
          molybdenum: {
            unit: 'mcg',
            value: 32
          },
          choline: {
            unit: 'mg',
            value: 99
          },
          taurine: {
            unit: 'mg',
            value: 'N/A'
          },
          lCarnitine: {
            unit: 'mg',
            value: 'N/A'
          },
          osmolality: {
            unit: 'mOsm/kg H2O',
            value: 660
          },
          osmolarity: {
            unit: 'mOsm/litre',
            value: 509
          },
          water: {
            unit: 'g/100ml',
            value: 77.4
          },
          renalSoluteLoad: {
            unit: 'mOsm/litre',
            value: 468
          }
        }
      },
      {
        id: 7,
        name: 'Ensure® Plus Juce',
        volume: '220 mL',
        volumeOffset: 220,
        typeofcategory: 'Bottle',
        macroNutrients: {
          energy: {
            kj: {
              value: 1403,
              unit: 'kJ'
            },
            kcal: {
              value: 330,
              unit: 'kcal'
            }
          },
          protein: {
            value: 10.56,
            unit: 'g'
          },
          carbohydrate: {
            value: 71.94,
            unit: 'g',
            ofWhichSugars: {
              value: 20.68,
              unit: 'g'
            }
          },
          fat: {
            value: 0,
            unit: 'g',
            ofWhichSaturates: {
              value: 0,
              unit: 'g'
            }
          },
          cahmb: {
            value: 'N/A',
            unit: 'g'
          },
          salt: {
            value: 0.04,
            unit: 'g'
          },
          fibre: {
            value: 0,
            unit: 'g',
            ofWhichFos: {
              value: 0,
              unit: 'g'
            }
          }
        },
        vitamins: {
          vitaminAre: {
            unit: 'mcg',
            value: 308,
            ofWhichBCaroteneRE: {
              unit: 'mcg',
              value: 0
            }
          },
          vitaminD: {
            unit: 'mcg',
            value: 1.1
          },
          vitaminE: {
            unit: 'mg',
            value: 5.9
          },
          vitaminC: {
            unit: 'mg',
            value: 22
          },
          thiaminVitaminB1: {
            unit: 'mg',
            value: 0.53
          },
          riboflavinVitaminB2: {
            unit: 'mg',
            value: 0.46
          },
          niacin: {
            unit: 'mg',
            value: 6.4
          },
          vitaminB6: {
            unit: 'mg',
            value: 0.51
          },
          folate: {
            unit: 'mcg',
            value: 44.2
          },
          folacin: {
            unit: 'mcg',
            value: 26
          },
          vitaminB12: {
            title: 'Vitamin B12',
            unit: 'mcg',
            value: 0.57
          },
          biotin: {
            unit: 'mcg',
            value: 11
          },
          panthothenicAcid: {
            title: 'Pantothenic acid',
            unit: 'mg',
            value: 0.79
          },
          vitaminK: {
            title: 'Vitamin K',
            unit: 'mcg',
            value: 25
          }
        },
        minerals: {
          sodium: {
            unit: 'mg',
            value: 15
          },
          calcium: {
            unit: 'mg',
            value: 40
          },
          phosphate: {
            unit: 'mg',
            value: 22
          },
          iron: {
            unit: 'mg',
            value: 2.6
          },
          magnesium: {
            unit: 'mg',
            value: 7.7
          },
          zinc: {
            unit: 'mg',
            value: 2.0
          },
          iodine: {
            unit: 'mcg',
            value: 33
          },
          potassium: {
            unit: 'mg',
            value: 42
          },
          chloride: {
            unit: 'mg',
            value: 264
          },
          copper: {
            unit: 'mg',
            value: 0.32
          },
          manganese: {
            unit: 'mg',
            value: 0.66
          },
          selenium: {
            unit: 'mcg',
            value: 14
          },
          chromium: {
            unit: 'mcg',
            value: 11
          },
          molybdenum: {
            unit: 'mcg',
            value: 44
          },
          choline: {
            unit: 'mg',
            value: 'N/A'
          },
          taurine: {
            unit: 'mg',
            value: 'N/A'
          },
          lCarnitine: {
            unit: 'mg',
            value: 'N/A'
          },
          osmolality: {
            unit: 'mOsm/kg H2O',
            value: 945
          },
          osmolarity: {
            unit: 'mOsm/litre',
            value: 718
          },
          water: {
            unit: 'g/100ml',
            value: 76.3
          },
          renalSoluteLoad: {
            unit: 'mOsm/litre',
            value: 315
          }
        }
      },
      {
        id: 8,
        name: 'Ensure® Plus Fibre',
        volume: '200 mL',
        volumeOffset: 200,
        typeofcategory: 'Bottle',
        macroNutrients: {
          energy: {
            kj: {
              value: 1303,
              unit: 'kJ'
            },
            kcal: {
              value: 310,
              unit: 'kcal'
            }
          },
          protein: {
            value: 12.5,
            unit: 'g'
          },
          carbohydrate: {
            value: 40.4,
            unit: 'g',
            ofWhichSugars: {
              value: 9.84,
              unit: 'g'
            }
          },
          fat: {
            value: 9.84,
            unit: 'g',
            ofWhichSaturates: {
              value: 0.84,
              unit: 'g'
            }
          },
          cahmb: {
            value: 'N/A',
            unit: 'g'
          },
          salt: {
            value: 0.42,
            unit: 'g'
          },
          fibre: {
            value: 5.0,
            unit: 'g',
            ofWhichFos: {
              value: 2.5,
              unit: 'g'
            }
          }
        },
        vitamins: {
          vitaminAre: {
            unit: 'mcg',
            value: 234,
            ofWhichBCaroteneRE: {
              unit: 'mcg',
              value: 58
            }
          },
          vitaminD: {
            unit: 'mcg',
            value: 3.4
          },
          vitaminE: {
            unit: 'mg',
            value: 4.8
          },
          vitaminC: {
            unit: 'mg',
            value: 24
          },
          thiaminVitaminB1: {
            unit: 'mg',
            value: 0.4
          },
          riboflavinVitaminB2: {
            unit: 'mg',
            value: 0.54
          },
          niacin: {
            unit: 'mg',
            value: 5.2
          },
          vitaminB6: {
            unit: 'mg',
            value: 0.54
          },
          folate: {
            unit: 'mcg',
            value: 112.2
          },
          folacin: {
            unit: 'mcg',
            value: 66
          },
          vitaminB12: {
            title: 'Vitamin B12',
            unit: 'mcg',
            value: 1.3
          },
          biotin: {
            unit: 'mcg',
            value: 12
          },
          panthothenicAcid: {
            title: 'Pantothenic acid',
            unit: 'mg',
            value: 2.2
          },
          vitaminK: {
            title: 'Vitamin K',
            unit: 'mcg',
            value: 24
          }
        },
        minerals: {
          sodium: {
            unit: 'mg',
            value: 170
          },
          calcium: {
            unit: 'mg',
            value: 140
          },
          phosphate: {
            unit: 'mg',
            value: 138
          },
          iron: {
            unit: 'mg',
            value: 4.2
          },
          magnesium: {
            unit: 'mg',
            value: 60
          },
          zinc: {
            unit: 'mg',
            value: 3.2
          },
          iodine: {
            unit: 'mcg',
            value: 44
          },
          potassium: {
            unit: 'mg',
            value: 270
          },
          chloride: {
            unit: 'mg',
            value: 220
          },
          copper: {
            unit: 'mg',
            value: 0.36
          },
          manganese: {
            unit: 'mg',
            value: 1.0
          },
          selenium: {
            unit: 'mcg',
            value: 17
          },
          chromium: {
            unit: 'mcg',
            value: 15
          },
          molybdenum: {
            unit: 'mcg',
            value: 32
          },
          choline: {
            unit: 'mg',
            value: 110
          },
          taurine: {
            unit: 'mg',
            value: 'N/A'
          },
          lCarnitine: {
            unit: 'mg',
            value: 'N/A'
          },
          osmolality: {
            unit: 'mOsm/kg H2O',
            value: 730
          },
          osmolarity: {
            unit: 'mOsm/litre',
            value: 552
          },
          water: {
            unit: 'g/100ml',
            value: 75.93
          },
          renalSoluteLoad: {
            unit: 'mOsm/litre',
            value: 459
          }
        }
      },
      {
        id: 9,
        name: 'Enshake®',
        volume: '(1 sachet + 240mL whole milk)',
        volumeOffset: 310,
        typeofcategory: 'Serving',
        macroNutrients: {
          energy: {
            kj: {
              value: 2500,
              unit: 'kJ'
            },
            kcal: {
              value: 595,
              unit: 'kcal'
            }
          },
          protein: {
            value: 16.5,
            unit: 'g'
          },
          carbohydrate: {
            value: 78.4,
            unit: 'g',
            ofWhichSugars: {
              value: 22,
              unit: 'g'
            }
          },
          fat: {
            value: 24.0,
            unit: 'g',
            ofWhichSaturates: {
              value: 10,
              unit: 'g'
            }
          },
          cahmb: {
            value: 'N/A',
            unit: 'g'
          },
          salt: {
            value: 1.1,
            unit: 'g'
          },
          fibre: {
            value: 0,
            unit: 'g',
            ofWhichFos: {
              value: 0,
              unit: 'g'
            }
          }
        },
        vitamins: {
          vitaminAre: {
            unit: 'mcg',
            value: 405,
            ofWhichBCaroteneRE: {
              unit: 'mcg',
              value: 37
            }
          },
          vitaminD: {
            unit: 'mcg',
            value: 6.3
          },
          vitaminE: {
            unit: 'mg',
            value: 6.9
          },
          vitaminC: {
            unit: 'mg',
            value: 50
          },
          thiaminVitaminB1: {
            unit: 'mg',
            value: 0.07
          },
          riboflavinVitaminB2: {
            unit: 'mg',
            value: 0.58
          },
          niacin: {
            unit: 'mg',
            value: 0.48
          },
          vitaminB6: {
            unit: 'mg',
            value: 0.14
          },
          folate: {
            unit: 'mcg',
            value: 32.64
          },
          folacin: {
            unit: 'mcg',
            value: 19.2
          },
          vitaminB12: {
            title: 'Vitamin B12',
            unit: 'mcg',
            value: 2.16
          },
          biotin: {
            unit: 'mcg',
            value: 6.24
          },
          panthothenicAcid: {
            title: 'Pantothenic acid',
            unit: 'mg',
            value: 1.44
          },
          vitaminK: {
            title: 'Vitamin K',
            unit: 'mcg',
            value: 47
          }
        },
        minerals: {
          sodium: {
            unit: 'mg',
            value: 426
          },
          calcium: {
            unit: 'mg',
            value: 468
          },
          phosphate: {
            unit: 'mg',
            value: 369
          },
          iron: {
            unit: 'mg',
            value: 0.05
          },
          magnesium: {
            unit: 'mg',
            value: 114
          },
          zinc: {
            unit: 'mg',
            value: 1.2
          },
          iodine: {
            unit: 'mcg',
            value: 76.8
          },
          potassium: {
            unit: 'mg',
            value: 813
          },
          chloride: {
            unit: 'mg',
            value: 400
          },
          copper: {
            unit: 'mg',
            value: 'trace'
          },
          manganese: {
            unit: 'mg',
            value: 'trace'
          },
          selenium: {
            unit: 'mcg',
            value: 2.4
          },
          chromium: {
            unit: 'mcg',
            value: 0
          },
          molybdenum: {
            unit: 'mcg',
            value: 'N/A'
          },
          choline: {
            unit: 'mg',
            value: 'N/A'
          },
          taurine: {
            unit: 'mg',
            value: 'N/A'
          },
          lCarnitine: {
            unit: 'mg',
            value: 'N/A'
          },
          osmolality: {
            unit: 'mOsm/kg H2O',
            value: 1050
          },
          osmolarity: {
            unit: 'mOsm/litre',
            value: 746
          },
          water: {
            unit: 'g/100ml',
            value: 217
          },
          renalSoluteLoad: {
            unit: 'mOsm/litre',
            value: '218'
          }
        }
      },
      {
        id: 10,
        name: 'Ensure® Shake',
        volume: '(1 sachet + 200mL whole milk)',
        volumeOffset: 246,
        typeofcategory: 'Serving',
        macroNutrients: {
          energy: {
            kj: {
              value: 1613,
              unit: 'kJ'
            },
            kcal: {
              value: 386,
              unit: 'kcal'
            }
          },
          protein: {
            value: 17.2,
            unit: 'g'
          },
          carbohydrate: {
            value: 43.2,
            unit: 'g',
            ofWhichSugars: {
              value: 28.8,
              unit: 'g'
            }
          },
          fat: {
            value: 16.0,
            unit: 'g',
            ofWhichSaturates: {
              value: 9.0,
              unit: 'g'
            }
          },
          cahmb: {
            value: 'N/A',
            unit: 'g'
          },
          salt: {
            value: 0.61,
            unit: 'g'
          },
          fibre: {
            value: 0,
            unit: 'g',
            ofWhichFos: {
              value: 0,
              unit: 'g'
            }
          }
        },
        vitamins: {
          vitaminAre: {
            unit: 'mcg',
            value: 344,
            ofWhichBCaroteneRE: {
              unit: 'mcg',
              value: 0
            }
          },
          vitaminD: {
            unit: 'mcg',
            value: 5.0
          },
          vitaminE: {
            unit: 'mg',
            value: 6.1
          },
          vitaminC: {
            unit: 'mg',
            value: 37.2
          },
          thiaminVitaminB1: {
            unit: 'mg',
            value: 0.84
          },
          riboflavinVitaminB2: {
            unit: 'mg',
            value: 1.31
          },
          niacin: {
            unit: 'mg',
            value: 10.7
          },
          vitaminB6: {
            unit: 'mg',
            value: 1.23
          },
          folate: {
            unit: 'mcg',
            value: 222.7
          },
          folacin: {
            unit: 'mcg',
            value: 131
          },
          vitaminB12: {
            title: 'Vitamin B12',
            unit: 'mcg',
            value: 2.93
          },
          biotin: {
            unit: 'mcg',
            value: 23.8
          },
          panthothenicAcid: {
            title: 'Pantothenic acid',
            unit: 'mg',
            value: 4.23
          },
          vitaminK: {
            title: 'Vitamin K',
            unit: 'mcg',
            value: 31.4
          }
        },
        minerals: {
          sodium: {
            unit: 'mg',
            value: 243
          },
          calcium: {
            unit: 'mg',
            value: 561
          },
          phosphate: {
            unit: 'mg',
            value: 443
          },
          iron: {
            unit: 'mg',
            value: 3.99
          },
          magnesium: {
            unit: 'mg',
            value: 67.2
          },
          zinc: {
            unit: 'mg',
            value: 3.65
          },
          iodine: {
            unit: 'mcg',
            value: 116
          },
          potassium: {
            unit: 'mg',
            value: 699
          },
          chloride: {
            unit: 'mg',
            value: 448
          },
          copper: {
            unit: 'mg',
            value: 0.31
          },
          manganese: {
            unit: 'mg',
            value: 0.35
          },
          selenium: {
            unit: 'mcg',
            value: 16.4
          },
          chromium: {
            unit: 'mcg',
            value: 4.0
          },
          molybdenum: {
            unit: 'mcg',
            value: 9.12
          },
          choline: {
            unit: 'mg',
            value: 'N/A'
          },
          taurine: {
            unit: 'mg',
            value: 'N/A'
          },
          lCarnitine: {
            unit: 'mg',
            value: 'N/A'
          },
          osmolality: {
            unit: 'mOsm/kg H2O',
            value: 959
          },
          osmolarity: {
            unit: 'mOsm/litre',
            value: 710
          },
          water: {
            unit: 'g/100ml',
            value: 'N/A'
          },
          renalSoluteLoad: {
            unit: 'mOsm/litre',
            value: 568
          }
        }
      }
    ]
  },
  {
    title: 'DISEASE-SPECIFIC SIP AND TUBE FEEDS',
    products: [
      {
        id: 11,
        name: 'Vital® 1.5kcal',
        volume: '100 mL tube feed',
        volumeOffset: 100,
        typeofcategory: 'Serving',
        macroNutrients: {
          energy: {
            kj: {
              value: 631,
              unit: 'kJ'
            },
            kcal: {
              value: 150,
              unit: 'kcal'
            }
          },
          protein: {
            value: 6.75,
            unit: 'g'
          },
          carbohydrate: {
            value: 18.4,
            unit: 'g',
            ofWhichSugars: {
              value: 3.5,
              unit: 'g'
            }
          },
          fat: {
            value: 5.5,
            unit: 'g',
            ofWhichSaturates: {
              value: 3.9,
              unit: 'g'
            }
          },
          cahmb: {
            value: 'N/A',
            unit: 'g'
          },
          salt: {
            value: 0.42,
            unit: 'g'
          },
          fibre: {
            value: 0,
            unit: 'g',
            ofWhichFos: {
              value: 0,
              unit: 'g'
            }
          }
        },
        vitamins: {
          vitaminAre: {
            unit: 'mcg',
            value: 150,
            ofWhichBCaroteneRE: {
              unit: 'mcg',
              value: 0
            }
          },
          vitaminD: {
            unit: 'mcg',
            value: 1.0
          },
          vitaminE: {
            unit: 'mg',
            value: 1.9
          },
          vitaminC: {
            unit: 'mg',
            value: 18
          },
          thiaminVitaminB1: {
            unit: 'mg',
            value: 0.21
          },
          riboflavinVitaminB2: {
            unit: 'mg',
            value: 0.3
          },
          niacin: {
            unit: 'mg',
            value: 3.0
          },
          vitaminB6: {
            unit: 'mg',
            value: 0.3
          },
          folate: {
            unit: 'mcg',
            value: 51
          },
          folacin: {
            unit: 'mcg',
            value: 30
          },
          vitaminB12: {
            title: 'Vitamin B12',
            unit: 'mcg',
            value: 0.5
          },
          biotin: {
            unit: 'mcg',
            value: 5.5
          },
          panthothenicAcid: {
            title: 'Pantothenic acid',
            unit: 'mg',
            value: 1.0
          },
          vitaminK: {
            title: 'Vitamin K',
            unit: 'mcg',
            value: 7.0
          }
        },
        minerals: {
          sodium: {
            unit: 'mg',
            value: 169
          },
          calcium: {
            unit: 'mg',
            value: 100
          },
          phosphate: {
            unit: 'mg',
            value: 100
          },
          iron: {
            unit: 'mg',
            value: 2.0
          },
          magnesium: {
            unit: 'mg',
            value: 30
          },
          zinc: {
            unit: 'mg',
            value: 1.8
          },
          iodine: {
            unit: 'mcg',
            value: 15
          },
          potassium: {
            unit: 'mg',
            value: 200
          },
          chloride: {
            unit: 'mg',
            value: 150
          },
          copper: {
            unit: 'mg',
            value: 0.24
          },
          manganese: {
            unit: 'mg',
            value: 0.5
          },
          selenium: {
            unit: 'mcg',
            value: 9.5
          },
          chromium: {
            unit: 'mcg',
            value: 8
          },
          molybdenum: {
            unit: 'mcg',
            value: 18
          },
          choline: {
            unit: 'mg',
            value: 68
          },
          taurine: {
            unit: 'mg',
            value: 15
          },
          lCarnitine: {
            unit: 'mg',
            value: 15
          },
          osmolality: {
            unit: 'mOsm/kg H2O',
            value: 630
          },
          osmolarity: {
            unit: 'mOsm/litre',
            value: 487
          },
          water: {
            unit: 'g/100ml',
            value: 77.6
          },
          renalSoluteLoad: {
            unit: 'mOsm/litre',
            value: 552
          }
        }
      },
      {
        id: 12,
        name: 'Perative®',
        volume: '100 mL tube feed',
        volumeOffset: 100,
        typeofcategory: 'Serving',
        macroNutrients: {
          energy: {
            kj: {
              value: 552,
              unit: 'kJ'
            },
            kcal: {
              value: 131,
              unit: 'kcal'
            }
          },
          protein: {
            value: 6.7,
            unit: 'g'
          },
          carbohydrate: {
            value: 17.7,
            unit: 'g',
            ofWhichSugars: {
              value: 0.45,
              unit: 'g'
            }
          },
          fat: {
            value: 3.7,
            unit: 'g',
            ofWhichSaturates: {
              value: 1.45,
              unit: 'g'
            }
          },
          cahmb: {
            value: 'N/A',
            unit: 'g'
          },
          salt: {
            value: 0.26,
            unit: 'g'
          },
          fibre: {
            value: 0,
            unit: 'g',
            ofWhichFos: {
              value: 0,
              unit: 'g'
            }
          }
        },
        vitamins: {
          vitaminAre: {
            unit: 'mcg',
            value: 139,
            ofWhichBCaroteneRE: {
              unit: 'mcg',
              value: 85
            }
          },
          vitaminD: {
            unit: 'mcg',
            value: 0.88
          },
          vitaminE: {
            unit: 'mg',
            value: 2.7
          },
          vitaminC: {
            unit: 'mg',
            value: 15
          },
          thiaminVitaminB1: {
            unit: 'mg',
            value: 0.2
          },
          riboflavinVitaminB2: {
            unit: 'mg',
            value: 0.23
          },
          niacin: {
            unit: 'mg',
            value: 2.2
          },
          vitaminB6: {
            unit: 'mg',
            value: 0.27
          },
          folate: {
            unit: 'mcg',
            value: 54.4
          },
          folacin: {
            unit: 'mcg',
            value: 32
          },
          vitaminB12: {
            title: 'Vitamin B12',
            unit: 'mcg',
            value: 0.41
          },
          biotin: {
            unit: 'mcg',
            value: 6.0
          },
          panthothenicAcid: {
            title: 'Pantothenic acid',
            unit: 'mg',
            value: 1.1
          },
          vitaminK: {
            title: 'Vitamin K',
            unit: 'mcg',
            value: 7.0
          }
        },
        minerals: {
          sodium: {
            unit: 'mg',
            value: 104
          },
          calcium: {
            unit: 'mg',
            value: 87
          },
          phosphate: {
            unit: 'mg',
            value: 87
          },
          iron: {
            unit: 'mg',
            value: 1.6
          },
          magnesium: {
            unit: 'mg',
            value: 27
          },
          zinc: {
            unit: 'mg',
            value: 1.5
          },
          iodine: {
            unit: 'mcg',
            value: 16
          },
          potassium: {
            unit: 'mg',
            value: 173
          },
          chloride: {
            unit: 'mg',
            value: 145
          },
          copper: {
            unit: 'mg',
            value: 0.18
          },
          manganese: {
            unit: 'mg',
            value: 0.44
          },
          selenium: {
            unit: 'mcg',
            value: 6.1
          },
          chromium: {
            unit: 'mcg',
            value: 10.0
          },
          molybdenum: {
            unit: 'mcg',
            value: 13
          },
          choline: {
            unit: 'mg',
            value: 52
          },
          taurine: {
            unit: 'mg',
            value: 14
          },
          lCarnitine: {
            unit: 'mg',
            value: 10.0
          },
          osmolality: {
            unit: 'mOsm/kg H2O',
            value: 385
          },
          osmolarity: {
            unit: 'mOsm/litre',
            value: 308
          },
          water: {
            unit: 'g/100ml',
            value: 80.3
          },
          renalSoluteLoad: {
            unit: 'mOsm/litre',
            value: 512
          }
        }
      },
      {
        id: 13,
        name: 'Nepro® HP',
        volume: '100 mL tube feed',
        volumeOffset: 100,
        typeofcategory: 'Serving',
        macroNutrients: {
          energy: {
            kj: {
              value: 752.27272,
              unit: 'kJ'
            },
            kcal: {
              value: 180,
              unit: 'kcal'
            }
          },
          protein: {
            value: 8.1,
            unit: 'g'
          },
          carbohydrate: {
            value: 14.74,
            unit: 'g',
            ofWhichSugars: {
              value: 3.2,
              unit: 'g'
            }
          },
          fat: {
            value: 9.77,
            unit: 'g',
            ofWhichSaturates: {
              value: 0.73,
              unit: 'g'
            }
          },
          cahmb: {
            value: 'N/A',
            unit: 'g'
          },
          salt: {
            value: 0.18,
            unit: 'g'
          },
          fibre: {
            value: 1.26,
            unit: 'g',
            ofWhichFos: {
              value: 0.84,
              unit: 'g'
            }
          }
        },
        vitamins: {
          vitaminAre: {
            unit: 'mcg',
            value: 95,
            ofWhichBCaroteneRE: {
              unit: 'mcg',
              value: 0
            }
          },
          vitaminD: {
            unit: 'mcg',
            value: 1.2
          },
          vitaminE: {
            unit: 'mg',
            value: 3.4
          },
          vitaminC: {
            unit: 'mg',
            value: 10.5
          },
          thiaminVitaminB1: {
            unit: 'mg',
            value: 0.42
          },
          riboflavinVitaminB2: {
            unit: 'mg',
            value: 0.5
          },
          niacin: {
            unit: 'mg',
            value: 3.4
          },
          vitaminB6: {
            unit: 'mg',
            value: 0.5
          },
          folate: {
            unit: 'mcg',
            value: 102
          },
          folacin: {
            unit: 'mcg',
            value: 60
          },
          vitaminB12: {
            title: 'Vitamin B12',
            unit: 'mcg',
            value: 0.85
          },
          biotin: {
            unit: 'mcg',
            value: 9
          },
          panthothenicAcid: {
            title: 'Pantothenic acid',
            unit: 'mg',
            value: 1.6
          },
          vitaminK: {
            title: 'Vitamin K',
            unit: 'mcg',
            value: 9.0
          }
        },
        minerals: {
          sodium: {
            unit: 'mg',
            value: 70
          },
          calcium: {
            unit: 'mg',
            value: 106
          },
          phosphate: {
            unit: 'mg',
            value: 72
          },
          iron: {
            unit: 'mg',
            value: 1.9
          },
          magnesium: {
            unit: 'mg',
            value: 21
          },
          zinc: {
            unit: 'mg',
            value: 1.9
          },
          iodine: {
            unit: 'mcg',
            value: 16
          },
          potassium: {
            unit: 'mg',
            value: 106
          },
          chloride: {
            unit: 'mg',
            value: 84
          },
          copper: {
            unit: 'mg',
            value: 0.21
          },
          manganese: {
            unit: 'mg',
            value: 0.21
          },
          selenium: {
            unit: 'mcg',
            value: 7.4
          },
          chromium: {
            unit: 'mcg',
            value: 4.5
          },
          molybdenum: {
            unit: 'mcg',
            value: 8.0
          },
          choline: {
            unit: 'mg',
            value: 63.5
          },
          taurine: {
            unit: 'mg',
            value: 16
          },
          lCarnitine: {
            unit: 'mg',
            value: 26.5
          },
          osmolality: {
            unit: 'mOsm/kg H2O',
            value: 735
          },
          osmolarity: {
            unit: 'mOsm/litre',
            value: 538
          },
          water: {
            unit: 'g/100ml',
            value: 73.29
          },
          renalSoluteLoad: {
            unit: 'mOsm/litre',
            value: 543
          }
        }
      },
      {
        id: 14,
        name: 'Glucerna® 1.5kcal',
        volume: '100 mL tube feed',
        volumeOffset: 100,
        typeofcategory: 'Serving',
        macroNutrients: {
          energy: {
            kj: {
              value: 625,
              unit: 'kJ'
            },
            kcal: {
              value: 150,
              unit: 'kcal'
            }
          },
          protein: {
            value: 7.5,
            unit: 'g'
          },
          carbohydrate: {
            value: 12.75,
            unit: 'g',
            ofWhichSugars: {
              value: 6.7,
              unit: 'g'
            }
          },
          fat: {
            value: 7.5,
            unit: 'g',
            ofWhichSaturates: {
              value: 0.53,
              unit: 'g'
            }
          },
          cahmb: {
            value: 'N/A',
            unit: 'g'
          },
          salt: {
            value: 0.35,
            unit: 'g'
          },
          fibre: {
            value: 1.5,
            unit: 'g',
            ofWhichFos: {
              value: 1.0,
              unit: 'g'
            }
          }
        },
        vitamins: {
          vitaminAre: {
            unit: 'μg',
            value: 144,
            ofWhichBCaroteneRE: {
              unit: 'μg',
              value: 0
            }
          },
          vitaminD: {
            unit: 'μg',
            value: 2.5
          },
          vitaminE: {
            unit: 'mg',
            value: 3.02
          },
          vitaminC: {
            unit: 'mg',
            value: 13
          },
          thiaminVitaminB1: {
            unit: 'mg',
            value: 0.26
          },
          riboflavinVitaminB2: {
            unit: 'mg',
            value: 0.34
          },
          niacin: {
            unit: 'mg',
            value: 3.0
          },
          vitaminB6: {
            unit: 'mg',
            value: 0.39
          },
          folate: {
            unit: 'mcg',
            value: 68
          },
          folacin: {
            unit: 'μg',
            value: 40
          },
          vitaminB12: {
            title: 'Vitamin B12',
            unit: 'μg',
            value: 0.5
          },
          biotin: {
            unit: 'μg',
            value: 7.2
          },
          panthothenicAcid: {
            title: 'Pantothenic acid',
            unit: 'mg',
            value: 1.2
          },
          vitaminK: {
            title: 'Vitamin K',
            unit: 'μg',
            value: 12
          }
        },
        minerals: {
          sodium: {
            unit: 'mg',
            value: 140
          },
          calcium: {
            unit: 'mg',
            value: 100
          },
          phosphate: {
            unit: 'mg',
            value: 100
          },
          iron: {
            unit: 'mg',
            value: 0.85
          },
          magnesium: {
            unit: 'mg',
            value: 31
          },
          zinc: {
            unit: 'mg',
            value: 1.7
          },
          iodine: {
            unit: 'μg',
            value: 15
          },
          potassium: {
            unit: 'mg',
            value: 165
          },
          chloride: {
            unit: 'mg',
            value: 145
          },
          copper: {
            unit: 'μg',
            value: 0.11
          },
          manganese: {
            unit: 'mg',
            value: 0.44
          },
          selenium: {
            unit: 'μg',
            value: 9.5
          },
          chromium: {
            unit: 'μg',
            value: 9.0
          },
          molybdenum: {
            unit: 'μg',
            value: 16
          },
          choline: {
            unit: 'mg',
            value: 60
          },
          taurine: {
            unit: 'mg',
            value: 15
          },
          lCarnitine: {
            unit: 'mg',
            value: 12
          },
          osmolality: {
            unit: 'mOsm/kg H2O',
            value: 875
          },
          osmolarity: {
            unit: 'mOsm/litre',
            value: 671
          },
          water: {
            unit: 'g/100ml',
            value: 77
          },
          renalSoluteLoad: {
            unit: 'mOsm/litre',
            value: 571
          }
        }
      },
      {
        id: 15,
        name: 'Vital® 1.5kcal',
        volume: '200 mL sip feed',
        volumeOffset: 200,
        typeofcategory: 'Bottle',
        macroNutrients: {
          energy: {
            kj: {
              value: 1262,
              unit: 'kJ'
            },
            kcal: {
              value: 300,
              unit: 'kcal'
            }
          },
          protein: {
            value: 13.5,
            unit: 'g'
          },
          carbohydrate: {
            value: 36.8,
            unit: 'g',
            ofWhichSugars: {
              value: 7,
              unit: 'g'
            }
          },
          fat: {
            value: 11,
            unit: 'g',
            ofWhichSaturates: {
              value: 7.8,
              unit: 'g'
            }
          },
          cahmb: {
            value: 'N/A',
            unit: 'g'
          },
          salt: {
            value: 0.84,
            unit: 'g'
          },
          fibre: {
            value: 0.0,
            unit: 'g',
            ofWhichFos: {
              value: 0.0,
              unit: 'g'
            }
          }
        },
        vitamins: {
          vitaminAre: {
            unit: 'mcg',
            value: 300,
            ofWhichBCaroteneRE: {
              unit: 'mcg',
              value: 0
            }
          },
          vitaminD: {
            unit: 'mcg',
            value: 2.0
          },
          vitaminE: {
            unit: 'mg',
            value: 3.8
          },
          vitaminC: {
            unit: 'mg',
            value: 36
          },
          thiaminVitaminB1: {
            unit: 'mg',
            value: 0.42
          },
          riboflavinVitaminB2: {
            unit: 'mg',
            value: 0.6
          },
          niacin: {
            unit: 'mg',
            value: 6
          },
          vitaminB6: {
            unit: 'mg',
            value: 0.6
          },
          folate: {
            unit: 'mcg',
            value: 102
          },
          folacin: {
            unit: 'mcg',
            value: 60
          },
          vitaminB12: {
            title: 'Vitamin B12',
            unit: 'mcg',
            value: 1.0
          },
          biotin: {
            unit: 'mcg',
            value: 11
          },
          panthothenicAcid: {
            title: 'Pantothenic acid',
            unit: 'mg',
            value: 2.0
          },
          vitaminK: {
            title: 'Vitamin K',
            unit: 'mcg',
            value: 14
          }
        },
        minerals: {
          sodium: {
            unit: 'mg',
            value: 338
          },
          calcium: {
            unit: 'mg',
            value: 200
          },
          phosphate: {
            unit: 'mg',
            value: 200
          },
          iron: {
            unit: 'mg',
            value: 4.0
          },
          magnesium: {
            unit: 'mg',
            value: 60
          },
          zinc: {
            unit: 'mg',
            value: 3.6
          },
          iodine: {
            unit: 'mcg',
            value: 30
          },
          potassium: {
            unit: 'mg',
            value: 400
          },
          chloride: {
            unit: 'mg',
            value: 300
          },
          copper: {
            unit: 'mg',
            value: 0.48
          },
          manganese: {
            unit: 'mg',
            value: 1.0
          },
          selenium: {
            unit: 'mcg',
            value: 19
          },
          chromium: {
            unit: 'mcg',
            value: 16
          },
          molybdenum: {
            unit: 'mcg',
            value: 36
          },
          choline: {
            unit: 'mg',
            value: 136
          },
          taurine: {
            unit: 'mg',
            value: 30
          },
          lCarnitine: {
            unit: 'mg',
            value: 30
          },
          osmolality: {
            unit: 'mOsm/kg H2O',
            value: 630
          },
          osmolarity: {
            unit: 'mOsm/litre',
            value: 487
          },
          water: {
            unit: 'g/100ml',
            value: 77.6
          },
          renalSoluteLoad: {
            unit: 'mOsm/litre',
            value: 552
          }
        }
      },
      {
        id: 16,
        name: 'Nepro® HP',
        volume: '220 mL sip feed',
        volumeOffset: 220,
        typeofcategory: 'Bottle',
        macroNutrients: {
          energy: {
            kj: {
              value: 1655,
              unit: 'kJ'
            },
            kcal: {
              value: 396,
              unit: 'kcal'
            }
          },
          protein: {
            value: 17.82,
            unit: 'g'
          },
          carbohydrate: {
            value: 32.43,
            unit: 'g',
            ofWhichSugars: {
              value: 7.0,
              unit: 'g'
            }
          },
          fat: {
            value: 21.49,
            unit: 'g',
            ofWhichSaturates: {
              value: 1.6,
              unit: 'g'
            }
          },
          cahmb: {
            value: 'N/A',
            unit: 'g'
          },
          salt: {
            value: 0.4,
            unit: 'g'
          },
          fibre: {
            value: 2.77,
            unit: 'g',
            ofWhichFos: {
              value: 1.85,
              unit: 'g'
            }
          }
        },
        vitamins: {
          vitaminAre: {
            unit: 'mcg',
            value: 210,
            ofWhichBCaroteneRE: {
              unit: 'mcg',
              value: 0
            }
          },
          vitaminD: {
            unit: 'mcg',
            value: 2.5
          },
          vitaminE: {
            unit: 'mg',
            value: 7.4
          },
          vitaminC: {
            unit: 'mg',
            value: 23
          },
          thiaminVitaminB1: {
            unit: 'mg',
            value: 0.92
          },
          riboflavinVitaminB2: {
            unit: 'mg',
            value: 1.1
          },
          niacin: {
            unit: 'mg',
            value: 7.5
          },
          vitaminB6: {
            unit: 'mg',
            value: 1.1
          },
          folate: {
            unit: 'mcg',
            value: 224.4
          },
          folacin: {
            unit: 'mcg',
            value: 132
          },
          vitaminB12: {
            title: 'Vitamin B12',
            unit: 'mcg',
            value: 1.9
          },
          biotin: {
            unit: 'mcg',
            value: 20
          },
          panthothenicAcid: {
            title: 'Pantothenic acid',
            unit: 'mg',
            value: 3.5
          },
          vitaminK: {
            title: 'Vitamin K',
            unit: 'mcg',
            value: 20
          }
        },
        minerals: {
          sodium: {
            unit: 'mg',
            value: 154
          },
          calcium: {
            unit: 'mg',
            value: 233
          },
          phosphate: {
            unit: 'mg',
            value: 158
          },
          iron: {
            unit: 'mg',
            value: 4.2
          },
          magnesium: {
            unit: 'mg',
            value: 46
          },
          zinc: {
            unit: 'mg',
            value: 4.2
          },
          iodine: {
            unit: 'mcg',
            value: 35
          },
          potassium: {
            unit: 'mg',
            value: 233
          },
          chloride: {
            unit: 'mg',
            value: 185
          },
          copper: {
            unit: 'mg',
            value: 0.46
          },
          manganese: {
            unit: 'mg',
            value: 0.46
          },
          selenium: {
            unit: 'mcg',
            value: 16
          },
          chromium: {
            unit: 'mcg',
            value: 9.9
          },
          molybdenum: {
            unit: 'mcg',
            value: 18
          },
          choline: {
            unit: 'mg',
            value: 140
          },
          taurine: {
            unit: 'mg',
            value: 35
          },
          lCarnitine: {
            unit: 'mg',
            value: 58
          },
          osmolality: {
            unit: 'mOsm/kg H2O',
            value: 735
          },
          osmolarity: {
            unit: 'mOsm/litre',
            value: 538
          },
          water: {
            unit: 'g/100ml',
            value: 73.29
          },
          renalSoluteLoad: {
            unit: 'mOsm/litre',
            value: 543
          }
        }
      },
      {
        id: 41,
        name: 'ProSure®',
        volume: '220 mL sip feed',
        volumeOffset: 220,
        typeofcategory: 'Bottle',
        macroNutrients: {
          energy: {
            kj: {
              value: 1179,
              unit: 'kJ'
            },
            kcal: {
              value: 280,
              unit: 'kcal'
            }
          },
          protein: {
            value: 14.63,
            unit: 'g'
          },
          carbohydrate: {
            value: 40.33,
            unit: 'g',
            ofWhichSugars: {
              value: 14,
              unit: 'g'
            }
          },
          fat: {
            value: 5.63,
            unit: 'g',
            ofWhichSaturates: {
              value: 1.5,
              unit: 'g'
            }
          },
          cahmb: {
            value: 'N/A',
            unit: 'g'
          },
          salt: {
            value: 0.64,
            unit: 'g'
          },
          fibre: {
            value: 4.55,
            unit: 'g',
            ofWhichFos: {
              value: 2.42,
              unit: 'g'
            }
          }
        },
        vitamins: {
          vitaminAre: {
            unit: 'mcg',
            value: 451,
            ofWhichBCaroteneRE: {
              unit: 'mcg',
              value: 154
            }
          },
          vitaminD: {
            unit: 'mcg',
            value: 3.7
          },
          vitaminE: {
            unit: 'mg',
            value: 44
          },
          vitaminC: {
            unit: 'mg',
            value: 95
          },
          thiaminVitaminB1: {
            unit: 'mg',
            value: 0.55
          },
          riboflavinVitaminB2: {
            unit: 'mg',
            value: 0.64
          },
          niacin: {
            unit: 'mg',
            value: 5.3
          },
          vitaminB6: {
            unit: 'mg',
            value: 0.75
          },
          folate: {
            unit: 'mcg',
            value: 119
          },
          folacin: {
            unit: 'mcg',
            value: 70
          },
          vitaminB12: {
            title: 'Vitamin B12',
            unit: 'mcg',
            value: 0.77
          },
          biotin: {
            unit: 'mcg',
            value: 11
          },
          panthothenicAcid: {
            title: 'Pantothenic acid',
            unit: 'mg',
            value: 2.4
          },
          vitaminK: {
            title: 'Vitamin K',
            unit: 'mcg',
            value: 22
          }
        },
        minerals: {
          sodium: {
            unit: 'mg',
            value: 253
          },
          calcium: {
            unit: 'mg',
            value: 220
          },
          phosphate: {
            unit: 'mg',
            value: 176
          },
          iron: {
            unit: 'mg',
            value: 1.43
          },
          magnesium: {
            unit: 'mg',
            value: 92
          },
          zinc: {
            unit: 'mg',
            value: 5.5
          },
          iodine: {
            unit: 'mcg',
            value: 35
          },
          potassium: {
            unit: 'mg',
            value: 385
          },
          chloride: {
            unit: 'mg',
            value: 334
          },
          copper: {
            unit: 'mg',
            value: 0.17
          },
          manganese: {
            unit: 'mg',
            value: 0.92
          },
          selenium: {
            unit: 'mcg',
            value: 17
          },
          chromium: {
            unit: 'mcg',
            value: 20
          },
          molybdenum: {
            unit: 'mcg',
            value: 31
          },
          choline: {
            unit: 'mg',
            value: 112
          },
          taurine: {
            unit: 'mg',
            value: 44
          },
          lCarnitine: {
            unit: 'mg',
            value: 22
          },
          osmolality: {
            unit: 'mOsm/kg H2O',
            value: 753
          },
          osmolarity: {
            unit: 'mOsm/litre',
            value: 597
          },
          water: {
            unit: 'g/100ml',
            value: 79.6
          },
          renalSoluteLoad: {
            unit: 'mOsm/litre',
            value: 517
          }
        }
      }
    ]
  },
  {
    title: 'TUBE FEEDS',
    products: [
      {
        id: 17,
        name: 'Jevity®',
        volume: '100 mL',
        volumeOffset: 100,
        typeofcategory: 'Serving',
        macroNutrients: {
          energy: {
            kj: {
              value: 449,
              unit: 'kJ'
            },
            kcal: {
              value: 107,
              unit: 'kcal'
            }
          },
          protein: {
            value: 4.0,
            unit: 'g'
          },
          carbohydrate: {
            value: 14.05,
            unit: 'g',
            ofWhichSugars: {
              value: 0.25,
              unit: 'g'
            }
          },
          fat: {
            value: 3.47,
            unit: 'g',
            ofWhichSaturates: {
              value: 0.94,
              unit: 'g'
            }
          },
          cahmb: {
            value: 'N/A',
            unit: 'g'
          },
          salt: {
            value: 0.23,
            unit: 'g'
          },
          fibre: {
            value: 1.76,
            unit: 'g',
            ofWhichFos: {
              value: 0.7,
              unit: 'g'
            }
          }
        },
        vitamins: {
          vitaminAre: {
            unit: 'mcg',
            value: 51,
            ofWhichBCaroteneRE: {
              unit: 'mcg',
              value: 31
            }
          },
          vitaminD: {
            unit: 'mcg',
            value: 0.75
          },
          vitaminE: {
            unit: 'mg',
            value: 2.3
          },
          vitaminC: {
            unit: 'mg',
            value: 10
          },
          thiaminVitaminB1: {
            unit: 'mg',
            value: 0.17
          },
          riboflavinVitaminB2: {
            unit: 'mg',
            value: 0.2
          },
          niacin: {
            unit: 'mg',
            value: 1.8
          },
          vitaminB6: {
            unit: 'mg',
            value: 0.23
          },
          folate: {
            unit: 'mcg',
            value: 45.9
          },
          folacin: {
            unit: 'mcg',
            value: 27
          },
          vitaminB12: {
            title: 'Vitamin B12',
            unit: 'mcg',
            value: 0.39
          },
          biotin: {
            unit: 'mcg',
            value: 5.0
          },
          panthothenicAcid: {
            title: 'Pantothenic acid',
            unit: 'mg',
            value: 0.93
          },
          vitaminK: {
            title: 'Vitamin K',
            unit: 'mcg',
            value: 6.2
          }
        },
        minerals: {
          sodium: {
            unit: 'mg',
            value: 93
          },
          calcium: {
            unit: 'mg',
            value: 92
          },
          phosphate: {
            unit: 'mg',
            value: 72
          },
          iron: {
            unit: 'mg',
            value: 1.4
          },
          magnesium: {
            unit: 'mg',
            value: 22
          },
          zinc: {
            unit: 'mg',
            value: 1.1
          },
          iodine: {
            unit: 'mcg',
            value: 13
          },
          potassium: {
            unit: 'mg',
            value: 157
          },
          chloride: {
            unit: 'mg',
            value: 131
          },
          copper: {
            unit: 'mg',
            value: 0.15
          },
          manganese: {
            unit: 'mg',
            value: 0.35
          },
          selenium: {
            unit: 'mcg',
            value: 5.3
          },
          chromium: {
            unit: 'mcg',
            value: 6.8
          },
          molybdenum: {
            unit: 'mcg',
            value: 11
          },
          choline: {
            unit: 'mg',
            value: 46
          },
          taurine: {
            unit: 'mg',
            value: 10
          },
          lCarnitine: {
            unit: 'mg',
            value: 8.4
          },
          osmolality: {
            unit: 'mOsm/kg H2O',
            value: 300
          },
          osmolarity: {
            unit: 'mOsm/litre',
            value: 249
          },
          water: {
            unit: 'g/100ml',
            value: 83.3
          },
          renalSoluteLoad: {
            unit: 'mOsm/litre',
            value: 346
          }
        }
      },
      {
        id: 18,
        name: 'Jevity® Plus',
        volume: '100 mL',
        volumeOffset: 100,
        typeofcategory: 'Serving',
        macroNutrients: {
          energy: {
            kj: {
              value: 514,
              unit: 'kJ'
            },
            kcal: {
              value: 122,
              unit: 'kcal'
            }
          },
          protein: {
            value: 5.55,
            unit: 'g'
          },
          carbohydrate: {
            value: 15.07,
            unit: 'g',
            ofWhichSugars: {
              value: 0.75,
              unit: 'g'
            }
          },
          fat: {
            value: 3.93,
            unit: 'g',
            ofWhichSaturates: {
              value: 0.95,
              unit: 'g'
            }
          },
          cahmb: {
            value: 'N/A',
            unit: 'g'
          },
          salt: {
            value: 0.27,
            unit: 'g'
          },
          fibre: {
            value: 2.2,
            unit: 'g',
            ofWhichFos: {
              value: 1.0,
              unit: 'g'
            }
          }
        },
        vitamins: {
          vitaminAre: {
            unit: 'mcg',
            value: 84,
            ofWhichBCaroteneRE: {
              unit: 'mcg',
              value: 33
            }
          },
          vitaminD: {
            unit: 'mcg',
            value: 1.0
          },
          vitaminE: {
            unit: 'mg',
            value: 2.4
          },
          vitaminC: {
            unit: 'mg',
            value: 12
          },
          thiaminVitaminB1: {
            unit: 'mg',
            value: 0.19
          },
          riboflavinVitaminB2: {
            unit: 'mg',
            value: 0.21
          },
          niacin: {
            unit: 'mg',
            value: 2.2
          },
          vitaminB6: {
            unit: 'mg',
            value: 0.26
          },
          folate: {
            unit: 'mcg',
            value: 51
          },
          folacin: {
            unit: 'mcg',
            value: 30
          },
          vitaminB12: {
            title: 'Vitamin B12',
            unit: 'mcg',
            value: 0.35
          },
          biotin: {
            unit: 'mcg',
            value: 5.2
          },
          panthothenicAcid: {
            title: 'Pantothenic acid',
            unit: 'mg',
            value: 1.0
          },
          vitaminK: {
            title: 'Vitamin K',
            unit: 'mcg',
            value: 8.0
          }
        },
        minerals: {
          sodium: {
            unit: 'mg',
            value: 108
          },
          calcium: {
            unit: 'mg',
            value: 80
          },
          phosphate: {
            unit: 'mg',
            value: 80
          },
          iron: {
            unit: 'mg',
            value: 1.8
          },
          magnesium: {
            unit: 'mg',
            value: 24
          },
          zinc: {
            unit: 'mg',
            value: 1.4
          },
          iodine: {
            unit: 'mcg',
            value: 15
          },
          potassium: {
            unit: 'mg',
            value: 185
          },
          chloride: {
            unit: 'mg',
            value: 150
          },
          copper: {
            unit: 'mg',
            value: 0.2
          },
          manganese: {
            unit: 'mg',
            value: 0.42
          },
          selenium: {
            unit: 'mcg',
            value: 7.5
          },
          chromium: {
            unit: 'mcg',
            value: 8.0
          },
          molybdenum: {
            unit: 'mcg',
            value: 13
          },
          choline: {
            unit: 'mg',
            value: 60
          },
          taurine: {
            unit: 'mg',
            value: 15
          },
          lCarnitine: {
            unit: 'mg',
            value: 9.6
          },
          osmolality: {
            unit: 'mOsm/kg H2O',
            value: 449
          },
          osmolarity: {
            unit: 'mOsm/litre',
            value: 361
          },
          water: {
            unit: 'g/100ml',
            value: 80.7
          },
          renalSoluteLoad: {
            unit: 'mOsm/litre',
            value: 453
          }
        }
      },
      {
        id: 19,
        name: 'Jevity® 1.5kcal',
        volume: '100 mL',
        volumeOffset: 100,
        typeofcategory: 'Serving',
        macroNutrients: {
          energy: {
            kj: {
              value: 649,
              unit: 'kJ'
            },
            kcal: {
              value: 154,
              unit: 'kcal'
            }
          },
          protein: {
            value: 6.38,
            unit: 'g'
          },
          carbohydrate: {
            value: 20.1,
            unit: 'g',
            ofWhichSugars: {
              value: 1.3,
              unit: 'g'
            }
          },
          fat: {
            value: 4.9,
            unit: 'g',
            ofWhichSaturates: {
              value: 1.15,
              unit: 'g'
            }
          },
          cahmb: {
            value: 'N/A',
            unit: 'g'
          },
          salt: {
            value: 0.35,
            unit: 'g'
          },
          fibre: {
            value: 2.2,
            unit: 'g',
            ofWhichFos: {
              value: 1.0,
              unit: 'g'
            }
          }
        },
        vitamins: {
          vitaminAre: {
            unit: 'mcg',
            value: 159.5,
            ofWhichBCaroteneRE: {
              unit: 'mcg',
              value: 34.5
            }
          },
          vitaminD: {
            unit: 'mcg',
            value: 1
          },
          vitaminE: {
            unit: 'mg',
            value: 2.6
          },
          vitaminC: {
            unit: 'mg',
            value: 13
          },
          thiaminVitaminB1: {
            unit: 'mg',
            value: 0.26
          },
          riboflavinVitaminB2: {
            unit: 'mg',
            value: 0.34
          },
          niacin: {
            unit: 'mg',
            value: 2.9
          },
          vitaminB6: {
            unit: 'mg',
            value: 0.39
          },
          folate: {
            unit: 'mcg',
            value: 68
          },
          folacin: {
            unit: 'mcg',
            value: 40
          },
          vitaminB12: {
            title: 'Vitamin B12',
            unit: 'mcg',
            value: 0.4
          },
          biotin: {
            unit: 'mcg',
            value: 7.2
          },
          panthothenicAcid: {
            title: 'Pantothenic acid',
            unit: 'mg',
            value: 1.3
          },
          vitaminK: {
            title: 'Vitamin K',
            unit: 'mcg',
            value: 8.0
          }
        },
        minerals: {
          sodium: {
            unit: 'mg',
            value: 140
          },
          calcium: {
            unit: 'mg',
            value: 100
          },
          phosphate: {
            unit: 'mg',
            value: 100
          },
          iron: {
            unit: 'mg',
            value: 2.2
          },
          magnesium: {
            unit: 'mg',
            value: 31
          },
          zinc: {
            unit: 'mg',
            value: 1.9
          },
          iodine: {
            unit: 'mcg',
            value: 15
          },
          potassium: {
            unit: 'mg',
            value: 165
          },
          chloride: {
            unit: 'mg',
            value: 145
          },
          copper: {
            unit: 'mg',
            value: 0.25
          },
          manganese: {
            unit: 'mg',
            value: 0.5
          },
          selenium: {
            unit: 'mcg',
            value: 7.6
          },
          chromium: {
            unit: 'mcg',
            value: 10
          },
          molybdenum: {
            unit: 'mcg',
            value: 15
          },
          choline: {
            unit: 'mg',
            value: 60
          },
          taurine: {
            unit: 'mg',
            value: 15
          },
          lCarnitine: {
            unit: 'mg',
            value: 12
          },
          osmolality: {
            unit: 'mOsm/kg H2O',
            value: 524
          },
          osmolarity: {
            unit: 'mOsm/litre',
            value: 397
          },
          water: {
            unit: 'g/100ml',
            value: 76
          },
          renalSoluteLoad: {
            unit: 'mOsm/litre',
            value: 508
          }
        }
      },
      {
        id: 20,
        name: 'Jevity® Promote',
        volume: '100 mL',
        volumeOffset: 100,
        typeofcategory: 'Serving',
        macroNutrients: {
          energy: {
            kj: {
              value: 434,
              unit: 'kJ'
            },
            kcal: {
              value: 103,
              unit: 'kcal'
            }
          },
          protein: {
            value: 5.55,
            unit: 'g'
          },
          carbohydrate: {
            value: 11.98,
            unit: 'g',
            ofWhichSugars: {
              value: 0.52,
              unit: 'g'
            }
          },
          fat: {
            value: 3.32,
            unit: 'g',
            ofWhichSaturates: {
              value: 0.8,
              unit: 'g'
            }
          },
          cahmb: {
            value: 'N/A',
            unit: 'g'
          },
          salt: {
            value: 0.4,
            unit: 'g'
          },
          fibre: {
            value: 1.7,
            unit: 'g',
            ofWhichFos: {
              value: 0.7,
              unit: 'g'
            }
          }
        },
        vitamins: {
          vitaminAre: {
            unit: 'mcg',
            value: 84,
            ofWhichBCaroteneRE: {
              unit: 'mcg',
              value: 33
            }
          },
          vitaminD: {
            unit: 'mcg',
            value: 1.0
          },
          vitaminE: {
            unit: 'mg',
            value: 2.1
          },
          vitaminC: {
            unit: 'mg',
            value: 10.0
          },
          thiaminVitaminB1: {
            unit: 'mg',
            value: 0.17
          },
          riboflavinVitaminB2: {
            unit: 'mg',
            value: 0.2
          },
          niacin: {
            unit: 'mg',
            value: 2.0
          },
          vitaminB6: {
            unit: 'mg',
            value: 0.26
          },
          folate: {
            unit: 'mcg',
            value: 51
          },
          folacin: {
            unit: 'mcg',
            value: 30
          },
          vitaminB12: {
            title: 'Vitamin B12',
            unit: 'mcg',
            value: 0.35
          },
          biotin: {
            unit: 'mcg',
            value: 5.0
          },
          panthothenicAcid: {
            title: 'Pantothenic acid',
            unit: 'mg',
            value: 0.9
          },
          vitaminK: {
            title: 'Vitamin K',
            unit: 'mcg',
            value: 8.0
          }
        },
        minerals: {
          sodium: {
            unit: 'mg',
            value: 160
          },
          calcium: {
            unit: 'mg',
            value: 70
          },
          phosphate: {
            unit: 'mg',
            value: 70
          },
          iron: {
            unit: 'mg',
            value: 1.4
          },
          magnesium: {
            unit: 'mg',
            value: 30
          },
          zinc: {
            unit: 'mg',
            value: 1.1
          },
          iodine: {
            unit: 'mcg',
            value: 15
          },
          potassium: {
            unit: 'mg',
            value: 250
          },
          chloride: {
            unit: 'mg',
            value: 140
          },
          copper: {
            unit: 'mg',
            value: 0.18
          },
          manganese: {
            unit: 'mg',
            value: 0.35
          },
          selenium: {
            unit: 'mcg',
            value: 7.5
          },
          chromium: {
            unit: 'mcg',
            value: 6.5
          },
          molybdenum: {
            unit: 'mcg',
            value: 11
          },
          choline: {
            unit: 'mg',
            value: 60
          },
          taurine: {
            unit: 'mg',
            value: 15
          },
          lCarnitine: {
            unit: 'mg',
            value: 8.0
          },
          osmolality: {
            unit: 'mOsm/kg H2O',
            value: 425
          },
          osmolarity: {
            unit: 'mOsm/litre',
            value: 356
          },
          water: {
            unit: 'g/100ml',
            value: 84
          },
          renalSoluteLoad: {
            unit: 'mOsm/litre',
            value: 489
          }
        }
      },
      {
        id: 21,
        name: 'Jevity® Plus HP',
        volume: '100 mL',
        volumeOffset: 100,
        typeofcategory: 'Serving',
        macroNutrients: {
          energy: {
            kj: {
              value: 551,
              unit: 'kJ'
            },
            kcal: {
              value: 131,
              unit: 'kcal'
            }
          },
          protein: {
            value: 8.13,
            unit: 'g'
          },
          carbohydrate: {
            value: 14.15,
            unit: 'g',
            ofWhichSugars: {
              value: 0.7,
              unit: 'g'
            }
          },
          fat: {
            value: 4.33,
            unit: 'g',
            ofWhichSaturates: {
              value: 1.0,
              unit: 'g'
            }
          },
          cahmb: {
            value: 'N/A',
            unit: 'g'
          },
          salt: {
            value: 0.25,
            unit: 'g'
          },
          fibre: {
            value: 1.5,
            unit: 'g',
            ofWhichFos: {
              value: 1.0,
              unit: 'g'
            }
          }
        },
        vitamins: {
          vitaminAre: {
            unit: 'mcg',
            value: 150,
            ofWhichBCaroteneRE: {
              unit: 'mcg',
              value: 30
            }
          },
          vitaminD: {
            unit: 'mcg',
            value: 0.9
          },
          vitaminE: {
            unit: 'mg',
            value: 2.3
          },
          vitaminC: {
            unit: 'mg',
            value: 20
          },
          thiaminVitaminB1: {
            unit: 'mg',
            value: 0.2
          },
          riboflavinVitaminB2: {
            unit: 'mg',
            value: 0.28
          },
          niacin: {
            unit: 'mg',
            value: 2.8
          },
          vitaminB6: {
            unit: 'mg',
            value: 0.29
          },
          folate: {
            unit: 'mcg',
            value: 51
          },
          folacin: {
            unit: 'mcg',
            value: 30
          },
          vitaminB12: {
            title: 'Vitamin B12',
            unit: 'mcg',
            value: 0.6
          },
          biotin: {
            unit: 'mcg',
            value: 6.0
          },
          panthothenicAcid: {
            title: 'Pantothenic acid',
            unit: 'mg',
            value: 1.0
          },
          vitaminK: {
            title: 'Vitamin K',
            unit: 'mcg',
            value: 7.0
          }
        },
        minerals: {
          sodium: {
            unit: 'mg',
            value: 100
          },
          calcium: {
            unit: 'mg',
            value: 115
          },
          phosphate: {
            unit: 'mg',
            value: 85
          },
          iron: {
            unit: 'mg',
            value: 1.6
          },
          magnesium: {
            unit: 'mg',
            value: 25
          },
          zinc: {
            unit: 'mg',
            value: 1.7
          },
          iodine: {
            unit: 'mcg',
            value: 16
          },
          potassium: {
            unit: 'mg',
            value: 130
          },
          chloride: {
            unit: 'mg',
            value: 130
          },
          copper: {
            unit: 'mg',
            value: 0.2
          },
          manganese: {
            unit: 'mg',
            value: 0.4
          },
          selenium: {
            unit: 'mcg',
            value: 8.5
          },
          chromium: {
            unit: 'mcg',
            value: 7.0
          },
          molybdenum: {
            unit: 'mcg',
            value: 12
          },
          choline: {
            unit: 'mg',
            value: 60
          },
          taurine: {
            unit: 'mg',
            value: 15
          },
          lCarnitine: {
            unit: 'mg',
            value: 12
          },
          osmolality: {
            unit: 'mOsm/kg H2O',
            value: 385
          },
          osmolarity: {
            unit: 'mOsm/litre',
            value: 305
          },
          water: {
            unit: 'g/100ml',
            value: 79.49
          },
          renalSoluteLoad: {
            unit: 'mOsm/litre',
            value: 577
          }
        }
      },
      {
        id: 22,
        name: 'Osmolite®',
        volume: '100 mL',
        volumeOffset: 100,
        typeofcategory: 'Serving',
        macroNutrients: {
          energy: {
            kj: {
              value: 424,
              unit: 'kJ'
            },
            kcal: {
              value: 101,
              unit: 'kcal'
            }
          },
          protein: {
            value: 4.0,
            unit: 'g'
          },
          carbohydrate: {
            value: 13.56,
            unit: 'g',
            ofWhichSugars: {
              value: 0.6,
              unit: 'g'
            }
          },
          fat: {
            value: 3.4,
            unit: 'g',
            ofWhichSaturates: {
              value: 0.85,
              unit: 'g'
            }
          },
          cahmb: {
            value: 'N/A',
            unit: 'g'
          },
          salt: {
            value: 0.22,
            unit: 'g'
          },
          fibre: {
            value: 0,
            unit: 'g',
            ofWhichFos: {
              value: 0,
              unit: 'g'
            }
          }
        },
        vitamins: {
          vitaminAre: {
            unit: 'mcg',
            value: 108,
            ofWhichBCaroteneRE: {
              unit: 'mcg',
              value: 0
            }
          },
          vitaminD: {
            unit: 'mcg',
            value: 0.73
          },
          vitaminE: {
            unit: 'mg',
            value: 2.1
          },
          vitaminC: {
            unit: 'mg',
            value: 10
          },
          thiaminVitaminB1: {
            unit: 'mg',
            value: 0.16
          },
          riboflavinVitaminB2: {
            unit: 'mg',
            value: 0.18
          },
          niacin: {
            unit: 'mg',
            value: 1.7
          },
          vitaminB6: {
            unit: 'mg',
            value: 0.22
          },
          folate: {
            unit: 'mcg',
            value: 39.1
          },
          folacin: {
            unit: 'mcg',
            value: 23
          },
          vitaminB12: {
            title: 'Vitamin B12',
            unit: 'mcg',
            value: 0.34
          },
          biotin: {
            unit: 'mcg',
            value: 4.6
          },
          panthothenicAcid: {
            title: 'Pantothenic acid',
            unit: 'mg',
            value: 0.78
          },
          vitaminK: {
            title: 'Vitamin K',
            unit: 'mcg',
            value: 5.2
          }
        },
        minerals: {
          sodium: {
            unit: 'mg',
            value: 88
          },
          calcium: {
            unit: 'mg',
            value: 68
          },
          phosphate: {
            unit: 'mg',
            value: 68
          },
          iron: {
            unit: 'mg',
            value: 1.4
          },
          magnesium: {
            unit: 'mg',
            value: 20
          },
          zinc: {
            unit: 'mg',
            value: 1.3
          },
          iodine: {
            unit: 'mcg',
            value: 11
          },
          potassium: {
            unit: 'mg',
            value: 148
          },
          chloride: {
            unit: 'mg',
            value: 136
          },
          copper: {
            unit: 'mg',
            value: 0.17
          },
          manganese: {
            unit: 'mg',
            value: 0.38
          },
          selenium: {
            unit: 'mcg',
            value: 6.0
          },
          chromium: {
            unit: 'mcg',
            value: 6.5
          },
          molybdenum: {
            unit: 'mcg',
            value: 12
          },
          choline: {
            unit: 'mg',
            value: 56
          },
          taurine: {
            unit: 'mg',
            value: 'N/A'
          },
          lCarnitine: {
            unit: 'mg',
            value: 'N/A'
          },
          osmolality: {
            unit: 'mOsm/kg H2O',
            value: 288
          },
          osmolarity: {
            unit: 'mOsm/litre',
            value: 244
          },
          water: {
            unit: 'g/100ml',
            value: 84.9
          },
          renalSoluteLoad: {
            unit: 'mOsm/litre',
            value: 342
          }
        }
      },
      {
        id: 23,
        name: 'Osmolite® Plus',
        volume: '100 mL',
        volumeOffset: 100,
        typeofcategory: 'Serving',
        macroNutrients: {
          energy: {
            kj: {
              value: 508,
              unit: 'kJ'
            },
            kcal: {
              value: 121,
              unit: 'kcal'
            }
          },
          protein: {
            value: 5.55,
            unit: 'g'
          },
          carbohydrate: {
            value: 15.75,
            unit: 'g',
            ofWhichSugars: {
              value: 0.42,
              unit: 'g'
            }
          },
          fat: {
            value: 3.93,
            unit: 'g',
            ofWhichSaturates: {
              value: 1.0,
              unit: 'g'
            }
          },
          cahmb: {
            value: 'N/A',
            unit: 'g'
          },
          salt: {
            value: 0.34,
            unit: 'g'
          },
          fibre: {
            value: 0,
            unit: 'g',
            ofWhichFos: {
              value: 0,
              unit: 'g'
            }
          }
        },
        vitamins: {
          vitaminAre: {
            unit: 'mcg',
            value: 84,
            ofWhichBCaroteneRE: {
              unit: 'mcg',
              value: 33
            }
          },
          vitaminD: {
            unit: 'mcg',
            value: 1.0
          },
          vitaminE: {
            unit: 'mg',
            value: 2.4
          },
          vitaminC: {
            unit: 'mg',
            value: 12
          },
          thiaminVitaminB1: {
            unit: 'mg',
            value: 0.23
          },
          riboflavinVitaminB2: {
            unit: 'mg',
            value: 0.26
          },
          niacin: {
            unit: 'mg',
            value: 2.1
          },
          vitaminB6: {
            unit: 'mg',
            value: 0.3
          },
          folate: {
            unit: 'mcg',
            value: 47.6
          },
          folacin: {
            unit: 'mcg',
            value: 28
          },
          vitaminB12: {
            title: 'Vitamin B12',
            unit: 'mcg',
            value: 0.46
          },
          biotin: {
            unit: 'mcg',
            value: 6.0
          },
          panthothenicAcid: {
            title: 'Pantothenic acid',
            unit: 'mg',
            value: 1.0
          },
          vitaminK: {
            title: 'Vitamin K',
            unit: 'mcg',
            value: 8.0
          }
        },
        minerals: {
          sodium: {
            unit: 'mg',
            value: 134
          },
          calcium: {
            unit: 'mg',
            value: 83
          },
          phosphate: {
            unit: 'mg',
            value: 80
          },
          iron: {
            unit: 'mg',
            value: 1.8
          },
          magnesium: {
            unit: 'mg',
            value: 24
          },
          zinc: {
            unit: 'mg',
            value: 1.5
          },
          iodine: {
            unit: 'mcg',
            value: 15
          },
          potassium: {
            unit: 'mg',
            value: 181
          },
          chloride: {
            unit: 'mg',
            value: 154
          },
          copper: {
            unit: 'mg',
            value: 0.2
          },
          manganese: {
            unit: 'mg',
            value: 0.4
          },
          selenium: {
            unit: 'mcg',
            value: 7.5
          },
          chromium: {
            unit: 'mcg',
            value: 9.0
          },
          molybdenum: {
            unit: 'mcg',
            value: 14
          },
          choline: {
            unit: 'mg',
            value: 60
          },
          taurine: {
            unit: 'mg',
            value: 15
          },
          lCarnitine: {
            unit: 'mg',
            value: 9.5
          },
          osmolality: {
            unit: 'mOsm/kg H2O',
            value: 359
          },
          osmolarity: {
            unit: 'mOsm/litre',
            value: 293
          },
          water: {
            unit: 'g/100ml',
            value: 81.8
          },
          renalSoluteLoad: {
            unit: 'mOsm/litre',
            value: 464
          }
        }
      },
      {
        id: 24,
        name: 'Osmolite® 1.5kcal',
        volume: '100 mL',
        volumeOffset: 100,
        typeofcategory: 'Serving',
        macroNutrients: {
          energy: {
            kj: {
              value: 634,
              unit: 'kJ'
            },
            kcal: {
              value: 151,
              unit: 'kcal'
            }
          },
          protein: {
            value: 6.27,
            unit: 'g'
          },
          carbohydrate: {
            value: 20.36,
            unit: 'g',
            ofWhichSugars: {
              value: 1.15,
              unit: 'g'
            }
          },
          fat: {
            value: 4.91,
            unit: 'g',
            ofWhichSaturates: {
              value: 1.3,
              unit: 'g'
            }
          },
          cahmb: {
            value: 'N/A',
            unit: 'g'
          },
          salt: {
            value: 0.35,
            unit: 'g'
          },
          fibre: {
            value: 0,
            unit: 'g',
            ofWhichFos: {
              value: 0,
              unit: 'g'
            }
          }
        },
        vitamins: {
          vitaminAre: {
            unit: 'mcg',
            value: 159.5,
            ofWhichBCaroteneRE: {
              unit: 'mcg',
              value: 34.5
            }
          },
          vitaminD: {
            unit: 'mcg',
            value: 1.0
          },
          vitaminE: {
            unit: 'mg',
            value: 2.6
          },
          vitaminC: {
            unit: 'mg',
            value: 13
          },
          thiaminVitaminB1: {
            unit: 'mg',
            value: 0.26
          },
          riboflavinVitaminB2: {
            unit: 'mg',
            value: 0.34
          },
          niacin: {
            unit: 'mg',
            value: 2.9
          },
          vitaminB6: {
            unit: 'mg',
            value: 0.39
          },
          folate: {
            unit: 'mcg',
            value: 68
          },
          folacin: {
            unit: 'mcg',
            value: 40
          },
          vitaminB12: {
            title: 'Vitamin B12',
            unit: 'mcg',
            value: 0.4
          },
          biotin: {
            unit: 'mcg',
            value: 7.2
          },
          panthothenicAcid: {
            title: 'Pantothenic acid',
            unit: 'mg',
            value: 1.3
          },
          vitaminK: {
            title: 'Vitamin K',
            unit: 'mcg',
            value: 8.0
          }
        },
        minerals: {
          sodium: {
            unit: 'mg',
            value: 140
          },
          calcium: {
            unit: 'mg',
            value: 100
          },
          phosphate: {
            unit: 'mg',
            value: 100
          },
          iron: {
            unit: 'mg',
            value: 2.2
          },
          magnesium: {
            unit: 'mg',
            value: 31
          },
          zinc: {
            unit: 'mg',
            value: 1.9
          },
          iodine: {
            unit: 'mcg',
            value: 15
          },
          potassium: {
            unit: 'mg',
            value: 165
          },
          chloride: {
            unit: 'mg',
            value: 145
          },
          copper: {
            unit: 'mg',
            value: 0.25
          },
          manganese: {
            unit: 'mg',
            value: 0.5
          },
          selenium: {
            unit: 'mcg',
            value: 7.0
          },
          chromium: {
            unit: 'mcg',
            value: 10.0
          },
          molybdenum: {
            unit: 'mcg',
            value: 15
          },
          choline: {
            unit: 'mg',
            value: 60
          },
          taurine: {
            unit: 'mg',
            value: 15
          },
          lCarnitine: {
            unit: 'mg',
            value: 12
          },
          osmolality: {
            unit: 'mOsm/kg H2O',
            value: 510
          },
          osmolarity: {
            unit: 'mOsm/litre',
            value: 392
          },
          water: {
            unit: 'g/100ml',
            value: 77.16
          },
          renalSoluteLoad: {
            unit: 'mOsm/litre',
            value: 501
          }
        }
      },
      {
        id: 25,
        name: 'Osmolite® HP',
        volume: '100 mL',
        volumeOffset: 100,
        typeofcategory: 'Serving',
        macroNutrients: {
          energy: {
            kj: {
              value: 424,
              unit: 'kJ'
            },
            kcal: {
              value: 100,
              unit: 'kcal'
            }
          },
          protein: {
            value: 6.26,
            unit: 'g'
          },
          carbohydrate: {
            value: 13.0,
            unit: 'g',
            ofWhichSugars: {
              value: 1.4,
              unit: 'g'
            }
          },
          fat: {
            value: 2.6,
            unit: 'g',
            ofWhichSaturates: {
              value: 0.7,
              unit: 'g'
            }
          },
          cahmb: {
            value: 'N/A',
            unit: 'g'
          },
          salt: {
            value: 0.23,
            unit: 'g'
          },
          fibre: {
            value: 0,
            unit: 'g',
            ofWhichFos: {
              value: 0,
              unit: 'g'
            }
          }
        },
        vitamins: {
          vitaminAre: {
            unit: 'mcg',
            value: 212,
            ofWhichBCaroteneRE: {
              unit: 'mcg',
              value: 0
            }
          },
          vitaminD: {
            unit: 'mcg',
            value: 0.8
          },
          vitaminE: {
            unit: 'mg',
            value: 2.1
          },
          vitaminC: {
            unit: 'mg',
            value: 43
          },
          thiaminVitaminB1: {
            unit: 'mg',
            value: 0.18
          },
          riboflavinVitaminB2: {
            unit: 'mg',
            value: 0.2
          },
          niacin: {
            unit: 'mg',
            value: 1.9
          },
          vitaminB6: {
            unit: 'mg',
            value: 0.18
          },
          folate: {
            unit: 'mcg',
            value: 34
          },
          folacin: {
            unit: 'mcg',
            value: 20
          },
          vitaminB12: {
            title: 'Vitamin B12',
            unit: 'mcg',
            value: 0.31
          },
          biotin: {
            unit: 'mcg',
            value: 3.3
          },
          panthothenicAcid: {
            title: 'Pantothenic acid',
            unit: 'mg',
            value: 0.6
          },
          vitaminK: {
            title: 'Vitamin K',
            unit: 'mcg',
            value: 6.4
          }
        },
        minerals: {
          sodium: {
            unit: 'mg',
            value: 92
          },
          calcium: {
            unit: 'mg',
            value: 72
          },
          phosphate: {
            unit: 'mg',
            value: 67
          },
          iron: {
            unit: 'mg',
            value: 1.4
          },
          magnesium: {
            unit: 'mg',
            value: 17
          },
          zinc: {
            unit: 'mg',
            value: 2.6
          },
          iodine: {
            unit: 'mcg',
            value: 12
          },
          potassium: {
            unit: 'mg',
            value: 200
          },
          chloride: {
            unit: 'mg',
            value: 126
          },
          copper: {
            unit: 'mg',
            value: 0.16
          },
          manganese: {
            unit: 'mg',
            value: 0.35
          },
          selenium: {
            unit: 'mcg',
            value: 6.0
          },
          chromium: {
            unit: 'mcg',
            value: 6.8
          },
          molybdenum: {
            unit: 'mcg',
            value: 12
          },
          choline: {
            unit: 'mg',
            value: 48
          },
          taurine: {
            unit: 'mg',
            value: 12
          },
          lCarnitine: {
            unit: 'mg',
            value: 8.0
          },
          osmolality: {
            unit: 'mOsm/kg H2O',
            value: 319
          },
          osmolarity: {
            unit: 'mOsm/litre',
            value: 269
          },
          water: {
            unit: 'g/100ml',
            value: 84.6
          },
          renalSoluteLoad: {
            unit: 'mOsm/litre',
            value: 484
          }
        }
      },
      {
        id: 26,
        name: 'TwoCal®',
        volume: '100 mL',
        volumeOffset: 100,
        typeofcategory: 'Serving',
        macroNutrients: {
          energy: {
            kj: {
              value: 837,
              unit: 'kJ'
            },
            kcal: {
              value: 200,
              unit: 'kcal'
            }
          },
          protein: {
            value: 8.4,
            unit: 'g'
          },
          carbohydrate: {
            value: 21.0,
            unit: 'g',
            ofWhichSugars: {
              value: 4.65,
              unit: 'g'
            }
          },
          fat: {
            value: 8.9,
            unit: 'g',
            ofWhichSaturates: {
              value: 0.85,
              unit: 'g'
            }
          },
          cahmb: {
            value: 'N/A',
            unit: 'g'
          },
          salt: {
            value: 0.33,
            unit: 'g'
          },
          fibre: {
            value: 1.0,
            unit: 'g',
            ofWhichFos: {
              value: 1.0,
              unit: 'g'
            }
          }
        },
        vitamins: {
          vitaminAre: {
            unit: 'mcg',
            value: 158,
            ofWhichBCaroteneRE: {
              unit: 'mcg',
              value: 0
            }
          },
          vitaminD: {
            unit: 'mcg',
            value: 1.7
          },
          vitaminE: {
            unit: 'mg',
            value: 3.4
          },
          vitaminC: {
            unit: 'mg',
            value: 20
          },
          thiaminVitaminB1: {
            unit: 'mg',
            value: 0.3
          },
          riboflavinVitaminB2: {
            unit: 'mg',
            value: 0.29
          },
          niacin: {
            unit: 'mg',
            value: 3.4
          },
          vitaminB6: {
            unit: 'mg',
            value: 0.34
          },
          folate: {
            unit: 'mcg',
            value: 81.6
          },
          folacin: {
            unit: 'mcg',
            value: 48
          },
          vitaminB12: {
            title: 'Vitamin B12',
            unit: 'mcg',
            value: 0.64
          },
          biotin: {
            unit: 'mcg',
            value: 8.0
          },
          panthothenicAcid: {
            title: 'Pantothenic acid',
            unit: 'mg',
            value: 1.6
          },
          vitaminK: {
            title: 'Vitamin K',
            unit: 'mcg',
            value: 8.5
          }
        },
        minerals: {
          sodium: {
            unit: 'mg',
            value: 130
          },
          calcium: {
            unit: 'mg',
            value: 150
          },
          phosphate: {
            unit: 'mg',
            value: 120
          },
          iron: {
            unit: 'mg',
            value: 2.1
          },
          magnesium: {
            unit: 'mg',
            value: 40
          },
          zinc: {
            unit: 'mg',
            value: 2.4
          },
          iodine: {
            unit: 'mcg',
            value: 16
          },
          potassium: {
            unit: 'mg',
            value: 200
          },
          chloride: {
            unit: 'mg',
            value: 180
          },
          copper: {
            unit: 'mg',
            value: 0.24
          },
          manganese: {
            unit: 'mg',
            value: 0.55
          },
          selenium: {
            unit: 'mcg',
            value: 9.0
          },
          chromium: {
            unit: 'mcg',
            value: 10
          },
          molybdenum: {
            unit: 'mcg',
            value: 16
          },
          choline: {
            unit: 'mg',
            value: 63
          },
          taurine: {
            unit: 'mg',
            value: 16
          },
          lCarnitine: {
            unit: 'mg',
            value: 16
          },
          osmolality: {
            unit: 'mOsm/kg H2O',
            value: 800
          },
          osmolarity: {
            unit: 'mOsm/litre',
            value: 560
          },
          water: {
            unit: 'g/100ml',
            value: 70.3
          },
          renalSoluteLoad: {
            unit: 'mOsm/litre',
            value: 637
          }
        }
      },
      {
        id: 27,
        name: 'TwoCal® Bolus',
        volume: '200 mL bottle',
        volumeOffset: 200,
        typeofcategory: 'Serving',
        macroNutrients: {
          energy: {
            kj: {
              value: 1674,
              unit: 'kJ'
            },
            kcal: {
              value: 399,
              unit: 'kcal'
            }
          },
          protein: {
            value: 16.8,
            unit: 'g'
          },
          carbohydrate: {
            value: 42,
            unit: 'g',
            ofWhichSugars: {
              value: 9.3,
              unit: 'g'
            }
          },
          fat: {
            value: 17.8,
            unit: 'g',
            ofWhichSaturates: {
              value: 1.7,
              unit: 'g'
            }
          },
          cahmb: {
            value: 'N/A',
            unit: 'g'
          },
          salt: {
            value: 0.66,
            unit: 'g'
          },
          fibre: {
            value: 2.0,
            unit: 'g',
            ofWhichFos: {
              value: 2.0,
              unit: 'g'
            }
          }
        },
        vitamins: {
          vitaminAre: {
            unit: 'mcg',
            value: 316,
            ofWhichBCaroteneRE: {
              unit: 'mcg',
              value: 0
            }
          },
          vitaminD: {
            unit: 'mcg',
            value: 3.4
          },
          vitaminE: {
            unit: 'mg',
            value: 6.8
          },
          vitaminC: {
            unit: 'mg',
            value: 40
          },
          thiaminVitaminB1: {
            unit: 'mg',
            value: 0.6
          },
          riboflavinVitaminB2: {
            unit: 'mg',
            value: 0.58
          },
          niacin: {
            unit: 'mg',
            value: 6.8
          },
          vitaminB6: {
            unit: 'mg',
            value: 0.68
          },
          folate: {
            unit: 'mcg',
            value: 163.2
          },
          folacin: {
            unit: 'mcg',
            value: 96
          },
          vitaminB12: {
            title: 'Vitamin B12',
            unit: 'mcg',
            value: 1.28
          },
          biotin: {
            unit: 'mcg',
            value: 16.0
          },
          panthothenicAcid: {
            title: 'Pantothenic acid',
            unit: 'mg',
            value: 3.2
          },
          vitaminK: {
            title: 'Vitamin K',
            unit: 'mcg',
            value: 17
          }
        },
        minerals: {
          sodium: {
            unit: 'mg',
            value: 260
          },
          calcium: {
            unit: 'mg',
            value: 300
          },
          phosphate: {
            unit: 'mg',
            value: 240
          },
          iron: {
            unit: 'mg',
            value: 4.2
          },
          magnesium: {
            unit: 'mg',
            value: 80
          },
          zinc: {
            unit: 'mg',
            value: 4.8
          },
          iodine: {
            unit: 'mcg',
            value: 32
          },
          potassium: {
            unit: 'mg',
            value: 400
          },
          chloride: {
            unit: 'mg',
            value: 360
          },
          copper: {
            unit: 'mg',
            value: 0.48
          },
          manganese: {
            unit: 'mg',
            value: 1.1
          },
          selenium: {
            unit: 'mcg',
            value: 18
          },
          chromium: {
            unit: 'mcg',
            value: 20
          },
          molybdenum: {
            unit: 'mcg',
            value: 32
          },
          choline: {
            unit: 'mg',
            value: 126
          },
          taurine: {
            unit: 'mg',
            value: 32
          },
          lCarnitine: {
            unit: 'mg',
            value: 32
          },
          osmolality: {
            unit: 'mOsm/kg H2O',
            value: 800
          },
          osmolarity: {
            unit: 'mOsm/litre',
            value: 560
          },
          water: {
            unit: 'g/100ml',
            value: 70.3
          },
          renalSoluteLoad: {
            unit: 'mOsm/litre',
            value: 637
          }
        }
      }
    ]
  },
  {
    title: 'PAEDIATRIC SIP FEEDS AND TUBE FEEDS',
    products: [
      {
        id: 28,
        name: 'PaediaSure®',
        volume: '100 mL tube feed',
        volumeOffset: 100,
        typeofcategory: 'Serving',
        macroNutrients: {
          energy: {
            kj: { value: 422, unit: 'kJ' },
            kcal: { value: 101, unit: 'kcal' }
          },
          protein: { value: 2.8, unit: 'g' },
          carbohydrate: {
            value: 11.16,
            unit: 'g',
            ofWhichSugars: { value: 3.7, unit: 'g' }
          },
          fat: {
            value: 4.98,
            unit: 'g',
            ofWhichSaturates: { value: 1.3, unit: 'g' }
          },
          cahmb: {
            value: 'N/A',
            unit: 'g'
          },
          salt: { value: 0.15, unit: 'g' },
          fibre: {
            value: 0,
            unit: 'g',
            ofWhichFos: { value: 0, unit: 'g' }
          }
        },
        vitamins: {
          vitaminAre: {
            unit: 'mcg',
            value: 45,
            ofWhichBCaroteneRE: {
              unit: 'mcg',
              value: 0
            }
          },
          vitaminD: {
            unit: 'mcg',
            value: 1.0
          },
          vitaminE: {
            unit: 'mg',
            value: 1.5
          },
          vitaminC: {
            unit: 'mg',
            value: 5.0
          },
          thiaminVitaminB1: {
            unit: 'mg',
            value: 0.15
          },
          riboflavinVitaminB2: {
            unit: 'mg',
            value: 0.2
          },
          niacin: {
            unit: 'mg',
            value: 1.2
          },
          vitaminB6: {
            unit: 'mg',
            value: 0.1
          },
          folate: {
            unit: 'mcg',
            value: 25.5
          },
          folacin: {
            unit: 'mcg',
            value: 15
          },
          vitaminB12: {
            title: 'Vitamin B12',
            unit: 'mcg',
            value: 0.2
          },
          biotin: {
            unit: 'mcg',
            value: 5.0
          },
          panthothenicAcid: {
            title: 'Pantothenic acid',
            unit: 'mg',
            value: 0.3
          },
          vitaminK: {
            title: 'Vitamin K',
            unit: 'mcg',
            value: 4.0
          }
        },
        minerals: {
          sodium: {
            unit: 'mg',
            value: 60
          },
          calcium: {
            unit: 'mg',
            value: 56
          },
          phosphate: {
            unit: 'mg',
            value: 53
          },
          iron: {
            unit: 'mg',
            value: 1.0
          },
          magnesium: {
            unit: 'mg',
            value: 16
          },
          zinc: {
            unit: 'mg',
            value: 1.0
          },
          iodine: {
            unit: 'mcg',
            value: 10
          },
          potassium: {
            unit: 'mg',
            value: 110
          },
          chloride: {
            unit: 'mg',
            value: 100
          },
          copper: {
            unit: 'mg',
            value: 0.1
          },
          manganese: {
            unit: 'mg',
            value: 0.1
          },
          selenium: {
            unit: 'mcg',
            value: 2.8
          },
          chromium: {
            unit: 'mcg',
            value: 2.5
          },
          molybdenum: {
            unit: 'mcg',
            value: 4.0
          },
          choline: {
            unit: 'mg',
            value: 15
          },
          taurine: {
            unit: 'mg',
            value: 7.2
          },
          lCarnitine: {
            unit: 'mg',
            value: 1.7
          },
          osmolality: {
            unit: 'mOsm/kg H2O',
            value: 320
          },
          osmolarity: {
            unit: 'mOsm/litre',
            value: 273
          },
          water: {
            unit: 'g/100ml',
            value: 85.4
          },
          renalSoluteLoad: {
            unit: 'mOsm/litre',
            value: 259
          }
        }
      },
      {
        id: 29,
        name: 'PaediaSure®',
        volume: '200 mL sip feed',
        volumeOffset: 200,
        typeofcategory: 'Bottle',
        macroNutrients: {
          energy: {
            kj: { value: 843, unit: 'kJ' },
            kcal: { value: 201, unit: 'kcal' }
          },
          protein: { value: 5.6, unit: 'g' },
          carbohydrate: {
            value: 22,
            unit: 'g',
            ofWhichSugars: { value: 7.4, unit: 'g' }
          },
          fat: {
            value: 10,
            unit: 'g',
            ofWhichSaturates: { value: 2.6, unit: 'g' }
          },
          cahmb: {
            value: 'N/A',
            unit: 'g'
          },
          salt: { value: 0.3, unit: 'g' },
          fibre: {
            value: 0,
            unit: 'g',
            ofWhichFos: { value: 0, unit: 'g' }
          }
        },
        vitamins: {
          vitaminAre: {
            unit: 'mcg',
            value: 90,
            ofWhichBCaroteneRE: {
              unit: 'mcg',
              value: 0
            }
          },
          vitaminD: {
            unit: 'mcg',
            value: 2.0
          },
          vitaminE: {
            unit: 'mg',
            value: 3.0
          },
          vitaminC: {
            unit: 'mg',
            value: 10
          },
          thiaminVitaminB1: {
            unit: 'mg',
            value: 0.3
          },
          riboflavinVitaminB2: {
            unit: 'mg',
            value: 0.4
          },
          niacin: {
            unit: 'mg',
            value: 2.4
          },
          vitaminB6: {
            unit: 'mg',
            value: 0.2
          },
          folate: {
            unit: 'mcg',
            value: 51
          },
          folacin: {
            unit: 'mcg',
            value: 30
          },
          vitaminB12: {
            title: 'Vitamin B12',
            unit: 'mcg',
            value: 0.4
          },
          biotin: {
            unit: 'mcg',
            value: 10
          },
          panthothenicAcid: {
            title: 'Pantothenic acid',
            unit: 'mg',
            value: 0.6
          },
          vitaminK: {
            title: 'Vitamin K',
            unit: 'mcg',
            value: 8.0
          }
        },
        minerals: {
          sodium: {
            unit: 'mg',
            value: 120
          },
          calcium: {
            unit: 'mg',
            value: 112
          },
          phosphate: {
            unit: 'mg',
            value: 106
          },
          iron: {
            unit: 'mg',
            value: 2.0
          },
          magnesium: {
            unit: 'mg',
            value: 32
          },
          zinc: {
            unit: 'mg',
            value: 2.0
          },
          iodine: {
            unit: 'mcg',
            value: 20
          },
          potassium: {
            unit: 'mg',
            value: 220
          },
          chloride: {
            unit: 'mg',
            value: 200
          },
          copper: {
            unit: 'mg',
            value: 0.2
          },
          manganese: {
            unit: 'mg',
            value: 0.2
          },
          selenium: {
            unit: 'mcg',
            value: 5.6
          },
          chromium: {
            unit: 'mcg',
            value: 5.0
          },
          molybdenum: {
            unit: 'mcg',
            value: 8.0
          },
          choline: {
            unit: 'mg',
            value: 30
          },
          taurine: {
            unit: 'mg',
            value: 14
          },
          lCarnitine: {
            unit: 'mg',
            value: 3.4
          },
          osmolality: {
            unit: 'mOsm/kg H2O',
            value: 320
          },
          osmolarity: {
            unit: 'mOsm/litre',
            value: 273
          },
          water: {
            unit: 'g/100ml',
            value: 85.4
          },
          renalSoluteLoad: {
            unit: 'mOsm/litre',
            value: 259
          }
        }
      },
      {
        id: 30,
        name: 'PaediaSure® Fibre',
        volume: '100 mL tube feed',
        volumeOffset: 100,
        typeofcategory: 'Serving',
        macroNutrients: {
          energy: {
            kj: { value: 424, unit: 'kJ' },
            kcal: { value: 101, unit: 'kcal' }
          },
          protein: { value: 2.8, unit: 'g' },
          carbohydrate: {
            value: 10.93,
            unit: 'g',
            ofWhichSugars: { value: 3.75, unit: 'g' }
          },
          fat: {
            value: 4.98,
            unit: 'g',
            ofWhichSaturates: { value: 1.3, unit: 'g' }
          },
          fibre: {
            value: 0.73,
            unit: 'g',
            ofWhichFos: { value: 0.23, unit: 'g' }
          },
          cahmb: {
            value: 'N/A',
            unit: 'g'
          },
          salt: { value: 0.15, unit: 'g' }
        },
        vitamins: {
          vitaminAre: {
            unit: 'mcg',
            value: 45,
            ofWhichBCaroteneRE: {
              unit: 'mcg',
              value: 0
            }
          },
          vitaminD: {
            unit: 'mcg',
            value: 1.0
          },
          vitaminE: {
            unit: 'mg',
            value: 1.5
          },
          vitaminK: {
            title: 'Vitamin K',
            unit: 'mcg',
            value: 4.0
          },
          vitaminC: {
            unit: 'mg',
            value: 5.0
          },
          folate: {
            unit: 'mcg',
            value: 25.5
          },
          folacin: {
            unit: 'mcg',
            value: 15
          },
          thiaminVitaminB1: {
            unit: 'mg',
            value: 0.15
          },
          riboflavinVitaminB2: {
            unit: 'mg',
            value: 0.2
          },
          vitaminB6: {
            unit: 'mg',
            value: 0.1
          },
          vitaminB12: {
            title: 'Vitamin B12',
            unit: 'mcg',
            value: 0.2
          },
          niacin: {
            unit: 'mg',
            value: 1.2
          },
          panthothenicAcid: {
            title: 'Pantothenic acid',
            unit: 'mg',
            value: 0.3
          },
          biotin: {
            unit: 'mcg',
            value: 5.0
          }
        },
        minerals: {
          sodium: {
            unit: 'mg',
            value: 60
          },
          potassium: {
            unit: 'mg',
            value: 110
          },
          chloride: {
            unit: 'mg',
            value: 100
          },
          calcium: {
            unit: 'mg',
            value: 56
          },
          phosphate: {
            unit: 'mg',
            value: 53
          },
          iron: {
            unit: 'mg',
            value: 1.0
          },
          zinc: {
            unit: 'mg',
            value: 1.0
          },
          manganese: {
            unit: 'mg',
            value: 0.1
          },
          iodine: {
            unit: 'mcg',
            value: 10.0
          },
          selenium: {
            unit: 'mcg',
            value: 2.8
          },
          choline: {
            unit: 'mg',
            value: 15
          },
          copper: {
            unit: 'mg',
            value: 0.1
          },
          magnesium: {
            unit: 'mg',
            value: 16
          },
          chromium: {
            unit: 'mcg',
            value: 2.5
          },
          molybdenum: {
            unit: 'mcg',
            value: 4.0
          },
          taurine: {
            unit: 'mg',
            value: 7.2
          },
          lCarnitine: {
            unit: 'mg',
            value: 1.7
          },
          osmolality: {
            unit: 'mOsm/kg H2O',
            value: 340
          },
          osmolarity: {
            unit: 'mOsm/litre',
            value: 289
          },
          water: {
            unit: 'g/100ml',
            value: 85.2
          },
          renalSoluteLoad: {
            unit: 'mOsm/litre',
            value: 259
          }
        }
      },
      {
        id: 31,
        name: 'PaediaSure® Fibre',
        volume: '200 mL sip feed',
        volumeOffset: 200,
        typeofcategory: 'Bottle',
        macroNutrients: {
          energy: {
            kj: { value: 847, unit: 'kJ' },
            kcal: { value: 202, unit: 'kcal' }
          },
          protein: { value: 5.6, unit: 'g' },
          carbohydrate: {
            value: 21.86,
            unit: 'g',
            ofWhichSugars: { value: 7.5, unit: 'g' }
          },
          fat: {
            value: 9.96,
            unit: 'g',
            ofWhichSaturates: { value: 2.6, unit: 'g' }
          },
          fibre: {
            value: 1.46,
            unit: 'g',
            ofWhichFos: { value: 0.46, unit: 'g' }
          },
          cahmb: {
            value: 'N/A',
            unit: 'g'
          },
          salt: { value: 0.3, unit: 'g' }
        },
        vitamins: {
          vitaminAre: {
            unit: 'mcg',
            value: 90,
            ofWhichBCaroteneRE: {
              unit: 'mcg',
              value: 0
            }
          },
          vitaminD: {
            unit: 'mcg',
            value: 2.0
          },
          vitaminE: {
            unit: 'mg',
            value: 3.0
          },
          vitaminK: {
            title: 'Vitamin K',
            unit: 'mcg',
            value: 8.0
          },
          vitaminC: {
            unit: 'mg',
            value: 10.0
          },
          folate: {
            unit: 'mcg',
            value: 51
          },
          folacin: {
            unit: 'mcg',
            value: 30
          },
          thiaminVitaminB1: {
            unit: 'mg',
            value: 0.3
          },
          riboflavinVitaminB2: {
            unit: 'mg',
            value: 0.4
          },
          vitaminB6: {
            unit: 'mg',
            value: 0.2
          },
          vitaminB12: {
            title: 'Vitamin B12',
            unit: 'mcg',
            value: 0.4
          },
          niacin: {
            unit: 'mg',
            value: 2.4
          },
          panthothenicAcid: {
            title: 'Pantothenic acid',
            unit: 'mg',
            value: 0.6
          },
          biotin: {
            unit: 'mcg',
            value: 10.0
          }
        },
        minerals: {
          sodium: {
            unit: 'mg',
            value: 120
          },
          potassium: {
            unit: 'mg',
            value: 220
          },
          chloride: {
            unit: 'mg',
            value: 200
          },
          calcium: {
            unit: 'mg',
            value: 112
          },
          phosphate: {
            unit: 'mg',
            value: 106
          },
          iron: {
            unit: 'mg',
            value: 2.0
          },
          zinc: {
            unit: 'mg',
            value: 2.0
          },
          manganese: {
            unit: 'mg',
            value: 0.2
          },
          iodine: {
            unit: 'mcg',
            value: 20
          },
          selenium: {
            unit: 'mcg',
            value: 5.6
          },
          choline: {
            unit: 'mg',
            value: 30
          },
          copper: {
            unit: 'mg',
            value: 0.2
          },
          magnesium: {
            unit: 'mg',
            value: 32
          },
          chromium: {
            unit: 'mcg',
            value: 5.0
          },
          molybdenum: {
            unit: 'mcg',
            value: 8.0
          },
          taurine: {
            unit: 'mg',
            value: 14
          },
          lCarnitine: {
            unit: 'mg',
            value: 3.4
          },
          osmolality: {
            unit: 'mOsm/kg H2O',
            value: 340
          },
          osmolarity: {
            unit: 'mOsm/litre',
            value: 289
          },
          water: {
            unit: 'g/100ml',
            value: 85.2
          },
          renalSoluteLoad: {
            unit: 'mOsm/litre',
            value: 259
          }
        }
      },
      {
        id: 32,
        name: 'PaediaSure® Plus',
        volume: '100 mL tube feed',
        volumeOffset: 100,
        typeofcategory: 'Serving',
        macroNutrients: {
          energy: {
            kj: { value: 632, unit: 'kJ' },
            kcal: { value: 151, unit: 'kcal' }
          },
          protein: { value: 4.2, unit: 'g' },
          carbohydrate: {
            value: 16.74,
            unit: 'g',
            ofWhichSugars: { value: 2.2, unit: 'g' }
          },
          fat: {
            value: 7.47,
            unit: 'g',
            ofWhichSaturates: { value: 2.0, unit: 'g' }
          },
          fibre: {
            value: 0,
            unit: 'g',
            ofWhichFos: { value: 0, unit: 'g' }
          },
          cahmb: {
            value: 'N/A',
            unit: 'g'
          },
          salt: { value: 0.15, unit: 'g' }
        },
        vitamins: {
          vitaminAre: {
            unit: 'mcg',
            value: 99,
            ofWhichBCaroteneRE: {
              unit: 'mcg',
              value: 0
            }
          },
          vitaminD: {
            unit: 'mcg',
            value: 1.1
          },
          vitaminE: {
            unit: 'mg',
            value: 1.5
          },
          vitaminK: {
            title: 'Vitamin K',
            unit: 'mcg',
            value: 5.9
          },
          vitaminC: {
            unit: 'mg',
            value: 7.5
          },
          folate: {
            unit: 'mcg',
            value: 39.1
          },
          folacin: {
            unit: 'mcg',
            value: 23
          },
          thiaminVitaminB1: {
            unit: 'mg',
            value: 0.23
          },
          riboflavinVitaminB2: {
            unit: 'mg',
            value: 0.3
          },
          vitaminB6: {
            unit: 'mg',
            value: 0.15
          },
          vitaminB12: {
            title: 'Vitamin B12',
            unit: 'mcg',
            value: 0.3
          },
          niacin: {
            unit: 'mg',
            value: 1.8
          },
          panthothenicAcid: {
            title: 'Pantothenic acid',
            unit: 'mg',
            value: 0.45
          },
          biotin: {
            unit: 'mcg',
            value: 7.5
          }
        },
        minerals: {
          sodium: {
            unit: 'mg',
            value: 60
          },
          potassium: {
            unit: 'mg',
            value: 135
          },
          chloride: {
            unit: 'mg',
            value: 100
          },
          calcium: {
            unit: 'mg',
            value: 84
          },
          phosphate: {
            unit: 'mg',
            value: 80
          },
          iron: {
            unit: 'mg',
            value: 1.5
          },
          zinc: {
            unit: 'mg',
            value: 1.5
          },
          manganese: {
            unit: 'mg',
            value: 0.15
          },
          iodine: {
            unit: 'mcg',
            value: 15
          },
          selenium: {
            unit: 'mcg',
            value: 4.2
          },
          choline: {
            unit: 'mg',
            value: 22.5
          },
          copper: {
            unit: 'mg',
            value: 0.17
          },
          magnesium: {
            unit: 'mg',
            value: 24
          },
          chromium: {
            unit: 'mcg',
            value: 3.8
          },
          molybdenum: {
            unit: 'mcg',
            value: 5.9
          },
          taurine: {
            unit: 'mg',
            value: 10.8
          },
          lCarnitine: {
            unit: 'mg',
            value: 2.6
          },
          osmolality: {
            unit: 'mOsm/kg H2O',
            value: 500
          },
          osmolarity: {
            unit: 'mOsm/litre',
            value: 273
          },
          water: {
            unit: 'g/100ml',
            value: 78.3
          },
          renalSoluteLoad: {
            unit: 'mOsm/litre',
            value: 354
          }
        }
      },
      {
        id: 33,
        name: 'PaediaSure® Plus',
        volume: '200 mL sip feed',
        volumeOffset: 200,
        typeofcategory: 'Bottle',
        macroNutrients: {
          energy: {
            kj: { value: 1265, unit: 'kJ' },
            kcal: { value: 302, unit: 'kcal' }
          },
          protein: { value: 8.4, unit: 'g' },
          carbohydrate: {
            value: 33.5,
            unit: 'g',
            ofWhichSugars: { value: 11, unit: 'g' }
          },
          fat: {
            value: 14.9,
            unit: 'g',
            ofWhichSaturates: { value: 4.0, unit: 'g' }
          },
          fibre: {
            value: 0,
            unit: 'g',
            ofWhichFos: { value: 0, unit: 'g' }
          },
          cahmb: {
            value: 'N/A',
            unit: 'g'
          },
          salt: { value: 0.3, unit: 'g' }
        },
        vitamins: {
          vitaminAre: {
            unit: 'mcg',
            value: 198,
            ofWhichBCaroteneRE: {
              unit: 'mcg',
              value: 0
            }
          },
          vitaminD: {
            unit: 'mcg',
            value: 2.3
          },
          vitaminE: {
            unit: 'mg',
            value: 3.1
          },
          vitaminK: {
            title: 'Vitamin K',
            unit: 'mcg',
            value: 11.8
          },
          vitaminC: {
            unit: 'mg',
            value: 15
          },
          folate: {
            unit: 'mcg',
            value: 78.2
          },
          folacin: {
            unit: 'mcg',
            value: 46
          },
          thiaminVitaminB1: {
            unit: 'mg',
            value: 0.46
          },
          riboflavinVitaminB2: {
            unit: 'mg',
            value: 0.6
          },
          vitaminB6: {
            unit: 'mg',
            value: 0.3
          },
          vitaminB12: {
            title: 'Vitamin B12',
            unit: 'mcg',
            value: 0.6
          },
          niacin: {
            unit: 'mg',
            value: 3.6
          },
          panthothenicAcid: {
            title: 'Pantothenic acid',
            unit: 'mg',
            value: 0.9
          },
          biotin: {
            unit: 'mcg',
            value: 15
          }
        },
        minerals: {
          sodium: {
            unit: 'mg',
            value: 120
          },
          potassium: {
            unit: 'mg',
            value: 270
          },
          chloride: {
            unit: 'mg',
            value: 200
          },
          calcium: {
            unit: 'mg',
            value: 168
          },
          phosphate: {
            unit: 'mg',
            value: 160
          },
          iron: {
            unit: 'mg',
            value: 3.0
          },
          zinc: {
            unit: 'mg',
            value: 3.0
          },
          manganese: {
            unit: 'mg',
            value: 0.3
          },
          iodine: {
            unit: 'mcg',
            value: 30
          },
          selenium: {
            unit: 'mcg',
            value: 8.4
          },
          choline: {
            unit: 'mg',
            value: 46
          },
          copper: {
            unit: 'mg',
            value: 0.34
          },
          magnesium: {
            unit: 'mg',
            value: 48
          },
          chromium: {
            unit: 'mcg',
            value: 7.6
          },
          molybdenum: {
            unit: 'mcg',
            value: 11.8
          },
          taurine: {
            unit: 'mg',
            value: 22
          },
          lCarnitine: {
            unit: 'mg',
            value: 5.2
          },
          osmolality: {
            unit: 'mOsm/kg H2O',
            value: 500
          },
          osmolarity: {
            unit: 'mOsm/litre',
            value: 390
          },
          water: {
            unit: 'g/100ml',
            value: 78.3
          },
          renalSoluteLoad: {
            unit: 'mOsm/litre',
            value: 354
          }
        }
      },
      {
        id: 34,
        name: 'PaediaSure® Plus Fibre',
        volume: '100 mL tube feed',
        volumeOffset: 100,
        typeofcategory: 'Serving',
        macroNutrients: {
          energy: {
            kj: { value: 635, unit: 'kJ' },
            kcal: { value: 152, unit: 'kcal' }
          },
          protein: { value: 4.2, unit: 'g' },
          carbohydrate: {
            value: 16.39,
            unit: 'g',
            ofWhichSugars: { value: 5.5, unit: 'g' }
          },
          fat: {
            value: 7.47,
            unit: 'g',
            ofWhichSaturates: { value: 2.0, unit: 'g' }
          },
          fibre: {
            value: 1.1,
            unit: 'g',
            ofWhichFos: { value: 0.35, unit: 'g' }
          },
          cahmb: {
            value: 'N/A',
            unit: 'g'
          },
          salt: { value: 0.15, unit: 'g' }
        },
        vitamins: {
          vitaminAre: {
            unit: 'mcg',
            value: 99,
            ofWhichBCaroteneRE: {
              unit: 'mcg',
              value: 0
            }
          },
          vitaminD: {
            unit: 'mcg',
            value: 1.1
          },
          vitaminE: {
            unit: 'mg',
            value: 1.5
          },
          vitaminK: {
            title: 'Vitamin K',
            unit: 'mcg',
            value: 5.9
          },
          vitaminC: {
            unit: 'mg',
            value: 7.5
          },
          folate: {
            unit: 'mcg',
            value: 39.1
          },
          folacin: {
            unit: 'mcg',
            value: 23
          },
          thiaminVitaminB1: {
            unit: 'mg',
            value: 0.23
          },
          riboflavinVitaminB2: {
            unit: 'mg',
            value: 0.3
          },
          vitaminB6: {
            unit: 'mg',
            value: 0.15
          },
          vitaminB12: {
            title: 'Vitamin B12',
            unit: 'mcg',
            value: 0.3
          },
          niacin: {
            unit: 'mg',
            value: 1.8
          },
          panthothenicAcid: {
            title: 'Pantothenic acid',
            unit: 'mg',
            value: 0.45
          },
          biotin: {
            unit: 'mcg',
            value: 7.5
          }
        },
        minerals: {
          sodium: {
            unit: 'mg',
            value: 60
          },
          potassium: {
            unit: 'mg',
            value: 135
          },
          chloride: {
            unit: 'mg',
            value: 100
          },
          calcium: {
            unit: 'mg',
            value: 83
          },
          phosphate: {
            unit: 'mg',
            value: 80
          },
          iron: {
            unit: 'mg',
            value: 1.5
          },
          zinc: {
            unit: 'mg',
            value: 1.5
          },
          manganese: {
            unit: 'mg',
            value: 0.15
          },
          iodine: {
            unit: 'mcg',
            value: 15
          },
          selenium: {
            unit: 'mcg',
            value: 4.2
          },
          choline: {
            unit: 'mg',
            value: 22.5
          },
          molybdenum: {
            unit: 'mcg',
            value: 5.9
          },
          copper: {
            unit: 'mg',
            value: 0.17
          },
          magnesium: {
            unit: 'mg',
            value: 24
          },
          chromium: {
            unit: 'mcg',
            value: 3.8
          },
          taurine: {
            unit: 'mg',
            value: 11
          },
          lCarnitine: {
            unit: 'mg',
            value: 2.6
          },
          osmolality: {
            unit: 'mOsm/kg H2O',
            value: 500
          },
          osmolarity: {
            unit: 'mOsm/litre',
            value: 389
          },
          water: {
            unit: 'g/100ml',
            value: 78
          },
          renalSoluteLoad: {
            unit: 'mOsm/litre',
            value: 354
          }
        }
      },
      {
        id: 35,
        name: 'PaediaSure® Plus Fibre',
        volume: '200 mL sip feed',
        volumeOffset: 200,
        typeofcategory: 'Bottle',
        macroNutrients: {
          energy: {
            kj: { value: 1270, unit: 'kJ' },
            kcal: { value: 304, unit: 'kcal' }
          },
          protein: { value: 8.4, unit: 'g' },
          carbohydrate: {
            value: 32.78,
            unit: 'g',
            ofWhichSugars: { value: 11, unit: 'g' }
          },
          fat: {
            value: 14.94,
            unit: 'g',
            ofWhichSaturates: { value: 4.0, unit: 'g' }
          },
          fibre: {
            value: 2.2,
            unit: 'g',
            ofWhichFos: { value: 0.7, unit: 'g' }
          },
          cahmb: {
            value: 'N/A',
            unit: 'g'
          },
          salt: { value: 0.3, unit: 'g' }
        },
        vitamins: {
          vitaminAre: {
            unit: 'mcg',
            value: 198,
            ofWhichBCaroteneRE: {
              unit: 'mcg',
              value: 0
            }
          },
          vitaminD: {
            unit: 'mcg',
            value: 2.3
          },
          vitaminE: {
            unit: 'mg',
            value: 3.1
          },
          vitaminK: {
            title: 'Vitamin K',
            unit: 'mcg',
            value: 12
          },
          vitaminC: {
            unit: 'mg',
            value: 15
          },
          folate: {
            unit: 'mcg',
            value: 78.2
          },
          folacin: {
            unit: 'mcg',
            value: 46
          },
          thiaminVitaminB1: {
            unit: 'mg',
            value: 0.46
          },
          riboflavinVitaminB2: {
            unit: 'mg',
            value: 0.6
          },
          vitaminB6: {
            unit: 'mg',
            value: 0.3
          },
          vitaminB12: {
            title: 'Vitamin B12',
            unit: 'mcg',
            value: 0.6
          },
          niacin: {
            unit: 'mg',
            value: 3.6
          },
          panthothenicAcid: {
            title: 'Pantothenic acid',
            unit: 'mg',
            value: 0.9
          },
          biotin: {
            unit: 'mcg',
            value: 15
          }
        },
        minerals: {
          sodium: {
            unit: 'mg',
            value: 120
          },
          potassium: {
            unit: 'mg',
            value: 270
          },
          chloride: {
            unit: 'mg',
            value: 200
          },
          calcium: {
            unit: 'mg',
            value: 166
          },
          phosphate: {
            unit: 'mg',
            value: 160
          },
          iron: {
            unit: 'mg',
            value: 3.0
          },
          zinc: {
            unit: 'mg',
            value: 3.0
          },
          manganese: {
            unit: 'mg',
            value: 0.3
          },
          iodine: {
            unit: 'mcg',
            value: 30
          },
          selenium: {
            unit: 'mcg',
            value: 8.4
          },
          choline: {
            unit: 'mg',
            value: 46
          },
          molybdenum: {
            unit: 'mcg',
            value: 12
          },
          copper: {
            unit: 'mg',
            value: 0.33
          },
          magnesium: {
            unit: 'mg',
            value: 48
          },
          chromium: {
            unit: 'mcg',
            value: 7.6
          },
          taurine: {
            unit: 'mg',
            value: 22
          },
          lCarnitine: {
            unit: 'mg',
            value: 5.2
          },
          osmolality: {
            unit: 'mOsm/kg H2O',
            value: 500
          },
          osmolarity: {
            unit: 'mOsm/litre',
            value: 389
          },
          water: {
            unit: 'g/100ml',
            value: 78
          },
          renalSoluteLoad: {
            unit: 'mOsm/litre',
            value: 354
          }
        }
      },
      {
        id: 36,
        name: 'PaediaSure® Plus Fibre Chocolate',
        volume: '200 mL sip feed',
        volumeOffset: 200,
        typeofcategory: 'Bottle',
        macroNutrients: {
          energy: {
            kj: { value: 1270, unit: 'kJ' },
            kcal: { value: 304, unit: 'kcal' }
          },
          protein: { value: 8.4, unit: 'g' },
          carbohydrate: {
            value: 32.78,
            unit: 'g',
            ofWhichSugars: { value: 12, unit: 'g' }
          },
          fat: {
            value: 14.94,
            unit: 'g',
            ofWhichSaturates: { value: 14.94, unit: 'g' }
          },
          fibre: {
            value: 2.2,
            unit: 'g',
            ofWhichFos: { value: 0.7, unit: 'g' }
          },
          cahmb: {
            value: 'N/A',
            unit: 'g'
          },
          salt: { value: 0.4, unit: 'g' }
        },
        vitamins: {
          vitaminAre: {
            unit: 'mcg',
            value: 138,
            ofWhichBCaroteneRE: {
              unit: 'mcg',
              value: 0
            }
          },
          vitaminD: {
            unit: 'mcg',
            value: 2.2
          },
          vitaminE: {
            unit: 'mg',
            value: 4.2
          },
          vitaminK: {
            title: 'Vitamin K',
            unit: 'mcg',
            value: 12
          },
          vitaminC: {
            unit: 'mg',
            value: 15
          },
          folate: {
            unit: 'mcg',
            value: 78.2
          },
          folacin: {
            unit: 'mcg',
            value: 46
          },
          thiaminVitaminB1: {
            unit: 'mg',
            value: 0.38
          },
          riboflavinVitaminB2: {
            unit: 'mg',
            value: 0.6
          },
          vitaminB6: {
            unit: 'mg',
            value: 0.3
          },
          vitaminB12: {
            title: 'Vitamin B12',
            unit: 'mcg',
            value: 0.4
          },
          niacin: {
            unit: 'mg',
            value: 3.6
          },
          panthothenicAcid: {
            title: 'Pantothenic acid',
            unit: 'mg',
            value: 0.9
          },
          biotin: {
            unit: 'mcg',
            value: 15
          }
        },
        minerals: {
          sodium: {
            unit: 'mg',
            value: 160
          },
          potassium: {
            unit: 'mg',
            value: 360
          },
          chloride: {
            unit: 'mg',
            value: 200
          },
          calcium: {
            unit: 'mg',
            value: 166
          },
          phosphate: {
            unit: 'mg',
            value: 160
          },
          iron: {
            unit: 'mg',
            value: 3.0
          },
          zinc: {
            unit: 'mg',
            value: 3.0
          },
          manganese: {
            unit: 'mg',
            value: 0.3
          },
          iodine: {
            unit: 'mcg',
            value: 26
          },
          selenium: {
            unit: 'mcg',
            value: 8.4
          },
          choline: {
            unit: 'mg',
            value: 44
          },
          molybdenum: {
            unit: 'mcg',
            value: 12
          },
          copper: {
            unit: 'mg',
            value: 0.3
          },
          magnesium: {
            unit: 'mg',
            value: 48
          },
          chromium: {
            unit: 'mcg',
            value: 13
          },
          taurine: {
            unit: 'mg',
            value: 22
          },
          lCarnitine: {
            unit: 'mg',
            value: 5.2
          },
          osmolality: {
            unit: 'mOsm/kg H2O',
            value: 423
          },
          osmolarity: {
            unit: 'mOsm/litre',
            value: 543
          },
          water: {
            unit: 'g/100ml',
            value: 78
          },
          renalSoluteLoad: {
            unit: 'mOsm/litre',
            value: 374
          }
        }
      },
      {
        id: 37,
        name: 'PaediaSure® Compact',
        volume: '125 mL sip feed',
        volumeOffset: 125,
        typeofcategory: 'Bottle',
        macroNutrients: {
          energy: {
            kj: { value: 1258, unit: 'kJ' },
            kcal: { value: 301, unit: 'kcal' }
          },
          protein: { value: 8.4, unit: 'g' },
          carbohydrate: {
            value: 32.69,
            unit: 'g',
            ofWhichSugars: { value: 5.38, unit: 'g' }
          },
          fat: {
            value: 14.94,
            unit: 'g',
            ofWhichSaturates: { value: 4.13, unit: 'g' }
          },
          fibre: {
            value: 0.91,
            unit: 'g',
            ofWhichFos: { value: 0.7, unit: 'g' }
          },
          cahmb: {
            value: 'N/A',
            unit: 'g'
          },
          salt: { value: 0.34, unit: 'g' }
        },
        vitamins: {
          vitaminAre: {
            unit: 'mcg',
            value: 150,
            ofWhichBCaroteneRE: {
              unit: 'mcg',
              value: 0
            }
          },
          vitaminD: {
            unit: 'mcg',
            value: 2.5
          },
          vitaminE: {
            unit: 'mg',
            value: 4.3
          },
          vitaminK: {
            title: 'Vitamin K',
            unit: 'mcg',
            value: 12
          },
          vitaminC: {
            unit: 'mg',
            value: 19
          },
          folate: {
            unit: 'mcg',
            value: 76.5
          },
          folacin: {
            unit: 'mcg',
            value: 45
          },
          thiaminVitaminB1: {
            unit: 'mg',
            value: 0.38
          },
          riboflavinVitaminB2: {
            unit: 'mg',
            value: 0.6
          },
          vitaminB6: {
            unit: 'mg',
            value: 0.3
          },
          vitaminB12: {
            title: 'Vitamin B12',
            unit: 'mcg',
            value: 0.69
          },
          niacin: {
            unit: 'mg',
            value: 3.6
          },
          panthothenicAcid: {
            title: 'Pantothenic acid',
            unit: 'mg',
            value: 0.9
          },
          biotin: {
            unit: 'mcg',
            value: 13
          }
        },
        minerals: {
          sodium: {
            unit: 'mg',
            value: 138
          },
          potassium: {
            unit: 'mg',
            value: 325
          },
          chloride: {
            unit: 'mg',
            value: 188
          },
          calcium: {
            unit: 'mg',
            value: 175
          },
          phosphate: {
            unit: 'mg',
            value: 175
          },
          iron: {
            unit: 'mg',
            value: 2.8
          },
          zinc: {
            unit: 'mg',
            value: 3.0
          },
          manganese: {
            unit: 'mg',
            value: 0.25
          },
          iodine: {
            unit: 'mcg',
            value: 25
          },
          selenium: {
            unit: 'mcg',
            value: 9.4
          },
          choline: {
            unit: 'mg',
            value: 41
          },
          molybdenum: {
            unit: 'mcg',
            value: 13
          },
          copper: {
            unit: 'mg',
            value: 0.29
          },
          magnesium: {
            unit: 'mg',
            value: 44
          },
          chromium: {
            unit: 'mcg',
            value: 6.3
          },
          taurine: {
            unit: 'mg',
            value: 20
          },
          lCarnitine: {
            unit: 'mg',
            value: 5.1
          },
          osmolality: {
            unit: 'mOsm/kg H2O',
            value: 994
          },
          osmolarity: {
            unit: 'mOsm/litre',
            value: 643
          },
          water: {
            unit: 'g/100ml',
            value: 81.6
          },
          renalSoluteLoad: {
            unit: 'mOsm/litre',
            value: 585
          }
        }
      },
      {
        id: 38,
        name: 'PaediaSure® Plus Juce',
        volume: '200 mL sip feed',
        volumeOffset: 200,
        typeofcategory: 'Bottle',
        macroNutrients: {
          energy: {
            kj: { value: 1275, unit: 'kJ' },
            kcal: { value: 300, unit: 'kcal' }
          },
          protein: { value: 8.4, unit: 'g' },
          carbohydrate: {
            value: 66.6,
            unit: 'g',
            ofWhichSugars: { value: 20.8, unit: 'g' }
          },
          fat: {
            value: 0,
            unit: 'g',
            ofWhichSaturates: { value: 0, unit: 'g' }
          },
          fibre: {
            value: 0,
            unit: 'g',
            ofWhichFos: { value: 0, unit: 'g' }
          },
          cahmb: {
            value: 'N/A',
            unit: 'g'
          },
          salt: { value: 0.04, unit: 'g' }
        },
        vitamins: {
          vitaminAre: {
            unit: 'mcg',
            value: 198,
            ofWhichBCaroteneRE: {
              unit: 'mcg',
              value: 0
            }
          },
          vitaminD: {
            unit: 'mcg',
            value: 0.62
          },
          vitaminE: {
            unit: 'mg',
            value: 3.0
          },
          vitaminK: {
            title: 'Vitamin K',
            unit: 'mcg',
            value: 12
          },
          vitaminC: {
            unit: 'mg',
            value: 15
          },
          folate: {
            unit: 'mcg',
            value: 20.4
          },
          folacin: {
            unit: 'mcg',
            value: 12
          },
          thiaminVitaminB1: {
            unit: 'mg',
            value: 0.46
          },
          riboflavinVitaminB2: {
            unit: 'mg',
            value: 0.6
          },
          vitaminB6: {
            unit: 'mg',
            value: 0.3
          },
          vitaminB12: {
            title: 'Vitamin B12',
            unit: 'mcg',
            value: 0.8
          },
          niacin: {
            unit: 'mg',
            value: 3.6
          },
          panthothenicAcid: {
            title: 'Pantothenic acid',
            unit: 'mg',
            value: 0.5
          },
          biotin: {
            unit: 'mcg',
            value: 7.0
          }
        },
        minerals: {
          sodium: {
            unit: 'mg',
            value: 15
          },
          potassium: {
            unit: 'mg',
            value: 38
          },
          chloride: {
            unit: 'mg',
            value: 200
          },
          calcium: {
            unit: 'mg',
            value: 38
          },
          phosphate: {
            unit: 'mg',
            value: 19
          },
          iron: {
            unit: 'mg',
            value: 3.0
          },
          zinc: {
            unit: 'mg',
            value: 3.0
          },
          manganese: {
            unit: 'mg',
            value: 0.3
          },
          iodine: {
            unit: 'mcg',
            value: 17
          },
          selenium: {
            unit: 'mcg',
            value: 7.4
          },
          choline: {
            unit: 'mg',
            value: 'N/A'
          },
          molybdenum: {
            unit: 'mcg',
            value: 26
          },
          copper: {
            unit: 'mg',
            value: 0.34
          },
          magnesium: {
            unit: 'mg',
            value: 6.2
          },
          chromium: {
            unit: 'mcg',
            value: 6.4
          },
          taurine: {
            unit: 'mg',
            value: 'N/A'
          },
          lCarnitine: {
            unit: 'mg',
            value: 'N/A'
          },
          osmolality: {
            unit: 'mOsm/kg H2O',
            value: 1080
          },
          osmolarity: {
            unit: 'mOsm/litre',
            value: 821
          },
          water: {
            unit: 'g/100ml',
            value: 76.3
          },
          renalSoluteLoad: {
            unit: 'mOsm/litre',
            value: 279
          }
        }
      },
      {
        id: 39,
        name: 'PaediaSure® Peptide',
        volume: '100 mL tube feed',
        volumeOffset: 100,
        typeofcategory: 'Serving',
        macroNutrients: {
          energy: {
            kj: { value: 420, unit: 'kJ' },
            kcal: { value: 100, unit: 'kcal' }
          },
          protein: { value: 3.0, unit: 'g' },
          carbohydrate: {
            value: 13.0,
            unit: 'g',
            ofWhichSugars: { value: 2.7, unit: 'g' }
          },
          fat: {
            value: 4.0,
            unit: 'g',
            ofWhichSaturates: { value: 2.0, unit: 'g' }
          },
          fibre: {
            value: 0,
            unit: 'g',
            ofWhichFos: { value: 0, unit: 'g' }
          },
          cahmb: {
            value: 'N/A',
            unit: 'g'
          },
          salt: { value: 0.18, unit: 'g' }
        },
        vitamins: {
          vitaminAre: {
            unit: 'mcg',
            value: 60,
            ofWhichBCaroteneRE: {
              unit: 'mcg',
              value: 0
            }
          },
          vitaminD: {
            unit: 'mcg',
            value: 1.0
          },
          vitaminE: {
            unit: 'mg',
            value: 1.0
          },
          vitaminK: {
            title: 'Vitamin K',
            unit: 'mcg',
            value: 5.0
          },
          vitaminC: {
            unit: 'mg',
            value: 10
          },
          folate: {
            unit: 'mcg',
            value: 25.5
          },
          folacin: {
            unit: 'mcg',
            value: 15
          },
          thiaminVitaminB1: {
            unit: 'mg',
            value: 0.15
          },
          riboflavinVitaminB2: {
            unit: 'mg',
            value: 0.2
          },
          vitaminB6: {
            unit: 'mg',
            value: 0.12
          },
          vitaminB12: {
            title: 'Vitamin B12',
            unit: 'mcg',
            value: 0.21
          },
          niacin: {
            unit: 'mg',
            value: 1.5
          },
          panthothenicAcid: {
            title: 'Pantothenic acid',
            unit: 'mg',
            value: 0.35
          },
          biotin: {
            unit: 'mcg',
            value: 4.5
          }
        },
        minerals: {
          sodium: {
            unit: 'mg',
            value: 70
          },
          potassium: {
            unit: 'mg',
            value: 150
          },
          chloride: {
            unit: 'mg',
            value: 75
          },
          calcium: {
            unit: 'mg',
            value: 80
          },
          phosphate: {
            unit: 'mg',
            value: 65
          },
          iron: {
            unit: 'mg',
            value: 1
          },
          zinc: {
            unit: 'mg',
            value: 1.1
          },
          manganese: {
            unit: 'mg',
            value: 1.0
          },
          iodine: {
            unit: 'mcg',
            value: 9.0
          },
          selenium: {
            unit: 'mcg',
            value: 3.4
          },
          choline: {
            unit: 'mg',
            value: 15
          },
          molybdenum: {
            unit: 'mcg',
            value: 5.0
          },
          copper: {
            unit: 'mg',
            value: 0.11
          },
          magnesium: {
            unit: 'mg',
            value: 12
          },
          chromium: {
            unit: 'mcg',
            value: 2.3
          },
          taurine: {
            unit: 'mg',
            value: 7.5
          },
          lCarnitine: {
            unit: 'mg',
            value: 3.0
          },
          osmolality: {
            unit: 'mOsm/kg H2O',
            value: 320
          },
          osmolarity: {
            unit: 'mOsm/litre',
            value: 272
          },
          water: {
            unit: 'g/100ml',
            value: 85.3
          },
          renalSoluteLoad: {
            unit: 'mOsm/litre',
            value: 282
          }
        }
      },
      {
        id: 40,
        name: 'PaediaSure® Peptide',
        volume: '200 mL sip feed',
        volumeOffset: 200,
        typeofcategory: 'Bottle',
        macroNutrients: {
          energy: {
            kj: { value: 840, unit: 'kJ' },
            kcal: { value: 200, unit: 'kcal' }
          },
          protein: { value: 6.0, unit: 'g' },
          carbohydrate: {
            value: 26,
            unit: 'g',
            ofWhichSugars: { value: 5.4, unit: 'g' }
          },
          fat: {
            value: 8,
            unit: 'g',
            ofWhichSaturates: { value: 4, unit: 'g' }
          },
          fibre: {
            value: 0,
            unit: 'g',
            ofWhichFos: { value: 0, unit: 'g' }
          },
          cahmb: {
            value: 'N/A',
            unit: 'g'
          },
          salt: { value: 0.36, unit: 'g' }
        },
        vitamins: {
          vitaminAre: {
            unit: 'mcg',
            value: 120,
            ofWhichBCaroteneRE: {
              unit: 'mcg',
              value: 0
            }
          },
          vitaminD: {
            unit: 'mcg',
            value: 2.0
          },
          vitaminE: {
            unit: 'mg',
            value: 2.0
          },
          vitaminK: {
            title: 'Vitamin K',
            unit: 'mcg',
            value: 10
          },
          vitaminC: {
            unit: 'mg',
            value: 20
          },
          folate: {
            unit: 'mcg',
            value: 51
          },
          folacin: {
            unit: 'mcg',
            value: 30
          },
          thiaminVitaminB1: {
            unit: 'mg',
            value: 0.3
          },
          riboflavinVitaminB2: {
            unit: 'mg',
            value: 0.4
          },
          vitaminB6: {
            unit: 'mg',
            value: 0.24
          },
          vitaminB12: {
            title: 'Vitamin B12',
            unit: 'mcg',
            value: 0.42
          },
          niacin: {
            unit: 'mg',
            value: 3.0
          },
          panthothenicAcid: {
            title: 'Pantothenic acid',
            unit: 'mg',
            value: 0.7
          },
          biotin: {
            unit: 'mcg',
            value: 9.0
          }
        },
        minerals: {
          sodium: {
            unit: 'mg',
            value: 140
          },
          potassium: {
            unit: 'mg',
            value: 300
          },
          chloride: {
            unit: 'mg',
            value: 150
          },
          calcium: {
            unit: 'mg',
            value: 160
          },
          phosphate: {
            unit: 'mg',
            value: 130
          },
          iron: {
            unit: 'mg',
            value: 2.0
          },
          zinc: {
            unit: 'mg',
            value: 2.2
          },
          manganese: {
            unit: 'mg',
            value: 2.0
          },
          iodine: {
            unit: 'mcg',
            value: 18.0
          },
          selenium: {
            unit: 'mcg',
            value: 6.8
          },
          choline: {
            unit: 'mg',
            value: 30
          },
          molybdenum: {
            unit: 'mcg',
            value: 10.0
          },
          copper: {
            unit: 'mg',
            value: 0.22
          },
          magnesium: {
            unit: 'mg',
            value: 24
          },
          chromium: {
            unit: 'mcg',
            value: 4.6
          },
          taurine: {
            unit: 'mg',
            value: 15
          },
          lCarnitine: {
            unit: 'mg',
            value: 6.0
          },
          osmolality: {
            unit: 'mOsm/kg H2O',
            value: 320
          },
          osmolarity: {
            unit: 'mOsm/litre',
            value: 272
          },
          water: {
            unit: 'g/100ml',
            value: 85.3
          },
          renalSoluteLoad: {
            unit: 'mOsm/litre',
            value: 282
          }
        }
      }
    ]
  }
];
